var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/types/entity.ts
var TaskTypes = /* @__PURE__ */ ((TaskTypes3) => {
  TaskTypes3["Course"] = "course";
  TaskTypes3["Survey"] = "survey";
  TaskTypes3["ExternalSurvey"] = "externalSurvey";
  TaskTypes3["Experiment"] = "experiment";
  TaskTypes3["Bespoke"] = "bespoke";
  TaskTypes3["Recruit"] = "recruit";
  TaskTypes3["Game"] = "game";
  TaskTypes3["Otree"] = "otree";
  TaskTypes3["JsPsych"] = "jspsych";
  TaskTypes3["Exproom"] = "exproom";
  return TaskTypes3;
})(TaskTypes || {});
var TaskAutoWdthDrawTypes = /* @__PURE__ */ ((TaskAutoWdthDrawTypes3) => {
  TaskAutoWdthDrawTypes3[TaskAutoWdthDrawTypes3["closed"] = 0] = "closed";
  TaskAutoWdthDrawTypes3[TaskAutoWdthDrawTypes3["open"] = 1] = "open";
  return TaskAutoWdthDrawTypes3;
})(TaskAutoWdthDrawTypes || {});
var TaskTrashTypes = /* @__PURE__ */ ((TaskTrashTypes3) => {
  TaskTrashTypes3[TaskTrashTypes3["normal"] = 0] = "normal";
  TaskTrashTypes3[TaskTrashTypes3["dumped"] = 1] = "dumped";
  TaskTrashTypes3[TaskTrashTypes3["deleted"] = 2] = "deleted";
  return TaskTrashTypes3;
})(TaskTrashTypes || {});
var TaskAuditStatusTypes = /* @__PURE__ */ ((TaskAuditStatusTypes3) => {
  TaskAuditStatusTypes3[TaskAuditStatusTypes3["Waiting"] = 1] = "Waiting";
  TaskAuditStatusTypes3[TaskAuditStatusTypes3["Passed"] = 2] = "Passed";
  TaskAuditStatusTypes3[TaskAuditStatusTypes3["Rejected"] = 3] = "Rejected";
  return TaskAuditStatusTypes3;
})(TaskAuditStatusTypes || {});
var TaskMemberJoinChannelTypes = /* @__PURE__ */ ((TaskMemberJoinChannelTypes3) => {
  TaskMemberJoinChannelTypes3[TaskMemberJoinChannelTypes3["Default"] = 0] = "Default";
  TaskMemberJoinChannelTypes3[TaskMemberJoinChannelTypes3["Invite"] = 1] = "Invite";
  TaskMemberJoinChannelTypes3[TaskMemberJoinChannelTypes3["Share"] = 2] = "Share";
  TaskMemberJoinChannelTypes3[TaskMemberJoinChannelTypes3["Qrcode"] = 3] = "Qrcode";
  return TaskMemberJoinChannelTypes3;
})(TaskMemberJoinChannelTypes || {});
var TaskMemberStatusTypes = /* @__PURE__ */ ((TaskMemberStatusTypes3) => {
  TaskMemberStatusTypes3[TaskMemberStatusTypes3["Invited"] = 1] = "Invited";
  TaskMemberStatusTypes3[TaskMemberStatusTypes3["InProgress"] = 2] = "InProgress";
  TaskMemberStatusTypes3[TaskMemberStatusTypes3["Completed"] = 3] = "Completed";
  return TaskMemberStatusTypes3;
})(TaskMemberStatusTypes || {});
var TaskShareQrCodeTypes = /* @__PURE__ */ ((TaskShareQrCodeTypes3) => {
  TaskShareQrCodeTypes3[TaskShareQrCodeTypes3["default"] = 1] = "default";
  TaskShareQrCodeTypes3[TaskShareQrCodeTypes3["subscribleFirst"] = 2] = "subscribleFirst";
  return TaskShareQrCodeTypes3;
})(TaskShareQrCodeTypes || {});
var TaskPushTypes = /* @__PURE__ */ ((TaskPushTypes2) => {
  TaskPushTypes2["wechat"] = "wechat";
  TaskPushTypes2["sms"] = "sms";
  return TaskPushTypes2;
})(TaskPushTypes || {});
var UserRoleTypes = /* @__PURE__ */ ((UserRoleTypes3) => {
  UserRoleTypes3[UserRoleTypes3["student"] = 0] = "student";
  UserRoleTypes3[UserRoleTypes3["teacher"] = 1] = "teacher";
  return UserRoleTypes3;
})(UserRoleTypes || {});
var UserGenderTypes = /* @__PURE__ */ ((UserGenderTypes3) => {
  UserGenderTypes3["unknown"] = "-1";
  UserGenderTypes3["male"] = "0";
  UserGenderTypes3["female"] = "1";
  return UserGenderTypes3;
})(UserGenderTypes || {});
var UserStatusTypes = /* @__PURE__ */ ((UserStatusTypes3) => {
  UserStatusTypes3[UserStatusTypes3["normal"] = 0] = "normal";
  UserStatusTypes3[UserStatusTypes3["deleted"] = 1] = "deleted";
  UserStatusTypes3[UserStatusTypes3["notificationDisabled"] = 2] = "notificationDisabled";
  UserStatusTypes3[UserStatusTypes3["inactivated"] = 3] = "inactivated";
  return UserStatusTypes3;
})(UserStatusTypes || {});
var UserTaskRelationStatusTypes = /* @__PURE__ */ ((UserTaskRelationStatusTypes3) => {
  UserTaskRelationStatusTypes3["Owner"] = "Owner";
  UserTaskRelationStatusTypes3["Viewed"] = "Viewed";
  UserTaskRelationStatusTypes3["IsMember"] = "IsMember";
  UserTaskRelationStatusTypes3["Dislike"] = "Dislike";
  return UserTaskRelationStatusTypes3;
})(UserTaskRelationStatusTypes || {});
var UserTaskInvitationStatusTypes = /* @__PURE__ */ ((UserTaskInvitationStatusTypes3) => {
  UserTaskInvitationStatusTypes3["Pending"] = "Pending";
  UserTaskInvitationStatusTypes3["Joined"] = "Joined";
  UserTaskInvitationStatusTypes3["Rejected"] = "Rejected";
  return UserTaskInvitationStatusTypes3;
})(UserTaskInvitationStatusTypes || {});
var OrgUserPlanTypes = /* @__PURE__ */ ((OrgUserPlanTypes3) => {
  OrgUserPlanTypes3[OrgUserPlanTypes3["Free"] = 1] = "Free";
  OrgUserPlanTypes3[OrgUserPlanTypes3["Pro"] = 2] = "Pro";
  OrgUserPlanTypes3[OrgUserPlanTypes3["Org"] = 3] = "Org";
  return OrgUserPlanTypes3;
})(OrgUserPlanTypes || {});
var WxSubscribeTypes = /* @__PURE__ */ ((WxSubscribeTypes3) => {
  WxSubscribeTypes3[WxSubscribeTypes3["unSubscribed"] = 0] = "unSubscribed";
  WxSubscribeTypes3[WxSubscribeTypes3["subscribed"] = 1] = "subscribed";
  return WxSubscribeTypes3;
})(WxSubscribeTypes || {});
var UserTransListTypes = /* @__PURE__ */ ((UserTransListTypes2) => {
  UserTransListTypes2[UserTransListTypes2["all"] = 1] = "all";
  UserTransListTypes2[UserTransListTypes2["income"] = 2] = "income";
  UserTransListTypes2[UserTransListTypes2["outcome"] = 3] = "outcome";
  return UserTransListTypes2;
})(UserTransListTypes || {});
var UserActionLogTypes = /* @__PURE__ */ ((UserActionLogTypes2) => {
  UserActionLogTypes2["changeMobile"] = "changeMobile";
  return UserActionLogTypes2;
})(UserActionLogTypes || {});
var WalletOwnerTypes = /* @__PURE__ */ ((WalletOwnerTypes3) => {
  WalletOwnerTypes3["User"] = "User";
  WalletOwnerTypes3["Experiment"] = "Experiment";
  WalletOwnerTypes3["Survey"] = "Survey";
  WalletOwnerTypes3["Lesson"] = "Lesson";
  WalletOwnerTypes3["Game"] = "Game";
  WalletOwnerTypes3["OtreeSession"] = "OtreeSession";
  return WalletOwnerTypes3;
})(WalletOwnerTypes || {});
var WalletTypes = /* @__PURE__ */ ((WalletTypes3) => {
  WalletTypes3["Redpacket"] = "Redpacket";
  WalletTypes3["InviterRedpacket"] = "InviterRedpacket";
  return WalletTypes3;
})(WalletTypes || {});
var TransactionStatusTypes = /* @__PURE__ */ ((TransactionStatusTypes3) => {
  TransactionStatusTypes3[TransactionStatusTypes3["Success"] = 0] = "Success";
  TransactionStatusTypes3[TransactionStatusTypes3["ToBe"] = 1] = "ToBe";
  TransactionStatusTypes3[TransactionStatusTypes3["Cancel"] = 2] = "Cancel";
  TransactionStatusTypes3[TransactionStatusTypes3["Refund"] = 3] = "Refund";
  TransactionStatusTypes3[TransactionStatusTypes3["Fail"] = 4] = "Fail";
  TransactionStatusTypes3[TransactionStatusTypes3["Closed"] = 5] = "Closed";
  TransactionStatusTypes3[TransactionStatusTypes3["Revoked"] = 6] = "Revoked";
  TransactionStatusTypes3[TransactionStatusTypes3["UserPaying"] = 7] = "UserPaying";
  TransactionStatusTypes3[TransactionStatusTypes3["NoPay"] = 8] = "NoPay";
  TransactionStatusTypes3[TransactionStatusTypes3["PayError"] = 9] = "PayError";
  TransactionStatusTypes3[TransactionStatusTypes3["cancelable"] = 10] = "cancelable";
  return TransactionStatusTypes3;
})(TransactionStatusTypes || {});
var PayerTypes = /* @__PURE__ */ ((PayerTypes3) => {
  PayerTypes3["user"] = "User";
  PayerTypes3["wallet"] = "Wallet";
  PayerTypes3["platform"] = "Platform";
  return PayerTypes3;
})(PayerTypes || {});
var PayeeTypes = /* @__PURE__ */ ((PayeeTypes3) => {
  PayeeTypes3["user"] = "User";
  PayeeTypes3["wallet"] = "Wallet";
  PayeeTypes3["platform"] = "Platform";
  return PayeeTypes3;
})(PayeeTypes || {});
var TransactionSubjectTypes = /* @__PURE__ */ ((TransactionSubjectTypes3) => {
  TransactionSubjectTypes3[TransactionSubjectTypes3["Exception"] = -1] = "Exception";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Charge"] = 0] = "Charge";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Payout"] = 1] = "Payout";
  TransactionSubjectTypes3[TransactionSubjectTypes3["SystemBonus"] = 2] = "SystemBonus";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Recruit"] = 3] = "Recruit";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Survey"] = 4] = "Survey";
  TransactionSubjectTypes3[TransactionSubjectTypes3["ClassAttendance"] = 5] = "ClassAttendance";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Settle"] = 6] = "Settle";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Consume"] = 7] = "Consume";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Game"] = 8] = "Game";
  TransactionSubjectTypes3[TransactionSubjectTypes3["SMS"] = 9] = "SMS";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Otree"] = 13] = "Otree";
  TransactionSubjectTypes3[TransactionSubjectTypes3["BuyProgram"] = 14] = "BuyProgram";
  TransactionSubjectTypes3[TransactionSubjectTypes3["AdminPay"] = 15] = "AdminPay";
  TransactionSubjectTypes3[TransactionSubjectTypes3["BuyChatAcademic"] = 16] = "BuyChatAcademic";
  TransactionSubjectTypes3[TransactionSubjectTypes3["BuyAIToken"] = 17] = "BuyAIToken";
  TransactionSubjectTypes3[TransactionSubjectTypes3["BuyOtreeServer"] = 18] = "BuyOtreeServer";
  TransactionSubjectTypes3[TransactionSubjectTypes3["SurveyAIProcess"] = 19] = "SurveyAIProcess";
  TransactionSubjectTypes3[TransactionSubjectTypes3["JsPsych"] = 20] = "JsPsych";
  TransactionSubjectTypes3[TransactionSubjectTypes3["ExternalSurvey"] = 21] = "ExternalSurvey";
  return TransactionSubjectTypes3;
})(TransactionSubjectTypes || {});
var TransactionPaymentSourceTypes = /* @__PURE__ */ ((TransactionPaymentSourceTypes3) => {
  TransactionPaymentSourceTypes3[TransactionPaymentSourceTypes3["ThirdParty"] = 1] = "ThirdParty";
  TransactionPaymentSourceTypes3[TransactionPaymentSourceTypes3["SDK"] = 2] = "SDK";
  return TransactionPaymentSourceTypes3;
})(TransactionPaymentSourceTypes || {});
var PayConfigurationItemTypes = /* @__PURE__ */ ((PayConfigurationItemTypes2) => {
  PayConfigurationItemTypes2["RewardLimit"] = "RewardLimit";
  PayConfigurationItemTypes2["RewardedLimitPerMonth"] = "RewardedLimitPerMonth";
  PayConfigurationItemTypes2["PayoutLimitPerDay"] = "PayoutLimitPerDay";
  PayConfigurationItemTypes2["PayoutLimitPerMonth"] = "PayoutLimitPerMonth";
  PayConfigurationItemTypes2["PayoutErrorThreshold"] = "PayoutErrorThreshold";
  PayConfigurationItemTypes2["UnknownWechatStatusRetryDuration"] = "UnknownWechatStatusRetryDuration";
  return PayConfigurationItemTypes2;
})(PayConfigurationItemTypes || {});
var AdminTransactionTypes = /* @__PURE__ */ ((AdminTransactionTypes3) => {
  AdminTransactionTypes3[AdminTransactionTypes3["Income"] = 1] = "Income";
  AdminTransactionTypes3[AdminTransactionTypes3["Outcome"] = 2] = "Outcome";
  return AdminTransactionTypes3;
})(AdminTransactionTypes || {});
var AdminTransactionStatusTypes = /* @__PURE__ */ ((AdminTransactionStatusTypes3) => {
  AdminTransactionStatusTypes3[AdminTransactionStatusTypes3["IncomeTodo"] = 1] = "IncomeTodo";
  AdminTransactionStatusTypes3[AdminTransactionStatusTypes3["IncomeDoing"] = 2] = "IncomeDoing";
  AdminTransactionStatusTypes3[AdminTransactionStatusTypes3["IncomeDone"] = 3] = "IncomeDone";
  AdminTransactionStatusTypes3[AdminTransactionStatusTypes3["OutcomeTodo"] = 4] = "OutcomeTodo";
  AdminTransactionStatusTypes3[AdminTransactionStatusTypes3["OutcomeDoing"] = 5] = "OutcomeDoing";
  AdminTransactionStatusTypes3[AdminTransactionStatusTypes3["OutcomeDone"] = 6] = "OutcomeDone";
  return AdminTransactionStatusTypes3;
})(AdminTransactionStatusTypes || {});
var RecruitMemberStatusTypes = /* @__PURE__ */ ((RecruitMemberStatusTypes3) => {
  RecruitMemberStatusTypes3[RecruitMemberStatusTypes3["toVerify"] = 1] = "toVerify";
  RecruitMemberStatusTypes3[RecruitMemberStatusTypes3["toChoose"] = 2] = "toChoose";
  RecruitMemberStatusTypes3[RecruitMemberStatusTypes3["applied"] = 3] = "applied";
  RecruitMemberStatusTypes3[RecruitMemberStatusTypes3["toCheck"] = 4] = "toCheck";
  RecruitMemberStatusTypes3[RecruitMemberStatusTypes3["hasChecked"] = 5] = "hasChecked";
  return RecruitMemberStatusTypes3;
})(RecruitMemberStatusTypes || {});
var RecruitApplyFilterTypes = /* @__PURE__ */ ((RecruitApplyFilterTypes3) => {
  RecruitApplyFilterTypes3["Order"] = "Order";
  RecruitApplyFilterTypes3["Random"] = "Random";
  return RecruitApplyFilterTypes3;
})(RecruitApplyFilterTypes || {});
var RecruitMemberApplyMessageTypes = /* @__PURE__ */ ((RecruitMemberApplyMessageTypes3) => {
  RecruitMemberApplyMessageTypes3["Success"] = "Success";
  RecruitMemberApplyMessageTypes3["Failed"] = "Failed";
  return RecruitMemberApplyMessageTypes3;
})(RecruitMemberApplyMessageTypes || {});
var RecruitTimeslotStatusTypes = /* @__PURE__ */ ((RecruitTimeslotStatusTypes3) => {
  RecruitTimeslotStatusTypes3[RecruitTimeslotStatusTypes3["default"] = 1] = "default";
  RecruitTimeslotStatusTypes3[RecruitTimeslotStatusTypes3["closed"] = 2] = "closed";
  return RecruitTimeslotStatusTypes3;
})(RecruitTimeslotStatusTypes || {});
var RecruitTimeslotTypes = /* @__PURE__ */ ((RecruitTimeslotTypes3) => {
  RecruitTimeslotTypes3[RecruitTimeslotTypes3["offline"] = 1] = "offline";
  RecruitTimeslotTypes3[RecruitTimeslotTypes3["customOnline"] = 2] = "customOnline";
  RecruitTimeslotTypes3[RecruitTimeslotTypes3["taskOnline"] = 6] = "taskOnline";
  RecruitTimeslotTypes3[RecruitTimeslotTypes3["course"] = 3] = "course";
  RecruitTimeslotTypes3[RecruitTimeslotTypes3["survey"] = 4] = "survey";
  RecruitTimeslotTypes3[RecruitTimeslotTypes3["experiment"] = 5] = "experiment";
  return RecruitTimeslotTypes3;
})(RecruitTimeslotTypes || {});
var RecruitMemberCheckInTypes = /* @__PURE__ */ ((RecruitMemberCheckInTypes3) => {
  RecruitMemberCheckInTypes3[RecruitMemberCheckInTypes3["manual"] = 1] = "manual";
  RecruitMemberCheckInTypes3[RecruitMemberCheckInTypes3["scan"] = 2] = "scan";
  return RecruitMemberCheckInTypes3;
})(RecruitMemberCheckInTypes || {});
var RecruitFilterQuestionTypes = /* @__PURE__ */ ((RecruitFilterQuestionTypes3) => {
  RecruitFilterQuestionTypes3["Radio"] = "Radio";
  RecruitFilterQuestionTypes3["Checkbox"] = "Checkbox";
  return RecruitFilterQuestionTypes3;
})(RecruitFilterQuestionTypes || {});
var RecruitFilterConditionTypes = /* @__PURE__ */ ((RecruitFilterConditionTypes3) => {
  RecruitFilterConditionTypes3["Include"] = "Include";
  RecruitFilterConditionTypes3["Excluded"] = "Excluded";
  return RecruitFilterConditionTypes3;
})(RecruitFilterConditionTypes || {});
var RecruitFilterConditionAimTypes = /* @__PURE__ */ ((RecruitFilterConditionAimTypes3) => {
  RecruitFilterConditionAimTypes3["Option"] = "Option";
  return RecruitFilterConditionAimTypes3;
})(RecruitFilterConditionAimTypes || {});
var RecruitFilterSpecialQuestionKeyTypes = /* @__PURE__ */ ((RecruitFilterSpecialQuestionKeyTypes3) => {
  RecruitFilterSpecialQuestionKeyTypes3["HasJoinedTask"] = "HasJoinedTask";
  RecruitFilterSpecialQuestionKeyTypes3["JoinTask"] = "JoinTask";
  RecruitFilterSpecialQuestionKeyTypes3["MarkedTag"] = "MarkedTag";
  return RecruitFilterSpecialQuestionKeyTypes3;
})(RecruitFilterSpecialQuestionKeyTypes || {});
var CourseQuarterTypes = /* @__PURE__ */ ((CourseQuarterTypes3) => {
  CourseQuarterTypes3[CourseQuarterTypes3["spring"] = 0] = "spring";
  CourseQuarterTypes3[CourseQuarterTypes3["summer"] = 1] = "summer";
  CourseQuarterTypes3[CourseQuarterTypes3["fall"] = 2] = "fall";
  CourseQuarterTypes3[CourseQuarterTypes3["winteer"] = 3] = "winteer";
  return CourseQuarterTypes3;
})(CourseQuarterTypes || {});
var CourseDiscussStatusTypes = /* @__PURE__ */ ((CourseDiscussStatusTypes3) => {
  CourseDiscussStatusTypes3[CourseDiscussStatusTypes3["open"] = 0] = "open";
  CourseDiscussStatusTypes3[CourseDiscussStatusTypes3["close"] = 1] = "close";
  return CourseDiscussStatusTypes3;
})(CourseDiscussStatusTypes || {});
var CoursePadResourceType = /* @__PURE__ */ ((CoursePadResourceType3) => {
  CoursePadResourceType3["text"] = "text";
  CoursePadResourceType3["iframe_bili"] = "iframe_bili";
  CoursePadResourceType3["video"] = "video";
  CoursePadResourceType3["picture"] = "picture";
  CoursePadResourceType3["file_ppt"] = "file_ppt";
  return CoursePadResourceType3;
})(CoursePadResourceType || {});
var CourseMemberStatusTypes = /* @__PURE__ */ ((CourseMemberStatusTypes3) => {
  CourseMemberStatusTypes3["Invited"] = "Invited";
  CourseMemberStatusTypes3["Joined"] = "Joined";
  return CourseMemberStatusTypes3;
})(CourseMemberStatusTypes || {});
var LessonCheckInSource = /* @__PURE__ */ ((LessonCheckInSource3) => {
  LessonCheckInSource3[LessonCheckInSource3["scanQRCode"] = 0] = "scanQRCode";
  LessonCheckInSource3[LessonCheckInSource3["shake"] = 1] = "shake";
  LessonCheckInSource3[LessonCheckInSource3["rollCall"] = 2] = "rollCall";
  return LessonCheckInSource3;
})(LessonCheckInSource || {});
var SurveyModeTypes = /* @__PURE__ */ ((SurveyModeTypes3) => {
  SurveyModeTypes3[SurveyModeTypes3["singlePage"] = 1] = "singlePage";
  SurveyModeTypes3[SurveyModeTypes3["dynamic"] = 2] = "dynamic";
  SurveyModeTypes3[SurveyModeTypes3["normal"] = 3] = "normal";
  return SurveyModeTypes3;
})(SurveyModeTypes || {});
var SurveyStatusTypes = /* @__PURE__ */ ((SurveyStatusTypes3) => {
  SurveyStatusTypes3[SurveyStatusTypes3["close"] = 0] = "close";
  SurveyStatusTypes3[SurveyStatusTypes3["open"] = 1] = "open";
  return SurveyStatusTypes3;
})(SurveyStatusTypes || {});
var SurveyAnswerStatusTypes = /* @__PURE__ */ ((SurveyAnswerStatusTypes3) => {
  SurveyAnswerStatusTypes3[SurveyAnswerStatusTypes3["WaitingForApproval"] = 0] = "WaitingForApproval";
  SurveyAnswerStatusTypes3[SurveyAnswerStatusTypes3["Pending"] = 1] = "Pending";
  SurveyAnswerStatusTypes3[SurveyAnswerStatusTypes3["WorkingOn"] = 2] = "WorkingOn";
  SurveyAnswerStatusTypes3[SurveyAnswerStatusTypes3["Completed"] = 3] = "Completed";
  SurveyAnswerStatusTypes3[SurveyAnswerStatusTypes3["Awarded"] = 4] = "Awarded";
  return SurveyAnswerStatusTypes3;
})(SurveyAnswerStatusTypes || {});
var JspsychMemberStatusTypes = /* @__PURE__ */ ((JspsychMemberStatusTypes3) => {
  JspsychMemberStatusTypes3["Invited"] = "Invited";
  JspsychMemberStatusTypes3["Joined"] = "Joined";
  return JspsychMemberStatusTypes3;
})(JspsychMemberStatusTypes || {});
var ExternalSurveyMemberStatusTypes = /* @__PURE__ */ ((ExternalSurveyMemberStatusTypes3) => {
  ExternalSurveyMemberStatusTypes3["Invited"] = "Invited";
  ExternalSurveyMemberStatusTypes3["Joined"] = "Joined";
  ExternalSurveyMemberStatusTypes3["Completed"] = "Completed";
  return ExternalSurveyMemberStatusTypes3;
})(ExternalSurveyMemberStatusTypes || {});
var ExternalSurveyLinkSourceTypes = /* @__PURE__ */ ((ExternalSurveyLinkSourceTypes3) => {
  ExternalSurveyLinkSourceTypes3[ExternalSurveyLinkSourceTypes3["Unknown"] = 0] = "Unknown";
  ExternalSurveyLinkSourceTypes3[ExternalSurveyLinkSourceTypes3["WJX"] = 1] = "WJX";
  ExternalSurveyLinkSourceTypes3[ExternalSurveyLinkSourceTypes3["Qualtrics"] = 2] = "Qualtrics";
  ExternalSurveyLinkSourceTypes3[ExternalSurveyLinkSourceTypes3["TencentSurvey"] = 3] = "TencentSurvey";
  return ExternalSurveyLinkSourceTypes3;
})(ExternalSurveyLinkSourceTypes || {});
var GameHistoryDisplayTypes = /* @__PURE__ */ ((GameHistoryDisplayTypes3) => {
  GameHistoryDisplayTypes3[GameHistoryDisplayTypes3["hidden"] = 0] = "hidden";
  GameHistoryDisplayTypes3[GameHistoryDisplayTypes3["showMe"] = 1] = "showMe";
  GameHistoryDisplayTypes3[GameHistoryDisplayTypes3["showAll"] = 2] = "showAll";
  return GameHistoryDisplayTypes3;
})(GameHistoryDisplayTypes || {});
var GameStatusTypes = /* @__PURE__ */ ((GameStatusTypes3) => {
  GameStatusTypes3[GameStatusTypes3["notStart"] = 1] = "notStart";
  GameStatusTypes3[GameStatusTypes3["started"] = 2] = "started";
  GameStatusTypes3[GameStatusTypes3["paused"] = 3] = "paused";
  GameStatusTypes3[GameStatusTypes3["over"] = 4] = "over";
  GameStatusTypes3[GameStatusTypes3["closed"] = 5] = "closed";
  return GameStatusTypes3;
})(GameStatusTypes || {});
var MsgPushChannel = /* @__PURE__ */ ((MsgPushChannel3) => {
  MsgPushChannel3[MsgPushChannel3["wx"] = 0] = "wx";
  MsgPushChannel3[MsgPushChannel3["sms"] = 1] = "sms";
  return MsgPushChannel3;
})(MsgPushChannel || {});
var OfficialAccountTypes = /* @__PURE__ */ ((OfficialAccountTypes3) => {
  OfficialAccountTypes3[OfficialAccountTypes3["officialAccount"] = 0] = "officialAccount";
  OfficialAccountTypes3[OfficialAccountTypes3["weapp"] = 1] = "weapp";
  return OfficialAccountTypes3;
})(OfficialAccountTypes || {});
var TextAutoReplyMatchRuleTypes = /* @__PURE__ */ ((TextAutoReplyMatchRuleTypes3) => {
  TextAutoReplyMatchRuleTypes3[TextAutoReplyMatchRuleTypes3["Full"] = 0] = "Full";
  TextAutoReplyMatchRuleTypes3[TextAutoReplyMatchRuleTypes3["Half"] = 1] = "Half";
  return TextAutoReplyMatchRuleTypes3;
})(TextAutoReplyMatchRuleTypes || {});
var TextAutoReplyContentModeTypes = /* @__PURE__ */ ((TextAutoReplyContentModeTypes3) => {
  TextAutoReplyContentModeTypes3[TextAutoReplyContentModeTypes3["Random"] = 0] = "Random";
  TextAutoReplyContentModeTypes3[TextAutoReplyContentModeTypes3["All"] = 1] = "All";
  return TextAutoReplyContentModeTypes3;
})(TextAutoReplyContentModeTypes || {});
var SubscribeAutoReplyContentTypes = /* @__PURE__ */ ((SubscribeAutoReplyContentTypes3) => {
  SubscribeAutoReplyContentTypes3["Text"] = "text";
  SubscribeAutoReplyContentTypes3["Image"] = "image";
  return SubscribeAutoReplyContentTypes3;
})(SubscribeAutoReplyContentTypes || {});
var WxTextUnReadStatusTypes = /* @__PURE__ */ ((WxTextUnReadStatusTypes3) => {
  WxTextUnReadStatusTypes3[WxTextUnReadStatusTypes3["read"] = 0] = "read";
  WxTextUnReadStatusTypes3[WxTextUnReadStatusTypes3["unread"] = 1] = "unread";
  return WxTextUnReadStatusTypes3;
})(WxTextUnReadStatusTypes || {});
var WxTextSentTypes = /* @__PURE__ */ ((WxTextSentTypes3) => {
  WxTextSentTypes3[WxTextSentTypes3["unsent"] = 0] = "unsent";
  WxTextSentTypes3[WxTextSentTypes3["sent"] = 1] = "sent";
  return WxTextSentTypes3;
})(WxTextSentTypes || {});
var WeappAuditStatusTypes = /* @__PURE__ */ ((WeappAuditStatusTypes2) => {
  WeappAuditStatusTypes2[WeappAuditStatusTypes2["success"] = 0] = "success";
  WeappAuditStatusTypes2[WeappAuditStatusTypes2["rejected"] = 1] = "rejected";
  WeappAuditStatusTypes2[WeappAuditStatusTypes2["waitting"] = 2] = "waitting";
  WeappAuditStatusTypes2[WeappAuditStatusTypes2["reverted"] = 3] = "reverted";
  WeappAuditStatusTypes2[WeappAuditStatusTypes2["delay"] = 4] = "delay";
  return WeappAuditStatusTypes2;
})(WeappAuditStatusTypes || {});
var WeappDomainManageTypes = /* @__PURE__ */ ((WeappDomainManageTypes2) => {
  WeappDomainManageTypes2["add"] = "add";
  WeappDomainManageTypes2["delete"] = "delete";
  WeappDomainManageTypes2["set"] = "set";
  WeappDomainManageTypes2["get"] = "get";
  return WeappDomainManageTypes2;
})(WeappDomainManageTypes || {});
var WechatQRCodeSceneTypes = /* @__PURE__ */ ((WechatQRCodeSceneTypes2) => {
  WechatQRCodeSceneTypes2["taskShare"] = "0";
  WechatQRCodeSceneTypes2["login"] = "1";
  WechatQRCodeSceneTypes2["org"] = "org";
  WechatQRCodeSceneTypes2["game"] = "game";
  WechatQRCodeSceneTypes2["bind"] = "bind";
  WechatQRCodeSceneTypes2["checkin"] = "4";
  return WechatQRCodeSceneTypes2;
})(WechatQRCodeSceneTypes || {});
var WechatGroupPushMsgTypes = /* @__PURE__ */ ((WechatGroupPushMsgTypes2) => {
  WechatGroupPushMsgTypes2["news"] = "mpnews";
  WechatGroupPushMsgTypes2["text"] = "text";
  WechatGroupPushMsgTypes2["voice"] = "voice";
  WechatGroupPushMsgTypes2["music"] = "music";
  WechatGroupPushMsgTypes2["image"] = "image";
  WechatGroupPushMsgTypes2["video"] = "video";
  WechatGroupPushMsgTypes2["wxcard"] = "wxcard";
  return WechatGroupPushMsgTypes2;
})(WechatGroupPushMsgTypes || {});
var IssuePayTypes = /* @__PURE__ */ ((IssuePayTypes3) => {
  IssuePayTypes3[IssuePayTypes3["wechat"] = 0] = "wechat";
  IssuePayTypes3[IssuePayTypes3["alipay"] = 1] = "alipay";
  return IssuePayTypes3;
})(IssuePayTypes || {});
var IssueStatusTypes = /* @__PURE__ */ ((IssueStatusTypes3) => {
  IssueStatusTypes3[IssueStatusTypes3["toResolve"] = 0] = "toResolve";
  IssueStatusTypes3[IssueStatusTypes3["agreed"] = 1] = "agreed";
  IssueStatusTypes3[IssueStatusTypes3["disAgreed"] = 2] = "disAgreed";
  IssueStatusTypes3[IssueStatusTypes3["failed"] = 3] = "failed";
  return IssueStatusTypes3;
})(IssueStatusTypes || {});
var IssueTypes = /* @__PURE__ */ ((IssueTypes3) => {
  IssueTypes3[IssueTypes3["researcher"] = 0] = "researcher";
  IssueTypes3[IssueTypes3["deposit"] = 1] = "deposit";
  IssueTypes3[IssueTypes3["invoice"] = 2] = "invoice";
  IssueTypes3[IssueTypes3["joinOrg"] = 3] = "joinOrg";
  return IssueTypes3;
})(IssueTypes || {});
var IssueCreatedFromTypes = /* @__PURE__ */ ((IssueCreatedFromTypes3) => {
  IssueCreatedFromTypes3[IssueCreatedFromTypes3["Web"] = 1] = "Web";
  IssueCreatedFromTypes3[IssueCreatedFromTypes3["Weapp"] = 2] = "Weapp";
  return IssueCreatedFromTypes3;
})(IssueCreatedFromTypes || {});
var AutoPayoutStatusType = /* @__PURE__ */ ((AutoPayoutStatusType2) => {
  AutoPayoutStatusType2["initialWaiting"] = "initialWaiting";
  AutoPayoutStatusType2["started"] = "started";
  AutoPayoutStatusType2["closed"] = "closed";
  AutoPayoutStatusType2["waitingClose"] = "waitingClose";
  return AutoPayoutStatusType2;
})(AutoPayoutStatusType || {});
var PayoutResolveResponseCode = /* @__PURE__ */ ((PayoutResolveResponseCode2) => {
  PayoutResolveResponseCode2[PayoutResolveResponseCode2["Success"] = 0] = "Success";
  PayoutResolveResponseCode2[PayoutResolveResponseCode2["Failed"] = 1] = "Failed";
  PayoutResolveResponseCode2[PayoutResolveResponseCode2["InsufficientBalance"] = 2] = "InsufficientBalance";
  PayoutResolveResponseCode2[PayoutResolveResponseCode2["UserNotBindWechat"] = 3] = "UserNotBindWechat";
  PayoutResolveResponseCode2[PayoutResolveResponseCode2["Unknown"] = 4] = "Unknown";
  PayoutResolveResponseCode2[PayoutResolveResponseCode2["UserAccountNotEnough"] = 5] = "UserAccountNotEnough";
  PayoutResolveResponseCode2[PayoutResolveResponseCode2["HasResolved"] = 6] = "HasResolved";
  PayoutResolveResponseCode2[PayoutResolveResponseCode2["UnknownWechatPayStatus"] = 7] = "UnknownWechatPayStatus";
  PayoutResolveResponseCode2[PayoutResolveResponseCode2["AccountNotEnough"] = 8] = "AccountNotEnough";
  return PayoutResolveResponseCode2;
})(PayoutResolveResponseCode || {});
var UserTagVisibleTypes = /* @__PURE__ */ ((UserTagVisibleTypes3) => {
  UserTagVisibleTypes3[UserTagVisibleTypes3["myself"] = 0] = "myself";
  UserTagVisibleTypes3[UserTagVisibleTypes3["system"] = 1] = "system";
  UserTagVisibleTypes3[UserTagVisibleTypes3["all"] = 2] = "all";
  return UserTagVisibleTypes3;
})(UserTagVisibleTypes || {});
var TagAttachmentTypes = /* @__PURE__ */ ((TagAttachmentTypes3) => {
  TagAttachmentTypes3[TagAttachmentTypes3["SurveyQuestion"] = 2] = "SurveyQuestion";
  TagAttachmentTypes3[TagAttachmentTypes3["Recruit"] = 3] = "Recruit";
  TagAttachmentTypes3[TagAttachmentTypes3["RecruitTimeslot"] = 4] = "RecruitTimeslot";
  TagAttachmentTypes3[TagAttachmentTypes3["Course"] = 5] = "Course";
  return TagAttachmentTypes3;
})(TagAttachmentTypes || {});
var SSOAppTypes = /* @__PURE__ */ ((SSOAppTypes3) => {
  SSOAppTypes3["oidc"] = "oidc";
  SSOAppTypes3["saml"] = "saml";
  return SSOAppTypes3;
})(SSOAppTypes || {});
var AssistantUserStatusTypes = /* @__PURE__ */ ((AssistantUserStatusTypes3) => {
  AssistantUserStatusTypes3[AssistantUserStatusTypes3["NotRegist"] = 1] = "NotRegist";
  AssistantUserStatusTypes3[AssistantUserStatusTypes3["NotJoin"] = 2] = "NotJoin";
  AssistantUserStatusTypes3[AssistantUserStatusTypes3["Joined"] = 3] = "Joined";
  return AssistantUserStatusTypes3;
})(AssistantUserStatusTypes || {});
var AssistantUserPermissionTypes = /* @__PURE__ */ ((AssistantUserPermissionTypes4) => {
  AssistantUserPermissionTypes4["Wallet"] = "Wallet";
  AssistantUserPermissionTypes4["CreateTask"] = "CreateTask";
  AssistantUserPermissionTypes4["EditTask"] = "EditTask";
  AssistantUserPermissionTypes4["DeleteTask"] = "DeleteTask";
  return AssistantUserPermissionTypes4;
})(AssistantUserPermissionTypes || {});
var AssistantUserPermissionValues = {
  ["Wallet" /* Wallet */]: 1,
  ["CreateTask" /* CreateTask */]: 2,
  ["EditTask" /* EditTask */]: 3,
  ["DeleteTask" /* DeleteTask */]: 4
};
var OrgJoinOrderTypes = /* @__PURE__ */ ((OrgJoinOrderTypes3) => {
  OrgJoinOrderTypes3[OrgJoinOrderTypes3["subscribeFirst"] = 1] = "subscribeFirst";
  OrgJoinOrderTypes3[OrgJoinOrderTypes3["joinFirst"] = 2] = "joinFirst";
  return OrgJoinOrderTypes3;
})(OrgJoinOrderTypes || {});
var ProgramProfilePlanTypes = /* @__PURE__ */ ((ProgramProfilePlanTypes3) => {
  ProgramProfilePlanTypes3[ProgramProfilePlanTypes3["Trial"] = -1] = "Trial";
  ProgramProfilePlanTypes3[ProgramProfilePlanTypes3["Personal"] = 1] = "Personal";
  ProgramProfilePlanTypes3[ProgramProfilePlanTypes3["Pro"] = 2] = "Pro";
  ProgramProfilePlanTypes3[ProgramProfilePlanTypes3["Team"] = 3] = "Team";
  ProgramProfilePlanTypes3[ProgramProfilePlanTypes3["Org"] = 4] = "Org";
  return ProgramProfilePlanTypes3;
})(ProgramProfilePlanTypes || {});
var AssistantProfileProgramTypes = /* @__PURE__ */ ((AssistantProfileProgramTypes3) => {
  AssistantProfileProgramTypes3[AssistantProfileProgramTypes3["Normal"] = 1] = "Normal";
  AssistantProfileProgramTypes3[AssistantProfileProgramTypes3["Team"] = 2] = "Team";
  return AssistantProfileProgramTypes3;
})(AssistantProfileProgramTypes || {});
var SubjectPoolTypes = /* @__PURE__ */ ((SubjectPoolTypes3) => {
  SubjectPoolTypes3["Personal"] = "Personal";
  SubjectPoolTypes3["Team"] = "Team";
  return SubjectPoolTypes3;
})(SubjectPoolTypes || {});
var AIMessageStatus = /* @__PURE__ */ ((AIMessageStatus3) => {
  AIMessageStatus3["Waiting"] = "waiting";
  AIMessageStatus3["Received"] = "received";
  AIMessageStatus3["Completed"] = "completed";
  AIMessageStatus3["Failed"] = "failed";
  AIMessageStatus3["Aborted"] = "aborted";
  return AIMessageStatus3;
})(AIMessageStatus || {});
var AIAssistantPurpose = /* @__PURE__ */ ((AIAssistantPurpose3) => {
  AIAssistantPurpose3["Chat"] = "chat";
  AIAssistantPurpose3["Course"] = "course";
  AIAssistantPurpose3["Research"] = "research";
  return AIAssistantPurpose3;
})(AIAssistantPurpose || {});
var AIModelProviderTypes = /* @__PURE__ */ ((AIModelProviderTypes3) => {
  AIModelProviderTypes3["openai"] = "openai";
  AIModelProviderTypes3["anthropic"] = "anthropic";
  AIModelProviderTypes3["gemini"] = "gemini";
  AIModelProviderTypes3["zhipuai"] = "zhipuai";
  AIModelProviderTypes3["qwen"] = "qwen";
  AIModelProviderTypes3["deepseek"] = "deepseek";
  AIModelProviderTypes3["baidu"] = "baidu";
  return AIModelProviderTypes3;
})(AIModelProviderTypes || {});

// src/entityTypes.ts
var entityTypes_exports = {};
__export(entityTypes_exports, {
  AIAssistantPurpose: () => AIAssistantPurpose2,
  AIMessageStatus: () => AIMessageStatus2,
  AIModelProviderTypes: () => AIModelProviderTypes2,
  AdminTransactionStatusTypes: () => AdminTransactionStatusTypes2,
  AdminTransactionTypes: () => AdminTransactionTypes2,
  AssistantProfileProgramTypes: () => AssistantProfileProgramTypes2,
  AssistantUserPermissionTypes: () => AssistantUserPermissionTypes2,
  AssistantUserPermissionValues: () => AssistantUserPermissionValues2,
  AssistantUserStatusTypes: () => AssistantUserStatusTypes2,
  CourseDiscussStatusTypes: () => CourseDiscussStatusTypes2,
  CourseMemberStatusTypes: () => CourseMemberStatusTypes2,
  CoursePadResourceType: () => CoursePadResourceType2,
  CourseQuarterTypes: () => CourseQuarterTypes2,
  DEV_SIGNUP_TEMPLATE_VALUES: () => DEV_SIGNUP_TEMPLATE_VALUES,
  DevSignupTemplateTypes: () => DevSignupTemplateTypes,
  ExternalSurveyLinkSourceTypes: () => ExternalSurveyLinkSourceTypes2,
  ExternalSurveyMemberStatusTypes: () => ExternalSurveyMemberStatusTypes2,
  GameHistoryDisplayTypes: () => GameHistoryDisplayTypes2,
  GameStatusTypes: () => GameStatusTypes2,
  IssueCreatedFromTypes: () => IssueCreatedFromTypes2,
  IssuePayTypes: () => IssuePayTypes2,
  IssueStatusTypes: () => IssueStatusTypes2,
  IssueTypes: () => IssueTypes2,
  JspsychMemberStatusTypes: () => JspsychMemberStatusTypes2,
  LessonCheckInSource: () => LessonCheckInSource2,
  MsgPushChannel: () => MsgPushChannel2,
  OfficialAccountTypes: () => OfficialAccountTypes2,
  OrgJoinOrderTypes: () => OrgJoinOrderTypes2,
  OrgUserPlanTypes: () => OrgUserPlanTypes2,
  PayeeTypes: () => PayeeTypes2,
  PayerTypes: () => PayerTypes2,
  ProgramProfilePlanTypes: () => ProgramProfilePlanTypes2,
  RecruitApplyFilterTypes: () => RecruitApplyFilterTypes2,
  RecruitFilterConditionAimTypes: () => RecruitFilterConditionAimTypes2,
  RecruitFilterConditionTypes: () => RecruitFilterConditionTypes2,
  RecruitFilterQuestionTypes: () => RecruitFilterQuestionTypes2,
  RecruitFilterSpecialQuestionKeyTypes: () => RecruitFilterSpecialQuestionKeyTypes2,
  RecruitMemberApplyMessageTypes: () => RecruitMemberApplyMessageTypes2,
  RecruitMemberCheckInTypes: () => RecruitMemberCheckInTypes2,
  RecruitMemberStatusTypes: () => RecruitMemberStatusTypes2,
  RecruitTimeslotStatusTypes: () => RecruitTimeslotStatusTypes2,
  RecruitTimeslotTypes: () => RecruitTimeslotTypes2,
  SSOAppTypes: () => SSOAppTypes2,
  SubjectPoolTypes: () => SubjectPoolTypes2,
  SubscribeAutoReplyContentTypes: () => SubscribeAutoReplyContentTypes2,
  SurveyAnswerStatusTypes: () => SurveyAnswerStatusTypes2,
  SurveyModeTypes: () => SurveyModeTypes2,
  SurveyStatusTypes: () => SurveyStatusTypes2,
  TagAttachmentTypes: () => TagAttachmentTypes2,
  TaskAuditStatusTypes: () => TaskAuditStatusTypes2,
  TaskAutoWdthDrawTypes: () => TaskAutoWdthDrawTypes2,
  TaskMemberJoinChannelTypes: () => TaskMemberJoinChannelTypes2,
  TaskMemberStatusTypes: () => TaskMemberStatusTypes2,
  TaskShareQrCodeTypes: () => TaskShareQrCodeTypes2,
  TaskTrashTypes: () => TaskTrashTypes2,
  TaskTypes: () => TaskTypes2,
  TextAutoReplyContentModeTypes: () => TextAutoReplyContentModeTypes2,
  TextAutoReplyMatchRuleTypes: () => TextAutoReplyMatchRuleTypes2,
  TransactionPaymentSourceTypes: () => TransactionPaymentSourceTypes2,
  TransactionStatusTypes: () => TransactionStatusTypes2,
  TransactionSubjectTypes: () => TransactionSubjectTypes2,
  UserGenderTypes: () => UserGenderTypes2,
  UserRoleTypes: () => UserRoleTypes2,
  UserStatusTypes: () => UserStatusTypes2,
  UserTagVisibleTypes: () => UserTagVisibleTypes2,
  UserTaskInvitationStatusTypes: () => UserTaskInvitationStatusTypes2,
  UserTaskRelationStatusTypes: () => UserTaskRelationStatusTypes2,
  WalletOwnerTypes: () => WalletOwnerTypes2,
  WalletTypes: () => WalletTypes2,
  WxSubscribeTypes: () => WxSubscribeTypes2,
  WxTextSentTypes: () => WxTextSentTypes2,
  WxTextUnReadStatusTypes: () => WxTextUnReadStatusTypes2
});
var TaskTypes2 = /* @__PURE__ */ ((TaskTypes3) => {
  TaskTypes3["Course"] = "course";
  TaskTypes3["Survey"] = "survey";
  TaskTypes3["ExternalSurvey"] = "externalSurvey";
  TaskTypes3["Experiment"] = "experiment";
  TaskTypes3["Bespoke"] = "bespoke";
  TaskTypes3["Recruit"] = "recruit";
  TaskTypes3["Game"] = "game";
  TaskTypes3["Otree"] = "otree";
  TaskTypes3["JsPsych"] = "jspsych";
  TaskTypes3["Exproom"] = "exproom";
  return TaskTypes3;
})(TaskTypes2 || {});
var TaskAutoWdthDrawTypes2 = /* @__PURE__ */ ((TaskAutoWdthDrawTypes3) => {
  TaskAutoWdthDrawTypes3[TaskAutoWdthDrawTypes3["closed"] = 0] = "closed";
  TaskAutoWdthDrawTypes3[TaskAutoWdthDrawTypes3["open"] = 1] = "open";
  return TaskAutoWdthDrawTypes3;
})(TaskAutoWdthDrawTypes2 || {});
var TaskTrashTypes2 = /* @__PURE__ */ ((TaskTrashTypes3) => {
  TaskTrashTypes3[TaskTrashTypes3["normal"] = 0] = "normal";
  TaskTrashTypes3[TaskTrashTypes3["dumped"] = 1] = "dumped";
  TaskTrashTypes3[TaskTrashTypes3["deleted"] = 2] = "deleted";
  return TaskTrashTypes3;
})(TaskTrashTypes2 || {});
var TaskAuditStatusTypes2 = /* @__PURE__ */ ((TaskAuditStatusTypes3) => {
  TaskAuditStatusTypes3[TaskAuditStatusTypes3["Waiting"] = 1] = "Waiting";
  TaskAuditStatusTypes3[TaskAuditStatusTypes3["Passed"] = 2] = "Passed";
  TaskAuditStatusTypes3[TaskAuditStatusTypes3["Rejected"] = 3] = "Rejected";
  return TaskAuditStatusTypes3;
})(TaskAuditStatusTypes2 || {});
var TaskMemberJoinChannelTypes2 = /* @__PURE__ */ ((TaskMemberJoinChannelTypes3) => {
  TaskMemberJoinChannelTypes3[TaskMemberJoinChannelTypes3["Default"] = 0] = "Default";
  TaskMemberJoinChannelTypes3[TaskMemberJoinChannelTypes3["Invite"] = 1] = "Invite";
  TaskMemberJoinChannelTypes3[TaskMemberJoinChannelTypes3["Share"] = 2] = "Share";
  TaskMemberJoinChannelTypes3[TaskMemberJoinChannelTypes3["Qrcode"] = 3] = "Qrcode";
  return TaskMemberJoinChannelTypes3;
})(TaskMemberJoinChannelTypes2 || {});
var TaskMemberStatusTypes2 = /* @__PURE__ */ ((TaskMemberStatusTypes3) => {
  TaskMemberStatusTypes3[TaskMemberStatusTypes3["Invited"] = 1] = "Invited";
  TaskMemberStatusTypes3[TaskMemberStatusTypes3["InProgress"] = 2] = "InProgress";
  TaskMemberStatusTypes3[TaskMemberStatusTypes3["Completed"] = 3] = "Completed";
  return TaskMemberStatusTypes3;
})(TaskMemberStatusTypes2 || {});
var TaskShareQrCodeTypes2 = /* @__PURE__ */ ((TaskShareQrCodeTypes3) => {
  TaskShareQrCodeTypes3[TaskShareQrCodeTypes3["default"] = 1] = "default";
  TaskShareQrCodeTypes3[TaskShareQrCodeTypes3["subscribleFirst"] = 2] = "subscribleFirst";
  return TaskShareQrCodeTypes3;
})(TaskShareQrCodeTypes2 || {});
var UserTaskRelationStatusTypes2 = /* @__PURE__ */ ((UserTaskRelationStatusTypes3) => {
  UserTaskRelationStatusTypes3["Owner"] = "Owner";
  UserTaskRelationStatusTypes3["Viewed"] = "Viewed";
  UserTaskRelationStatusTypes3["IsMember"] = "IsMember";
  UserTaskRelationStatusTypes3["Dislike"] = "Dislike";
  return UserTaskRelationStatusTypes3;
})(UserTaskRelationStatusTypes2 || {});
var UserTaskInvitationStatusTypes2 = /* @__PURE__ */ ((UserTaskInvitationStatusTypes3) => {
  UserTaskInvitationStatusTypes3["Pending"] = "Pending";
  UserTaskInvitationStatusTypes3["Joined"] = "Joined";
  UserTaskInvitationStatusTypes3["Rejected"] = "Rejected";
  return UserTaskInvitationStatusTypes3;
})(UserTaskInvitationStatusTypes2 || {});
var OrgUserPlanTypes2 = /* @__PURE__ */ ((OrgUserPlanTypes3) => {
  OrgUserPlanTypes3[OrgUserPlanTypes3["Free"] = 1] = "Free";
  OrgUserPlanTypes3[OrgUserPlanTypes3["Pro"] = 2] = "Pro";
  OrgUserPlanTypes3[OrgUserPlanTypes3["Org"] = 3] = "Org";
  return OrgUserPlanTypes3;
})(OrgUserPlanTypes2 || {});
var UserRoleTypes2 = /* @__PURE__ */ ((UserRoleTypes3) => {
  UserRoleTypes3[UserRoleTypes3["student"] = 0] = "student";
  UserRoleTypes3[UserRoleTypes3["teacher"] = 1] = "teacher";
  return UserRoleTypes3;
})(UserRoleTypes2 || {});
var UserGenderTypes2 = /* @__PURE__ */ ((UserGenderTypes3) => {
  UserGenderTypes3["unknown"] = "-1";
  UserGenderTypes3["male"] = "0";
  UserGenderTypes3["female"] = "1";
  return UserGenderTypes3;
})(UserGenderTypes2 || {});
var UserStatusTypes2 = /* @__PURE__ */ ((UserStatusTypes3) => {
  UserStatusTypes3[UserStatusTypes3["normal"] = 0] = "normal";
  UserStatusTypes3[UserStatusTypes3["deleted"] = 1] = "deleted";
  UserStatusTypes3[UserStatusTypes3["notificationDisabled"] = 2] = "notificationDisabled";
  UserStatusTypes3[UserStatusTypes3["inactivated"] = 3] = "inactivated";
  return UserStatusTypes3;
})(UserStatusTypes2 || {});
var WxSubscribeTypes2 = /* @__PURE__ */ ((WxSubscribeTypes3) => {
  WxSubscribeTypes3[WxSubscribeTypes3["unSubscribed"] = 0] = "unSubscribed";
  WxSubscribeTypes3[WxSubscribeTypes3["subscribed"] = 1] = "subscribed";
  return WxSubscribeTypes3;
})(WxSubscribeTypes2 || {});
var WalletOwnerTypes2 = /* @__PURE__ */ ((WalletOwnerTypes3) => {
  WalletOwnerTypes3["User"] = "User";
  WalletOwnerTypes3["Experiment"] = "Experiment";
  WalletOwnerTypes3["Survey"] = "Survey";
  WalletOwnerTypes3["Lesson"] = "Lesson";
  WalletOwnerTypes3["Game"] = "Game";
  WalletOwnerTypes3["OtreeSession"] = "OtreeSession";
  return WalletOwnerTypes3;
})(WalletOwnerTypes2 || {});
var WalletTypes2 = /* @__PURE__ */ ((WalletTypes3) => {
  WalletTypes3["Redpacket"] = "Redpacket";
  WalletTypes3["InviterRedpacket"] = "InviterRedpacket";
  return WalletTypes3;
})(WalletTypes2 || {});
var TransactionStatusTypes2 = /* @__PURE__ */ ((TransactionStatusTypes3) => {
  TransactionStatusTypes3[TransactionStatusTypes3["Success"] = 0] = "Success";
  TransactionStatusTypes3[TransactionStatusTypes3["ToBe"] = 1] = "ToBe";
  TransactionStatusTypes3[TransactionStatusTypes3["Cancel"] = 2] = "Cancel";
  TransactionStatusTypes3[TransactionStatusTypes3["Refund"] = 3] = "Refund";
  TransactionStatusTypes3[TransactionStatusTypes3["Fail"] = 4] = "Fail";
  TransactionStatusTypes3[TransactionStatusTypes3["Closed"] = 5] = "Closed";
  TransactionStatusTypes3[TransactionStatusTypes3["Revoked"] = 6] = "Revoked";
  TransactionStatusTypes3[TransactionStatusTypes3["UserPaying"] = 7] = "UserPaying";
  TransactionStatusTypes3[TransactionStatusTypes3["NoPay"] = 8] = "NoPay";
  TransactionStatusTypes3[TransactionStatusTypes3["PayError"] = 9] = "PayError";
  TransactionStatusTypes3[TransactionStatusTypes3["cancelable"] = 10] = "cancelable";
  return TransactionStatusTypes3;
})(TransactionStatusTypes2 || {});
var PayerTypes2 = /* @__PURE__ */ ((PayerTypes3) => {
  PayerTypes3["user"] = "User";
  PayerTypes3["wallet"] = "Wallet";
  PayerTypes3["platform"] = "Platform";
  return PayerTypes3;
})(PayerTypes2 || {});
var PayeeTypes2 = /* @__PURE__ */ ((PayeeTypes3) => {
  PayeeTypes3["user"] = "User";
  PayeeTypes3["wallet"] = "Wallet";
  PayeeTypes3["platform"] = "Platform";
  return PayeeTypes3;
})(PayeeTypes2 || {});
var TransactionSubjectTypes2 = /* @__PURE__ */ ((TransactionSubjectTypes3) => {
  TransactionSubjectTypes3[TransactionSubjectTypes3["Exception"] = -1] = "Exception";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Charge"] = 0] = "Charge";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Payout"] = 1] = "Payout";
  TransactionSubjectTypes3[TransactionSubjectTypes3["SystemBonus"] = 2] = "SystemBonus";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Recruit"] = 3] = "Recruit";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Survey"] = 4] = "Survey";
  TransactionSubjectTypes3[TransactionSubjectTypes3["ClassAttendance"] = 5] = "ClassAttendance";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Settle"] = 6] = "Settle";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Consume"] = 7] = "Consume";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Game"] = 8] = "Game";
  TransactionSubjectTypes3[TransactionSubjectTypes3["SMS"] = 9] = "SMS";
  TransactionSubjectTypes3[TransactionSubjectTypes3["Otree"] = 13] = "Otree";
  TransactionSubjectTypes3[TransactionSubjectTypes3["BuyProgram"] = 14] = "BuyProgram";
  TransactionSubjectTypes3[TransactionSubjectTypes3["AdminPay"] = 15] = "AdminPay";
  TransactionSubjectTypes3[TransactionSubjectTypes3["BuyChatAcademic"] = 16] = "BuyChatAcademic";
  TransactionSubjectTypes3[TransactionSubjectTypes3["BuyAIToken"] = 17] = "BuyAIToken";
  TransactionSubjectTypes3[TransactionSubjectTypes3["BuyOtreeServer"] = 18] = "BuyOtreeServer";
  TransactionSubjectTypes3[TransactionSubjectTypes3["SurveyAIProcess"] = 19] = "SurveyAIProcess";
  TransactionSubjectTypes3[TransactionSubjectTypes3["JsPsych"] = 20] = "JsPsych";
  TransactionSubjectTypes3[TransactionSubjectTypes3["ExternalSurvey"] = 21] = "ExternalSurvey";
  return TransactionSubjectTypes3;
})(TransactionSubjectTypes2 || {});
var TransactionPaymentSourceTypes2 = /* @__PURE__ */ ((TransactionPaymentSourceTypes3) => {
  TransactionPaymentSourceTypes3[TransactionPaymentSourceTypes3["ThirdParty"] = 1] = "ThirdParty";
  TransactionPaymentSourceTypes3[TransactionPaymentSourceTypes3["SDK"] = 2] = "SDK";
  return TransactionPaymentSourceTypes3;
})(TransactionPaymentSourceTypes2 || {});
var RecruitMemberStatusTypes2 = /* @__PURE__ */ ((RecruitMemberStatusTypes3) => {
  RecruitMemberStatusTypes3[RecruitMemberStatusTypes3["toVerify"] = 1] = "toVerify";
  RecruitMemberStatusTypes3[RecruitMemberStatusTypes3["toChoose"] = 2] = "toChoose";
  RecruitMemberStatusTypes3[RecruitMemberStatusTypes3["applied"] = 3] = "applied";
  RecruitMemberStatusTypes3[RecruitMemberStatusTypes3["toCheck"] = 4] = "toCheck";
  RecruitMemberStatusTypes3[RecruitMemberStatusTypes3["hasChecked"] = 5] = "hasChecked";
  return RecruitMemberStatusTypes3;
})(RecruitMemberStatusTypes2 || {});
var RecruitApplyFilterTypes2 = /* @__PURE__ */ ((RecruitApplyFilterTypes3) => {
  RecruitApplyFilterTypes3["Order"] = "Order";
  RecruitApplyFilterTypes3["Random"] = "Random";
  return RecruitApplyFilterTypes3;
})(RecruitApplyFilterTypes2 || {});
var RecruitMemberApplyMessageTypes2 = /* @__PURE__ */ ((RecruitMemberApplyMessageTypes3) => {
  RecruitMemberApplyMessageTypes3["Success"] = "Success";
  RecruitMemberApplyMessageTypes3["Failed"] = "Failed";
  return RecruitMemberApplyMessageTypes3;
})(RecruitMemberApplyMessageTypes2 || {});
var RecruitTimeslotStatusTypes2 = /* @__PURE__ */ ((RecruitTimeslotStatusTypes3) => {
  RecruitTimeslotStatusTypes3[RecruitTimeslotStatusTypes3["default"] = 1] = "default";
  RecruitTimeslotStatusTypes3[RecruitTimeslotStatusTypes3["closed"] = 2] = "closed";
  return RecruitTimeslotStatusTypes3;
})(RecruitTimeslotStatusTypes2 || {});
var RecruitTimeslotTypes2 = /* @__PURE__ */ ((RecruitTimeslotTypes3) => {
  RecruitTimeslotTypes3[RecruitTimeslotTypes3["offline"] = 1] = "offline";
  RecruitTimeslotTypes3[RecruitTimeslotTypes3["customOnline"] = 2] = "customOnline";
  RecruitTimeslotTypes3[RecruitTimeslotTypes3["taskOnline"] = 6] = "taskOnline";
  RecruitTimeslotTypes3[RecruitTimeslotTypes3["course"] = 3] = "course";
  RecruitTimeslotTypes3[RecruitTimeslotTypes3["survey"] = 4] = "survey";
  RecruitTimeslotTypes3[RecruitTimeslotTypes3["experiment"] = 5] = "experiment";
  return RecruitTimeslotTypes3;
})(RecruitTimeslotTypes2 || {});
var RecruitMemberCheckInTypes2 = /* @__PURE__ */ ((RecruitMemberCheckInTypes3) => {
  RecruitMemberCheckInTypes3[RecruitMemberCheckInTypes3["manual"] = 1] = "manual";
  RecruitMemberCheckInTypes3[RecruitMemberCheckInTypes3["scan"] = 2] = "scan";
  return RecruitMemberCheckInTypes3;
})(RecruitMemberCheckInTypes2 || {});
var RecruitFilterQuestionTypes2 = /* @__PURE__ */ ((RecruitFilterQuestionTypes3) => {
  RecruitFilterQuestionTypes3["Radio"] = "Radio";
  RecruitFilterQuestionTypes3["Checkbox"] = "Checkbox";
  return RecruitFilterQuestionTypes3;
})(RecruitFilterQuestionTypes2 || {});
var RecruitFilterConditionTypes2 = /* @__PURE__ */ ((RecruitFilterConditionTypes3) => {
  RecruitFilterConditionTypes3["Include"] = "Include";
  RecruitFilterConditionTypes3["Excluded"] = "Excluded";
  return RecruitFilterConditionTypes3;
})(RecruitFilterConditionTypes2 || {});
var RecruitFilterConditionAimTypes2 = /* @__PURE__ */ ((RecruitFilterConditionAimTypes3) => {
  RecruitFilterConditionAimTypes3["Option"] = "Option";
  return RecruitFilterConditionAimTypes3;
})(RecruitFilterConditionAimTypes2 || {});
var RecruitFilterSpecialQuestionKeyTypes2 = /* @__PURE__ */ ((RecruitFilterSpecialQuestionKeyTypes3) => {
  RecruitFilterSpecialQuestionKeyTypes3["HasJoinedTask"] = "HasJoinedTask";
  RecruitFilterSpecialQuestionKeyTypes3["JoinTask"] = "JoinTask";
  RecruitFilterSpecialQuestionKeyTypes3["MarkedTag"] = "MarkedTag";
  return RecruitFilterSpecialQuestionKeyTypes3;
})(RecruitFilterSpecialQuestionKeyTypes2 || {});
var CourseQuarterTypes2 = /* @__PURE__ */ ((CourseQuarterTypes3) => {
  CourseQuarterTypes3[CourseQuarterTypes3["spring"] = 0] = "spring";
  CourseQuarterTypes3[CourseQuarterTypes3["summer"] = 1] = "summer";
  CourseQuarterTypes3[CourseQuarterTypes3["fall"] = 2] = "fall";
  CourseQuarterTypes3[CourseQuarterTypes3["winteer"] = 3] = "winteer";
  return CourseQuarterTypes3;
})(CourseQuarterTypes2 || {});
var CourseDiscussStatusTypes2 = /* @__PURE__ */ ((CourseDiscussStatusTypes3) => {
  CourseDiscussStatusTypes3[CourseDiscussStatusTypes3["open"] = 0] = "open";
  CourseDiscussStatusTypes3[CourseDiscussStatusTypes3["close"] = 1] = "close";
  return CourseDiscussStatusTypes3;
})(CourseDiscussStatusTypes2 || {});
var CoursePadResourceType2 = /* @__PURE__ */ ((CoursePadResourceType3) => {
  CoursePadResourceType3["text"] = "text";
  CoursePadResourceType3["iframe_bili"] = "iframe_bili";
  CoursePadResourceType3["video"] = "video";
  CoursePadResourceType3["picture"] = "picture";
  CoursePadResourceType3["file_ppt"] = "file_ppt";
  return CoursePadResourceType3;
})(CoursePadResourceType2 || {});
var MsgPushChannel2 = /* @__PURE__ */ ((MsgPushChannel3) => {
  MsgPushChannel3[MsgPushChannel3["wx"] = 0] = "wx";
  MsgPushChannel3[MsgPushChannel3["sms"] = 1] = "sms";
  return MsgPushChannel3;
})(MsgPushChannel2 || {});
var SurveyModeTypes2 = /* @__PURE__ */ ((SurveyModeTypes3) => {
  SurveyModeTypes3[SurveyModeTypes3["singlePage"] = 1] = "singlePage";
  SurveyModeTypes3[SurveyModeTypes3["dynamic"] = 2] = "dynamic";
  SurveyModeTypes3[SurveyModeTypes3["normal"] = 3] = "normal";
  return SurveyModeTypes3;
})(SurveyModeTypes2 || {});
var SurveyStatusTypes2 = /* @__PURE__ */ ((SurveyStatusTypes3) => {
  SurveyStatusTypes3[SurveyStatusTypes3["close"] = 0] = "close";
  SurveyStatusTypes3[SurveyStatusTypes3["open"] = 1] = "open";
  return SurveyStatusTypes3;
})(SurveyStatusTypes2 || {});
var SurveyAnswerStatusTypes2 = /* @__PURE__ */ ((SurveyAnswerStatusTypes3) => {
  SurveyAnswerStatusTypes3[SurveyAnswerStatusTypes3["WaitingForApproval"] = 0] = "WaitingForApproval";
  SurveyAnswerStatusTypes3[SurveyAnswerStatusTypes3["Pending"] = 1] = "Pending";
  SurveyAnswerStatusTypes3[SurveyAnswerStatusTypes3["WorkingOn"] = 2] = "WorkingOn";
  SurveyAnswerStatusTypes3[SurveyAnswerStatusTypes3["Completed"] = 3] = "Completed";
  SurveyAnswerStatusTypes3[SurveyAnswerStatusTypes3["Awarded"] = 4] = "Awarded";
  return SurveyAnswerStatusTypes3;
})(SurveyAnswerStatusTypes2 || {});
var CourseMemberStatusTypes2 = /* @__PURE__ */ ((CourseMemberStatusTypes3) => {
  CourseMemberStatusTypes3["Invited"] = "Invited";
  CourseMemberStatusTypes3["Joined"] = "Joined";
  return CourseMemberStatusTypes3;
})(CourseMemberStatusTypes2 || {});
var JspsychMemberStatusTypes2 = /* @__PURE__ */ ((JspsychMemberStatusTypes3) => {
  JspsychMemberStatusTypes3["Invited"] = "Invited";
  JspsychMemberStatusTypes3["Joined"] = "Joined";
  return JspsychMemberStatusTypes3;
})(JspsychMemberStatusTypes2 || {});
var ExternalSurveyMemberStatusTypes2 = /* @__PURE__ */ ((ExternalSurveyMemberStatusTypes3) => {
  ExternalSurveyMemberStatusTypes3["Invited"] = "Invited";
  ExternalSurveyMemberStatusTypes3["Joined"] = "Joined";
  ExternalSurveyMemberStatusTypes3["Completed"] = "Completed";
  return ExternalSurveyMemberStatusTypes3;
})(ExternalSurveyMemberStatusTypes2 || {});
var ExternalSurveyLinkSourceTypes2 = /* @__PURE__ */ ((ExternalSurveyLinkSourceTypes3) => {
  ExternalSurveyLinkSourceTypes3[ExternalSurveyLinkSourceTypes3["Unknown"] = 0] = "Unknown";
  ExternalSurveyLinkSourceTypes3[ExternalSurveyLinkSourceTypes3["WJX"] = 1] = "WJX";
  ExternalSurveyLinkSourceTypes3[ExternalSurveyLinkSourceTypes3["Qualtrics"] = 2] = "Qualtrics";
  ExternalSurveyLinkSourceTypes3[ExternalSurveyLinkSourceTypes3["TencentSurvey"] = 3] = "TencentSurvey";
  return ExternalSurveyLinkSourceTypes3;
})(ExternalSurveyLinkSourceTypes2 || {});
var LessonCheckInSource2 = /* @__PURE__ */ ((LessonCheckInSource3) => {
  LessonCheckInSource3[LessonCheckInSource3["scanQRCode"] = 0] = "scanQRCode";
  LessonCheckInSource3[LessonCheckInSource3["shake"] = 1] = "shake";
  LessonCheckInSource3[LessonCheckInSource3["rollCall"] = 2] = "rollCall";
  return LessonCheckInSource3;
})(LessonCheckInSource2 || {});
var GameHistoryDisplayTypes2 = /* @__PURE__ */ ((GameHistoryDisplayTypes3) => {
  GameHistoryDisplayTypes3[GameHistoryDisplayTypes3["hidden"] = 0] = "hidden";
  GameHistoryDisplayTypes3[GameHistoryDisplayTypes3["showMe"] = 1] = "showMe";
  GameHistoryDisplayTypes3[GameHistoryDisplayTypes3["showAll"] = 2] = "showAll";
  return GameHistoryDisplayTypes3;
})(GameHistoryDisplayTypes2 || {});
var GameStatusTypes2 = /* @__PURE__ */ ((GameStatusTypes3) => {
  GameStatusTypes3[GameStatusTypes3["notStart"] = 1] = "notStart";
  GameStatusTypes3[GameStatusTypes3["started"] = 2] = "started";
  GameStatusTypes3[GameStatusTypes3["paused"] = 3] = "paused";
  GameStatusTypes3[GameStatusTypes3["over"] = 4] = "over";
  GameStatusTypes3[GameStatusTypes3["closed"] = 5] = "closed";
  return GameStatusTypes3;
})(GameStatusTypes2 || {});
var OfficialAccountTypes2 = /* @__PURE__ */ ((OfficialAccountTypes3) => {
  OfficialAccountTypes3[OfficialAccountTypes3["officialAccount"] = 0] = "officialAccount";
  OfficialAccountTypes3[OfficialAccountTypes3["weapp"] = 1] = "weapp";
  return OfficialAccountTypes3;
})(OfficialAccountTypes2 || {});
var TextAutoReplyMatchRuleTypes2 = /* @__PURE__ */ ((TextAutoReplyMatchRuleTypes3) => {
  TextAutoReplyMatchRuleTypes3[TextAutoReplyMatchRuleTypes3["Full"] = 0] = "Full";
  TextAutoReplyMatchRuleTypes3[TextAutoReplyMatchRuleTypes3["Half"] = 1] = "Half";
  return TextAutoReplyMatchRuleTypes3;
})(TextAutoReplyMatchRuleTypes2 || {});
var TextAutoReplyContentModeTypes2 = /* @__PURE__ */ ((TextAutoReplyContentModeTypes3) => {
  TextAutoReplyContentModeTypes3[TextAutoReplyContentModeTypes3["Random"] = 0] = "Random";
  TextAutoReplyContentModeTypes3[TextAutoReplyContentModeTypes3["All"] = 1] = "All";
  return TextAutoReplyContentModeTypes3;
})(TextAutoReplyContentModeTypes2 || {});
var SubscribeAutoReplyContentTypes2 = /* @__PURE__ */ ((SubscribeAutoReplyContentTypes3) => {
  SubscribeAutoReplyContentTypes3["Text"] = "text";
  SubscribeAutoReplyContentTypes3["Image"] = "image";
  return SubscribeAutoReplyContentTypes3;
})(SubscribeAutoReplyContentTypes2 || {});
var WxTextUnReadStatusTypes2 = /* @__PURE__ */ ((WxTextUnReadStatusTypes3) => {
  WxTextUnReadStatusTypes3[WxTextUnReadStatusTypes3["read"] = 0] = "read";
  WxTextUnReadStatusTypes3[WxTextUnReadStatusTypes3["unread"] = 1] = "unread";
  return WxTextUnReadStatusTypes3;
})(WxTextUnReadStatusTypes2 || {});
var WxTextSentTypes2 = /* @__PURE__ */ ((WxTextSentTypes3) => {
  WxTextSentTypes3[WxTextSentTypes3["unsent"] = 0] = "unsent";
  WxTextSentTypes3[WxTextSentTypes3["sent"] = 1] = "sent";
  return WxTextSentTypes3;
})(WxTextSentTypes2 || {});
var IssuePayTypes2 = /* @__PURE__ */ ((IssuePayTypes3) => {
  IssuePayTypes3[IssuePayTypes3["wechat"] = 0] = "wechat";
  IssuePayTypes3[IssuePayTypes3["alipay"] = 1] = "alipay";
  return IssuePayTypes3;
})(IssuePayTypes2 || {});
var IssueStatusTypes2 = /* @__PURE__ */ ((IssueStatusTypes3) => {
  IssueStatusTypes3[IssueStatusTypes3["toResolve"] = 0] = "toResolve";
  IssueStatusTypes3[IssueStatusTypes3["agreed"] = 1] = "agreed";
  IssueStatusTypes3[IssueStatusTypes3["disAgreed"] = 2] = "disAgreed";
  IssueStatusTypes3[IssueStatusTypes3["failed"] = 3] = "failed";
  return IssueStatusTypes3;
})(IssueStatusTypes2 || {});
var IssueTypes2 = /* @__PURE__ */ ((IssueTypes3) => {
  IssueTypes3[IssueTypes3["researcher"] = 0] = "researcher";
  IssueTypes3[IssueTypes3["deposit"] = 1] = "deposit";
  IssueTypes3[IssueTypes3["invoice"] = 2] = "invoice";
  IssueTypes3[IssueTypes3["joinOrg"] = 3] = "joinOrg";
  return IssueTypes3;
})(IssueTypes2 || {});
var IssueCreatedFromTypes2 = /* @__PURE__ */ ((IssueCreatedFromTypes3) => {
  IssueCreatedFromTypes3[IssueCreatedFromTypes3["Web"] = 1] = "Web";
  IssueCreatedFromTypes3[IssueCreatedFromTypes3["Weapp"] = 2] = "Weapp";
  return IssueCreatedFromTypes3;
})(IssueCreatedFromTypes2 || {});
var UserTagVisibleTypes2 = /* @__PURE__ */ ((UserTagVisibleTypes3) => {
  UserTagVisibleTypes3[UserTagVisibleTypes3["myself"] = 0] = "myself";
  UserTagVisibleTypes3[UserTagVisibleTypes3["system"] = 1] = "system";
  UserTagVisibleTypes3[UserTagVisibleTypes3["all"] = 2] = "all";
  return UserTagVisibleTypes3;
})(UserTagVisibleTypes2 || {});
var TagAttachmentTypes2 = /* @__PURE__ */ ((TagAttachmentTypes3) => {
  TagAttachmentTypes3[TagAttachmentTypes3["SurveyQuestion"] = 2] = "SurveyQuestion";
  TagAttachmentTypes3[TagAttachmentTypes3["Recruit"] = 3] = "Recruit";
  TagAttachmentTypes3[TagAttachmentTypes3["RecruitTimeslot"] = 4] = "RecruitTimeslot";
  TagAttachmentTypes3[TagAttachmentTypes3["Course"] = 5] = "Course";
  return TagAttachmentTypes3;
})(TagAttachmentTypes2 || {});
var SSOAppTypes2 = /* @__PURE__ */ ((SSOAppTypes3) => {
  SSOAppTypes3["oidc"] = "oidc";
  SSOAppTypes3["saml"] = "saml";
  return SSOAppTypes3;
})(SSOAppTypes2 || {});
var AssistantUserStatusTypes2 = /* @__PURE__ */ ((AssistantUserStatusTypes3) => {
  AssistantUserStatusTypes3[AssistantUserStatusTypes3["NotRegist"] = 1] = "NotRegist";
  AssistantUserStatusTypes3[AssistantUserStatusTypes3["NotJoin"] = 2] = "NotJoin";
  AssistantUserStatusTypes3[AssistantUserStatusTypes3["Joined"] = 3] = "Joined";
  return AssistantUserStatusTypes3;
})(AssistantUserStatusTypes2 || {});
var AssistantUserPermissionTypes2 = /* @__PURE__ */ ((AssistantUserPermissionTypes4) => {
  AssistantUserPermissionTypes4["Wallet"] = "Wallet";
  AssistantUserPermissionTypes4["CreateTask"] = "CreateTask";
  AssistantUserPermissionTypes4["EditTask"] = "EditTask";
  AssistantUserPermissionTypes4["DeleteTask"] = "DeleteTask";
  return AssistantUserPermissionTypes4;
})(AssistantUserPermissionTypes2 || {});
var AssistantUserPermissionValues2 = {
  ["Wallet" /* Wallet */]: 1,
  ["CreateTask" /* CreateTask */]: 2,
  ["EditTask" /* EditTask */]: 3,
  ["DeleteTask" /* DeleteTask */]: 4
};
var OrgJoinOrderTypes2 = /* @__PURE__ */ ((OrgJoinOrderTypes3) => {
  OrgJoinOrderTypes3[OrgJoinOrderTypes3["subscribeFirst"] = 1] = "subscribeFirst";
  OrgJoinOrderTypes3[OrgJoinOrderTypes3["joinFirst"] = 2] = "joinFirst";
  return OrgJoinOrderTypes3;
})(OrgJoinOrderTypes2 || {});
var ProgramProfilePlanTypes2 = /* @__PURE__ */ ((ProgramProfilePlanTypes3) => {
  ProgramProfilePlanTypes3[ProgramProfilePlanTypes3["Trial"] = -1] = "Trial";
  ProgramProfilePlanTypes3[ProgramProfilePlanTypes3["Personal"] = 1] = "Personal";
  ProgramProfilePlanTypes3[ProgramProfilePlanTypes3["Pro"] = 2] = "Pro";
  ProgramProfilePlanTypes3[ProgramProfilePlanTypes3["Team"] = 3] = "Team";
  ProgramProfilePlanTypes3[ProgramProfilePlanTypes3["Org"] = 4] = "Org";
  return ProgramProfilePlanTypes3;
})(ProgramProfilePlanTypes2 || {});
var DevSignupTemplateTypes = /* @__PURE__ */ ((DevSignupTemplateTypes2) => {
  DevSignupTemplateTypes2["researcherPro"] = "researcher-pro";
  DevSignupTemplateTypes2["researcherPersonal"] = "researcher-personal";
  DevSignupTemplateTypes2["researcherNone"] = "researcher-none";
  DevSignupTemplateTypes2["student"] = "student";
  return DevSignupTemplateTypes2;
})(DevSignupTemplateTypes || {});
var DEV_SIGNUP_TEMPLATE_VALUES = Object.values(DevSignupTemplateTypes);
var AdminTransactionTypes2 = /* @__PURE__ */ ((AdminTransactionTypes3) => {
  AdminTransactionTypes3[AdminTransactionTypes3["Income"] = 1] = "Income";
  AdminTransactionTypes3[AdminTransactionTypes3["Outcome"] = 2] = "Outcome";
  return AdminTransactionTypes3;
})(AdminTransactionTypes2 || {});
var AdminTransactionStatusTypes2 = /* @__PURE__ */ ((AdminTransactionStatusTypes3) => {
  AdminTransactionStatusTypes3[AdminTransactionStatusTypes3["IncomeTodo"] = 1] = "IncomeTodo";
  AdminTransactionStatusTypes3[AdminTransactionStatusTypes3["IncomeDoing"] = 2] = "IncomeDoing";
  AdminTransactionStatusTypes3[AdminTransactionStatusTypes3["IncomeDone"] = 3] = "IncomeDone";
  AdminTransactionStatusTypes3[AdminTransactionStatusTypes3["OutcomeTodo"] = 4] = "OutcomeTodo";
  AdminTransactionStatusTypes3[AdminTransactionStatusTypes3["OutcomeDoing"] = 5] = "OutcomeDoing";
  AdminTransactionStatusTypes3[AdminTransactionStatusTypes3["OutcomeDone"] = 6] = "OutcomeDone";
  return AdminTransactionStatusTypes3;
})(AdminTransactionStatusTypes2 || {});
var SubjectPoolTypes2 = /* @__PURE__ */ ((SubjectPoolTypes3) => {
  SubjectPoolTypes3["Personal"] = "Personal";
  SubjectPoolTypes3["Team"] = "Team";
  return SubjectPoolTypes3;
})(SubjectPoolTypes2 || {});
var AssistantProfileProgramTypes2 = /* @__PURE__ */ ((AssistantProfileProgramTypes3) => {
  AssistantProfileProgramTypes3[AssistantProfileProgramTypes3["Normal"] = 1] = "Normal";
  AssistantProfileProgramTypes3[AssistantProfileProgramTypes3["Team"] = 2] = "Team";
  return AssistantProfileProgramTypes3;
})(AssistantProfileProgramTypes2 || {});
var AIMessageStatus2 = /* @__PURE__ */ ((AIMessageStatus3) => {
  AIMessageStatus3["Waiting"] = "waiting";
  AIMessageStatus3["Received"] = "received";
  AIMessageStatus3["Completed"] = "completed";
  AIMessageStatus3["Failed"] = "failed";
  AIMessageStatus3["Aborted"] = "aborted";
  return AIMessageStatus3;
})(AIMessageStatus2 || {});
var AIAssistantPurpose2 = /* @__PURE__ */ ((AIAssistantPurpose3) => {
  AIAssistantPurpose3["Chat"] = "chat";
  AIAssistantPurpose3["Course"] = "course";
  AIAssistantPurpose3["Research"] = "research";
  return AIAssistantPurpose3;
})(AIAssistantPurpose2 || {});
var AIModelProviderTypes2 = /* @__PURE__ */ ((AIModelProviderTypes3) => {
  AIModelProviderTypes3["openai"] = "openai";
  AIModelProviderTypes3["anthropic"] = "anthropic";
  AIModelProviderTypes3["gemini"] = "gemini";
  AIModelProviderTypes3["zhipuai"] = "zhipuai";
  AIModelProviderTypes3["qwen"] = "qwen";
  AIModelProviderTypes3["deepseek"] = "deepseek";
  AIModelProviderTypes3["baidu"] = "baidu";
  return AIModelProviderTypes3;
})(AIModelProviderTypes2 || {});

// src/subject-admission-profile.ts
var SubjectAdmissionEducationLevel = /* @__PURE__ */ ((SubjectAdmissionEducationLevel2) => {
  SubjectAdmissionEducationLevel2["Undergraduate"] = "undergraduate";
  SubjectAdmissionEducationLevel2["Master"] = "master";
  SubjectAdmissionEducationLevel2["Doctoral"] = "doctoral";
  SubjectAdmissionEducationLevel2["Other"] = "other";
  return SubjectAdmissionEducationLevel2;
})(SubjectAdmissionEducationLevel || {});
var SubjectAdmissionEducationLevelLabels = {
  ["undergraduate" /* Undergraduate */]: "\u672C\u79D1\u751F",
  ["master" /* Master */]: "\u7855\u58EB\u7814\u7A76\u751F",
  ["doctoral" /* Doctoral */]: "\u535A\u58EB\u7814\u7A76\u751F",
  ["other" /* Other */]: "\u5176\u4ED6"
};
var SUBJECT_ADMISSION_EDUCATION_LEVELS = Object.values(
  SubjectAdmissionEducationLevel
);
var SUBJECT_ADMISSION_EDUCATION_LEVEL_ENUM_VALUES = Object.freeze(
  Object.fromEntries(
    SUBJECT_ADMISSION_EDUCATION_LEVELS.map((educationLevel) => [
      educationLevel,
      educationLevel
    ])
  )
);
var SubjectAdmissionSuggestionField = /* @__PURE__ */ ((SubjectAdmissionSuggestionField2) => {
  SubjectAdmissionSuggestionField2["College"] = "college";
  SubjectAdmissionSuggestionField2["Major"] = "major";
  return SubjectAdmissionSuggestionField2;
})(SubjectAdmissionSuggestionField || {});
var SUBJECT_ADMISSION_GRADE_YEAR_PATTERN = /^(19|20)\d{2}$/;
function normalizeSubjectAdmissionText(value) {
  if (typeof value !== "string") return void 0;
  const normalized = value.normalize("NFKC").trim().replace(/\s+/g, " ").replace(/([\p{Script=Han}])\s+(?=[\p{Script=Han}])/gu, "$1");
  return normalized || void 0;
}
function normalizeSubjectAdmissionCategoryValue(value) {
  return normalizeSubjectAdmissionText(value);
}
function normalizeSubjectAdmissionGrade(value) {
  const normalized = normalizeSubjectAdmissionText(value);
  return normalized && SUBJECT_ADMISSION_GRADE_YEAR_PATTERN.test(normalized) ? normalized : void 0;
}
function normalizeSubjectAdmissionEducationLevel(value) {
  return typeof value === "string" && SUBJECT_ADMISSION_EDUCATION_LEVELS.includes(
    value
  ) ? value : void 0;
}
function getSubjectAdmissionEducationLevelLabel(value) {
  const normalized = normalizeSubjectAdmissionEducationLevel(value);
  return normalized ? SubjectAdmissionEducationLevelLabels[normalized] : void 0;
}
function buildSubjectAdmissionGradeOptions(currentYear = (/* @__PURE__ */ new Date()).getFullYear(), yearsBack = 20) {
  const safeYearsBack = Math.max(0, Math.min(50, Math.floor(yearsBack)));
  return Array.from(
    { length: safeYearsBack + 2 },
    (_, index) => String(currentYear + 1 - index)
  );
}
var SUBJECT_ADMISSION_REQUIRED_FIELD_LABELS = {
  name: "\u59D3\u540D",
  gender: "\u6027\u522B",
  birth: "\u51FA\u751F\u65E5\u671F",
  educationLevel: "\u57F9\u517B\u5C42\u6B21",
  college: "\u5B66\u9662",
  grade: "\u5E74\u7EA7",
  major: "\u4E13\u4E1A",
  className: "\u73ED\u7EA7",
  mobile: "\u8054\u7CFB\u7535\u8BDD",
  email: "\u90AE\u7BB1",
  stuNum: "\u5B66\u53F7"
};
function hasText(value) {
  return typeof value === "string" && value.trim().length > 0;
}
function hasBoundMobile(mobile) {
  return hasText(mobile) && !mobile.startsWith("null");
}
function normalizeSubjectAdmissionContactMobile(value) {
  if (!hasText(value)) return void 0;
  const normalized = value.trim().replace(/[\s\-()]/g, "");
  if (/(null|undefined|placeholder)/i.test(normalized)) return void 0;
  return /^\+?\d{7,20}$/.test(normalized) ? normalized : void 0;
}
function getSubjectAdmissionContactMobile(user, profile) {
  if (hasText(profile?.contactMobile)) {
    return normalizeSubjectAdmissionContactMobile(profile?.contactMobile);
  }
  return normalizeSubjectAdmissionContactMobile(user?.mobile);
}
function parseSubjectAdmissionBirthDate(value) {
  if (!(value instanceof Date) && typeof value !== "string" && typeof value !== "number") {
    return null;
  }
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}
function hasValidSubjectAdmissionBirthDate(value, now = /* @__PURE__ */ new Date()) {
  const date = parseSubjectAdmissionBirthDate(value);
  return !!date && date.getTime() <= now.getTime();
}
function calculateAgeFromBirth(value, now = /* @__PURE__ */ new Date()) {
  const birth = parseSubjectAdmissionBirthDate(value);
  if (!birth || birth.getTime() > now.getTime()) return null;
  let age = now.getFullYear() - birth.getFullYear();
  const monthDifference = now.getMonth() - birth.getMonth();
  if (monthDifference < 0 || monthDifference === 0 && now.getDate() < birth.getDate()) {
    age -= 1;
  }
  return age;
}
function buildSubjectAdmissionOnboardingState(input) {
  const consentRequired = input.enabled && !input.hasProfile;
  return {
    consentRequired,
    isOnboarding: input.enabled && (input.requested || consentRequired)
  };
}
function getMissingSubjectAdmissionFields(user, profile) {
  const missing = [];
  const studentProfile = user?.role !== 1 /* teacher */;
  if (!hasText(user?.name)) missing.push("name");
  if (user?.gender !== "0" && user?.gender !== "1") missing.push("gender");
  if (!hasValidSubjectAdmissionBirthDate(user?.birth)) missing.push("birth");
  if (studentProfile && !normalizeSubjectAdmissionEducationLevel(profile?.educationLevel)) missing.push("educationLevel");
  if (studentProfile && !normalizeSubjectAdmissionCategoryValue(profile?.college)) missing.push("college");
  if (studentProfile && !normalizeSubjectAdmissionGrade(profile?.grade)) missing.push("grade");
  if (studentProfile && !normalizeSubjectAdmissionCategoryValue(profile?.major)) missing.push("major");
  if (studentProfile && !normalizeSubjectAdmissionText(profile?.className)) missing.push("className");
  if (!getSubjectAdmissionContactMobile(user, profile)) missing.push("mobile");
  if (!hasText(user?.email)) missing.push("email");
  if (studentProfile && !hasText(user?.stuNum)) missing.push("stuNum");
  return missing;
}
function isSubjectAdmissionProfileComplete(user, profile) {
  return getMissingSubjectAdmissionFields(user, profile).length === 0;
}

// src/recruit/admissionFilter.ts
var RecruitSubjectAdmissionFilterField = /* @__PURE__ */ ((RecruitSubjectAdmissionFilterField2) => {
  RecruitSubjectAdmissionFilterField2["Gender"] = "gender";
  RecruitSubjectAdmissionFilterField2["EducationLevel"] = "educationLevel";
  RecruitSubjectAdmissionFilterField2["Grade"] = "grade";
  RecruitSubjectAdmissionFilterField2["College"] = "college";
  RecruitSubjectAdmissionFilterField2["Major"] = "major";
  return RecruitSubjectAdmissionFilterField2;
})(RecruitSubjectAdmissionFilterField || {});
var RecruitSubjectAdmissionFilterQuestionKey = /* @__PURE__ */ ((RecruitSubjectAdmissionFilterQuestionKey2) => {
  RecruitSubjectAdmissionFilterQuestionKey2["Gender"] = "SubjectAdmissionGender";
  RecruitSubjectAdmissionFilterQuestionKey2["EducationLevel"] = "SubjectAdmissionEducationLevel";
  RecruitSubjectAdmissionFilterQuestionKey2["Grade"] = "SubjectAdmissionGrade";
  RecruitSubjectAdmissionFilterQuestionKey2["College"] = "SubjectAdmissionCollege";
  RecruitSubjectAdmissionFilterQuestionKey2["Major"] = "SubjectAdmissionMajor";
  return RecruitSubjectAdmissionFilterQuestionKey2;
})(RecruitSubjectAdmissionFilterQuestionKey || {});
var RECRUIT_SUBJECT_ADMISSION_RULE_TARGET_PREFIX = "subjectAdmission.";
var RECRUIT_SUBJECT_ADMISSION_FILTER_FIELDS = [
  "gender" /* Gender */,
  "educationLevel" /* EducationLevel */,
  "grade" /* Grade */,
  "college" /* College */,
  "major" /* Major */
];
var RecruitSubjectAdmissionFilterFieldLabels = {
  ["gender" /* Gender */]: "\u6027\u522B",
  ["educationLevel" /* EducationLevel */]: "\u57F9\u517B\u5C42\u6B21",
  ["grade" /* Grade */]: "\u5E74\u7EA7",
  ["college" /* College */]: "\u5B66\u9662",
  ["major" /* Major */]: "\u4E13\u4E1A"
};
var QUESTION_KEY_TO_FIELD = {
  ["SubjectAdmissionGender" /* Gender */]: "gender" /* Gender */,
  ["SubjectAdmissionEducationLevel" /* EducationLevel */]: "educationLevel" /* EducationLevel */,
  ["SubjectAdmissionGrade" /* Grade */]: "grade" /* Grade */,
  ["SubjectAdmissionCollege" /* College */]: "college" /* College */,
  ["SubjectAdmissionMajor" /* Major */]: "major" /* Major */
};
var FIELD_TO_QUESTION_KEY = Object.fromEntries(
  Object.entries(QUESTION_KEY_TO_FIELD).map(([questionKey, field]) => [field, questionKey])
);
function isRecruitSubjectAdmissionFilterQuestionKey(value) {
  return typeof value === "string" && Object.prototype.hasOwnProperty.call(QUESTION_KEY_TO_FIELD, value);
}
function getRecruitSubjectAdmissionFilterField(questionKey) {
  return isRecruitSubjectAdmissionFilterQuestionKey(questionKey) ? QUESTION_KEY_TO_FIELD[questionKey] : void 0;
}
function getRecruitSubjectAdmissionFilterQuestionKey(field) {
  return isRecruitSubjectAdmissionFilterField(field) ? FIELD_TO_QUESTION_KEY[field] : void 0;
}
function isRecruitSubjectAdmissionFilterField(value) {
  return typeof value === "string" && RECRUIT_SUBJECT_ADMISSION_FILTER_FIELDS.includes(
    value
  );
}
function getRecruitSubjectAdmissionRuleTarget(field) {
  return `${RECRUIT_SUBJECT_ADMISSION_RULE_TARGET_PREFIX}${field}`;
}
function getRecruitSubjectAdmissionFieldFromRuleTarget(target) {
  if (typeof target !== "string" || !target.startsWith(RECRUIT_SUBJECT_ADMISSION_RULE_TARGET_PREFIX)) {
    return void 0;
  }
  const field = target.slice(RECRUIT_SUBJECT_ADMISSION_RULE_TARGET_PREFIX.length);
  return isRecruitSubjectAdmissionFilterField(field) ? field : void 0;
}
function normalizeRecruitSubjectAdmissionFilterValue(field, value) {
  const firstValue = Array.isArray(value) ? value[0] : value;
  if (field === "gender" /* Gender */) {
    return firstValue === "0" || firstValue === "1" ? firstValue : void 0;
  }
  if (field === "educationLevel" /* EducationLevel */) {
    return normalizeSubjectAdmissionEducationLevel(firstValue);
  }
  if (field === "grade" /* Grade */) {
    return normalizeSubjectAdmissionGrade(firstValue);
  }
  if (field === "college" /* College */ || field === "major" /* Major */) {
    return normalizeSubjectAdmissionCategoryValue(firstValue);
  }
  return normalizeSubjectAdmissionText(firstValue);
}

// src/recruit/filterCondition.ts
var RecruitFilterSupportedQuestionTypes = ["Radio", "CheckBox"];
var SPECIAL_QUESTION_KEYS = /* @__PURE__ */ new Set([
  "JoinTask" /* JoinTask */,
  "MarkedTag" /* MarkedTag */,
  "HasJoinedTask" /* HasJoinedTask */
]);
var SPECIAL_QUESTION_KEYS_WITHOUT_EXTERNAL_AIM = /* @__PURE__ */ new Set([
  "HasJoinedTask" /* HasJoinedTask */
]);
function isSpecialRecruitFilterQuestionKey(questionKey) {
  return !!questionKey && (SPECIAL_QUESTION_KEYS.has(questionKey) || isRecruitSubjectAdmissionFilterQuestionKey(questionKey));
}
function isRecruitFilterConditionAimRequired(questionKey) {
  return !!questionKey && !SPECIAL_QUESTION_KEYS_WITHOUT_EXTERNAL_AIM.has(questionKey);
}
function getRecruitFilterConditionDefaultAim(questionKey) {
  if (questionKey === "HasJoinedTask" /* HasJoinedTask */) {
    return "HasJoinedTask" /* HasJoinedTask */;
  }
  return void 0;
}
function normalizeRecruitFilterCondition(condition) {
  const questionKey = condition.questionKey || void 0;
  const defaultAim = getRecruitFilterConditionDefaultAim(questionKey);
  const admissionField = getRecruitSubjectAdmissionFilterField(questionKey);
  const normalizedAim = admissionField ? normalizeRecruitSubjectAdmissionFilterValue(admissionField, condition.aim) : condition.aim || defaultAim;
  return {
    ...condition,
    questionKey,
    aim: questionKey ? normalizedAim : void 0
  };
}
function normalizeRecruitFilterConditions(conditions) {
  return (conditions || []).map(normalizeRecruitFilterCondition);
}
function isCompleteRecruitFilterCondition(condition) {
  const normalized = normalizeRecruitFilterCondition(condition);
  if (normalized.type !== "Include" /* Include */ && normalized.type !== "Excluded" /* Excluded */) {
    return false;
  }
  if (!normalized.questionKey) {
    return false;
  }
  return !isRecruitFilterConditionAimRequired(normalized.questionKey) || !!normalized.aim;
}
function findRecruitFilterSurveyQuestion(survey, questionKey) {
  return survey?.pageDocs?.[0]?.elementDocs?.find((question) => question.key === questionKey);
}
function validateRecruitFilterCondition(condition, options = {}) {
  const {
    survey,
    scope = "global",
    supportedQuestionTypes = RecruitFilterSupportedQuestionTypes
  } = options;
  const normalized = normalizeRecruitFilterCondition(condition);
  if (!normalized.type) {
    return "\u8BF7\u9009\u62E9\u6761\u4EF6\u903B\u8F91\u7C7B\u578B";
  }
  if (normalized.type !== "Include" /* Include */ && normalized.type !== "Excluded" /* Excluded */) {
    return "\u6761\u4EF6\u903B\u8F91\u7C7B\u578B\u4E0D\u5B58\u5728";
  }
  if (!normalized.questionKey) {
    return "\u8BF7\u9009\u62E9\u6761\u4EF6\u7C7B\u578B";
  }
  if (isRecruitFilterConditionAimRequired(normalized.questionKey) && !normalized.aim) {
    return "\u8BF7\u9009\u62E9\u6761\u4EF6";
  }
  if (isSpecialRecruitFilterQuestionKey(normalized.questionKey)) {
    const admissionField = getRecruitSubjectAdmissionFilterField(normalized.questionKey);
    if (admissionField) {
      return scope === "timeslot" ? "\u573A\u6B21\u7B5B\u9009\u53EA\u652F\u6301\u62A5\u540D\u4FE1\u606F\u9879" : normalizeRecruitSubjectAdmissionFilterValue(admissionField, normalized.aim) ? void 0 : "\u6761\u4EF6\u9009\u9879\u4E0D\u5B58\u5728";
    }
    const defaultAim = getRecruitFilterConditionDefaultAim(normalized.questionKey);
    if (defaultAim && normalized.aim !== defaultAim) {
      return "\u6761\u4EF6\u9009\u9879\u4E0D\u5B58\u5728";
    }
    return scope === "timeslot" ? "\u573A\u6B21\u7B5B\u9009\u53EA\u652F\u6301\u62A5\u540D\u4FE1\u606F\u9879" : void 0;
  }
  if (!survey) {
    return "\u62A5\u540D\u4FE1\u606F\u9879\u672A\u5F00\u542F";
  }
  const question = findRecruitFilterSurveyQuestion(survey, normalized.questionKey);
  if (!question) {
    return "\u6761\u4EF6\u9009\u9879\u4E0D\u5B58\u5728";
  }
  if (question.type && !supportedQuestionTypes.includes(question.type)) {
    return "\u6761\u4EF6\u9009\u9879\u4E0D\u5B58\u5728";
  }
  const detailData = question.detailData;
  const questionOptions = detailData?.options || [];
  if (!questionOptions.find((option) => option.key === normalized.aim)) {
    return "\u6761\u4EF6\u9009\u9879\u4E0D\u5B58\u5728";
  }
  return void 0;
}

// src/recruit-notifications.ts
var RecruitNotificationScenario = /* @__PURE__ */ ((RecruitNotificationScenario2) => {
  RecruitNotificationScenario2["ManualBroadcast"] = "RECRUIT_MANUAL_BROADCAST";
  RecruitNotificationScenario2["ApplicationSubmitted"] = "RECRUIT_APPLICATION_SUBMITTED";
  RecruitNotificationScenario2["ApplicationReviewRequired"] = "RECRUIT_APPLICATION_REVIEW_REQUIRED";
  RecruitNotificationScenario2["ApplicationApproved"] = "RECRUIT_APPLICATION_APPROVED";
  RecruitNotificationScenario2["ApplicationRejected"] = "RECRUIT_APPLICATION_REJECTED";
  RecruitNotificationScenario2["ApplicationWithdrawn"] = "RECRUIT_APPLICATION_WITHDRAWN";
  RecruitNotificationScenario2["InvitationCreated"] = "RECRUIT_INVITATION_CREATED";
  RecruitNotificationScenario2["InvitationAccepted"] = "RECRUIT_INVITATION_ACCEPTED";
  RecruitNotificationScenario2["InvitationRejected"] = "RECRUIT_INVITATION_REJECTED";
  RecruitNotificationScenario2["TimeslotAssigned"] = "RECRUIT_TIMESLOT_ASSIGNED";
  RecruitNotificationScenario2["TimeslotChanged"] = "RECRUIT_TIMESLOT_CHANGED";
  RecruitNotificationScenario2["TimeslotCancelled"] = "RECRUIT_TIMESLOT_CANCELLED";
  RecruitNotificationScenario2["RecruitCancelled"] = "RECRUIT_CANCELLED";
  RecruitNotificationScenario2["StartReminder"] = "RECRUIT_START_REMINDER";
  RecruitNotificationScenario2["CheckinConfirmed"] = "RECRUIT_CHECKIN_CONFIRMED";
  return RecruitNotificationScenario2;
})(RecruitNotificationScenario || {});
var RECRUIT_NOTIFICATION_SCENARIOS = Object.values(
  RecruitNotificationScenario
);
var RecruitNotificationDeliveryOutcome = /* @__PURE__ */ ((RecruitNotificationDeliveryOutcome2) => {
  RecruitNotificationDeliveryOutcome2["Delivered"] = "delivered";
  RecruitNotificationDeliveryOutcome2["Skipped"] = "skipped";
  RecruitNotificationDeliveryOutcome2["Unavailable"] = "unavailable";
  RecruitNotificationDeliveryOutcome2["Unreachable"] = "unreachable";
  RecruitNotificationDeliveryOutcome2["Failed"] = "failed";
  RecruitNotificationDeliveryOutcome2["Unknown"] = "unknown";
  return RecruitNotificationDeliveryOutcome2;
})(RecruitNotificationDeliveryOutcome || {});
var NjauNotificationSubchannel = /* @__PURE__ */ ((NjauNotificationSubchannel2) => {
  NjauNotificationSubchannel2["Todo"] = "todo";
  NjauNotificationSubchannel2["Email"] = "email";
  return NjauNotificationSubchannel2;
})(NjauNotificationSubchannel || {});
var NotificationBatchStatus = /* @__PURE__ */ ((NotificationBatchStatus2) => {
  NotificationBatchStatus2["Waiting"] = "waiting";
  NotificationBatchStatus2["Sending"] = "sending";
  NotificationBatchStatus2["Partial"] = "partial";
  NotificationBatchStatus2["Completed"] = "completed";
  NotificationBatchStatus2["Cancelled"] = "cancelled";
  return NotificationBatchStatus2;
})(NotificationBatchStatus || {});
var NotificationBatchRecipientStatus = /* @__PURE__ */ ((NotificationBatchRecipientStatus2) => {
  NotificationBatchRecipientStatus2["Pending"] = "pending";
  NotificationBatchRecipientStatus2["Sending"] = "sending";
  NotificationBatchRecipientStatus2["Succeeded"] = "succeeded";
  NotificationBatchRecipientStatus2["Failed"] = "failed";
  NotificationBatchRecipientStatus2["Cancelled"] = "cancelled";
  return NotificationBatchRecipientStatus2;
})(NotificationBatchRecipientStatus || {});
var NotificationBatchAudienceType = /* @__PURE__ */ ((NotificationBatchAudienceType2) => {
  NotificationBatchAudienceType2["RecruitParticipants"] = "recruit_participants";
  NotificationBatchAudienceType2["SubjectPoolInvitations"] = "subject_pool_invitations";
  NotificationBatchAudienceType2["TeamApplicants"] = "team_applicants";
  NotificationBatchAudienceType2["AllEffectiveSubjects"] = "all_effective_subjects";
  NotificationBatchAudienceType2["SystemTags"] = "system_tags";
  NotificationBatchAudienceType2["TeamSubjects"] = "team_subjects";
  return NotificationBatchAudienceType2;
})(NotificationBatchAudienceType || {});
var NotificationBatchTrigger = /* @__PURE__ */ ((NotificationBatchTrigger2) => {
  NotificationBatchTrigger2["Manual"] = "manual";
  NotificationBatchTrigger2["RecruitCreated"] = "recruit_created";
  return NotificationBatchTrigger2;
})(NotificationBatchTrigger || {});
var RecruitStartReminderOffset = /* @__PURE__ */ ((RecruitStartReminderOffset2) => {
  RecruitStartReminderOffset2["TwoDays"] = "TWO_DAYS";
  RecruitStartReminderOffset2["OneDay"] = "ONE_DAY";
  RecruitStartReminderOffset2["HalfDay"] = "HALF_DAY";
  RecruitStartReminderOffset2["OneHour"] = "ONE_HOUR";
  RecruitStartReminderOffset2["ThirtyMinutes"] = "THIRTY_MINUTES";
  return RecruitStartReminderOffset2;
})(RecruitStartReminderOffset || {});
var RECRUIT_START_REMINDER_OFFSETS = Object.freeze([
  "TWO_DAYS" /* TwoDays */,
  "ONE_DAY" /* OneDay */,
  "HALF_DAY" /* HalfDay */,
  "ONE_HOUR" /* OneHour */,
  "THIRTY_MINUTES" /* ThirtyMinutes */
]);
var RECRUIT_START_REMINDER_OFFSET_ENUM_VALUES = Object.freeze(
  Object.fromEntries(
    RECRUIT_START_REMINDER_OFFSETS.map((offset) => [offset, offset])
  )
);
var RECRUIT_START_REMINDER_OFFSET_MILLISECONDS = Object.freeze({
  ["TWO_DAYS" /* TwoDays */]: 2 * 24 * 60 * 60 * 1e3,
  ["ONE_DAY" /* OneDay */]: 24 * 60 * 60 * 1e3,
  ["HALF_DAY" /* HalfDay */]: 12 * 60 * 60 * 1e3,
  ["ONE_HOUR" /* OneHour */]: 60 * 60 * 1e3,
  ["THIRTY_MINUTES" /* ThirtyMinutes */]: 30 * 60 * 1e3
});
function isRecruitStartReminderOffset(value) {
  return RECRUIT_START_REMINDER_OFFSETS.includes(
    value
  );
}
function normalizeRecruitStartReminderOffsets(values) {
  const selected = new Set(
    (values || []).filter(isRecruitStartReminderOffset)
  );
  return RECRUIT_START_REMINDER_OFFSETS.filter(
    (offset) => selected.has(offset)
  );
}
function resolveRecruitStartReminderOffsets(values, legacyIntervalMilliseconds) {
  if (Array.isArray(values)) {
    return normalizeRecruitStartReminderOffsets(values);
  }
  const legacyOffset = RECRUIT_START_REMINDER_OFFSETS.find(
    (offset) => RECRUIT_START_REMINDER_OFFSET_MILLISECONDS[offset] === legacyIntervalMilliseconds
  );
  return legacyOffset ? [legacyOffset] : [];
}
function normalizeRecruitNotificationProviderAttemptDetails(value) {
  if (!Array.isArray(value)) return [];
  const channels = new Set(Object.values(NjauNotificationSubchannel));
  const outcomes = new Set(Object.values(RecruitNotificationDeliveryOutcome));
  return value.flatMap((item) => {
    if (!item || typeof item !== "object") return [];
    const detail = item;
    if (!channels.has(detail.channel) || !outcomes.has(detail.outcome)) return [];
    return [{
      channel: detail.channel,
      outcome: detail.outcome,
      externalMessageId: typeof detail.externalMessageId === "string" ? detail.externalMessageId : void 0,
      error: typeof detail.error === "string" ? detail.error : void 0
    }];
  });
}
var NJAU_NOTIFICATION_SUBCHANNEL_LABELS = {
  ["todo" /* Todo */]: "\u516C\u4F17\u53F7\u5F85\u529E",
  ["email" /* Email */]: "\u5B66\u6821\u90AE\u4EF6"
};
var RECRUIT_NOTIFICATION_DELIVERY_OUTCOME_LABELS = {
  ["delivered" /* Delivered */]: "\u5DF2\u9001\u8FBE",
  ["failed" /* Failed */]: "\u5931\u8D25",
  ["unknown" /* Unknown */]: "\u7ED3\u679C\u672A\u77E5",
  ["unavailable" /* Unavailable */]: "\u6E20\u9053\u4E0D\u53EF\u7528",
  ["unreachable" /* Unreachable */]: "\u63A5\u6536\u4EBA\u4E0D\u53EF\u8FBE",
  ["skipped" /* Skipped */]: "\u5DF2\u8DF3\u8FC7"
};
function formatRecruitNotificationProviderAttemptDetails(value) {
  const details = normalizeRecruitNotificationProviderAttemptDetails(value);
  if (!details.length) return void 0;
  return details.map((detail) => {
    const label = NJAU_NOTIFICATION_SUBCHANNEL_LABELS[detail.channel];
    const outcome = RECRUIT_NOTIFICATION_DELIVERY_OUTCOME_LABELS[detail.outcome];
    return `${label}${outcome}${detail.error ? `\uFF1A${detail.error}` : ""}`;
  }).join("\uFF1B");
}

// src/recruit-discovery.ts
var RECOMMENDED_RECRUIT_TAGS = [
  "\u8BA4\u77E5\u884C\u4E3A\u5B9E\u9A8C",
  "\u6D88\u8D39\u884C\u4E3A\u8C03\u7814",
  "\u519C\u4E1A\u751F\u4EA7\u884C\u4E3A\u6A21\u62DF",
  "\u5FC3\u7406\u884C\u4E3A\u5E72\u9884\u5B9E\u9A8C",
  "\u793E\u79D1\u8C03\u7814"
];
var RECRUIT_DISCOVERY_STATUS = {
  Open: "OPEN",
  DeadlinePassed: "DEADLINE_PASSED",
  Closed: "CLOSED"
};
var RECRUIT_DISCOVERY_STATUS_VALUES = Object.values(
  RECRUIT_DISCOVERY_STATUS
);
function normalizeRecruitDiscoveryTags(values) {
  if (!Array.isArray(values)) return [];
  return [...new Set(
    values.filter((value) => typeof value === "string").map((value) => value.trim().slice(0, 50)).filter(Boolean)
  )].slice(0, 10);
}
function isRecruitDiscoveryStatus(value) {
  return RECRUIT_DISCOVERY_STATUS_VALUES.includes(value);
}
var RecruitRewardFilter = /* @__PURE__ */ ((RecruitRewardFilter2) => {
  RecruitRewardFilter2["None"] = "none";
  RecruitRewardFilter2["CashSubsidy"] = "cashSubsidy";
  RecruitRewardFilter2["AcademicCredit"] = "academicCredit";
  return RecruitRewardFilter2;
})(RecruitRewardFilter || {});
var RECRUIT_REWARD_FILTER_ENUM_VALUES = Object.freeze(
  Object.fromEntries(
    Object.values(RecruitRewardFilter).map((value) => [value, value])
  )
);
function isRecruitRewardFilter(value) {
  return Object.values(RecruitRewardFilter).includes(value);
}

// src/recruit-enrollment.ts
var RecruitEnrollmentCloseOffsetMinutes = Object.freeze({
  AtStart: 0,
  FifteenMinutes: 15,
  ThirtyMinutes: 30,
  OneHour: 60,
  ThreeHours: 180,
  TwelveHours: 720,
  OneDay: 1440
});
var RECRUIT_ENROLLMENT_CLOSE_OFFSET_MINUTES = Object.freeze(
  Object.values(RecruitEnrollmentCloseOffsetMinutes)
);
var RECRUIT_ENROLLMENT_CLOSE_OFFSET_OPTIONS = Object.freeze([
  { value: RecruitEnrollmentCloseOffsetMinutes.AtStart, label: "\u573A\u6B21\u5F00\u59CB\u65F6" },
  { value: RecruitEnrollmentCloseOffsetMinutes.FifteenMinutes, label: "\u63D0\u524D 15 \u5206\u949F" },
  { value: RecruitEnrollmentCloseOffsetMinutes.ThirtyMinutes, label: "\u63D0\u524D 30 \u5206\u949F" },
  { value: RecruitEnrollmentCloseOffsetMinutes.OneHour, label: "\u63D0\u524D 1 \u5C0F\u65F6" },
  { value: RecruitEnrollmentCloseOffsetMinutes.ThreeHours, label: "\u63D0\u524D 3 \u5C0F\u65F6" },
  { value: RecruitEnrollmentCloseOffsetMinutes.TwelveHours, label: "\u63D0\u524D 12 \u5C0F\u65F6" },
  { value: RecruitEnrollmentCloseOffsetMinutes.OneDay, label: "\u63D0\u524D 24 \u5C0F\u65F6" }
]);
function isRecruitEnrollmentCloseOffsetMinutes(value) {
  return RECRUIT_ENROLLMENT_CLOSE_OFFSET_MINUTES.includes(
    value
  );
}
function getRecruitEnrollmentDeadline(recruit, timeslot) {
  const applyRangeEnd = recruit.apply?.range?.[1];
  if (applyRangeEnd) {
    const deadline = new Date(applyRangeEnd);
    if (Number.isFinite(deadline.valueOf())) {
      return { deadline, source: "applyRange" };
    }
  }
  if (isRecruitEnrollmentCloseOffsetMinutes(
    recruit.enrollmentCloseBeforeStartMinutes
  )) {
    return {
      deadline: new Date(
        new Date(timeslot.start).valueOf() - recruit.enrollmentCloseBeforeStartMinutes * 6e4
      ),
      source: "relativeToStart"
    };
  }
  return {
    deadline: new Date(timeslot.end),
    source: "legacyEnd"
  };
}
function isRecruitEnrollmentClosed(recruit, timeslot, now = /* @__PURE__ */ new Date()) {
  return getRecruitEnrollmentDeadline(recruit, timeslot).deadline <= now;
}

// src/recruit-checkin.ts
var TimeslotCheckInDurationSeconds = Object.freeze({
  FiveMinutes: 5 * 60,
  FifteenMinutes: 15 * 60,
  ThirtyMinutes: 30 * 60,
  OneHour: 60 * 60
});
var DEFAULT_TIMESLOT_CHECK_IN_DURATION_SECONDS = TimeslotCheckInDurationSeconds.FiveMinutes;
var TIMESLOT_CHECK_IN_DURATION_SECONDS = Object.freeze(
  Object.values(TimeslotCheckInDurationSeconds)
);
var TIMESLOT_CHECK_IN_DURATION_OPTIONS = Object.freeze([
  {
    value: TimeslotCheckInDurationSeconds.FiveMinutes,
    label: "5 \u5206\u949F"
  },
  {
    value: TimeslotCheckInDurationSeconds.FifteenMinutes,
    label: "15 \u5206\u949F"
  },
  {
    value: TimeslotCheckInDurationSeconds.ThirtyMinutes,
    label: "30 \u5206\u949F"
  },
  {
    value: TimeslotCheckInDurationSeconds.OneHour,
    label: "1 \u5C0F\u65F6"
  },
  {
    value: null,
    label: "\u4E00\u76F4\u5F00\u542F"
  }
]);
function isTimeslotCheckInDurationSeconds(value) {
  return value === null || TIMESLOT_CHECK_IN_DURATION_SECONDS.includes(
    value
  );
}
function resolveTimeslotCheckInDurationSeconds(value) {
  if (value === void 0) {
    return DEFAULT_TIMESLOT_CHECK_IN_DURATION_SECONDS;
  }
  return isTimeslotCheckInDurationSeconds(value) ? value : DEFAULT_TIMESLOT_CHECK_IN_DURATION_SECONDS;
}

// src/types/resolver.ts
var UserRecruitJoinStatus = /* @__PURE__ */ ((UserRecruitJoinStatus2) => {
  UserRecruitJoinStatus2[UserRecruitJoinStatus2["noPassword"] = 1] = "noPassword";
  UserRecruitJoinStatus2[UserRecruitJoinStatus2["needPassword"] = 2] = "needPassword";
  UserRecruitJoinStatus2[UserRecruitJoinStatus2["needVerify"] = 2] = "needVerify";
  UserRecruitJoinStatus2[UserRecruitJoinStatus2["joined"] = 3] = "joined";
  UserRecruitJoinStatus2[UserRecruitJoinStatus2["closed"] = 4] = "closed";
  return UserRecruitJoinStatus2;
})(UserRecruitJoinStatus || {});
var SmsCodeTypes = /* @__PURE__ */ ((SmsCodeTypes2) => {
  SmsCodeTypes2[SmsCodeTypes2["login"] = 1] = "login";
  SmsCodeTypes2[SmsCodeTypes2["deleteAccount"] = 2] = "deleteAccount";
  SmsCodeTypes2[SmsCodeTypes2["supplementInfo"] = 3] = "supplementInfo";
  SmsCodeTypes2[SmsCodeTypes2["verifyMobile"] = 4] = "verifyMobile";
  SmsCodeTypes2[SmsCodeTypes2["verifyNewMobile"] = 5] = "verifyNewMobile";
  return SmsCodeTypes2;
})(SmsCodeTypes || {});
var SmsMsgTypes = /* @__PURE__ */ ((SmsMsgTypes2) => {
  SmsMsgTypes2[SmsMsgTypes2["invite"] = 1] = "invite";
  SmsMsgTypes2[SmsMsgTypes2["cancel"] = 2] = "cancel";
  SmsMsgTypes2[SmsMsgTypes2["announcement"] = 3] = "announcement";
  SmsMsgTypes2[SmsMsgTypes2["orgMessage"] = 4] = "orgMessage";
  SmsMsgTypes2[SmsMsgTypes2["joinSubjectPool"] = 5] = "joinSubjectPool";
  return SmsMsgTypes2;
})(SmsMsgTypes || {});
var TaskMemberFilterTypes = /* @__PURE__ */ ((TaskMemberFilterTypes2) => {
  TaskMemberFilterTypes2["Name"] = "name";
  TaskMemberFilterTypes2["Mobile"] = "mobile";
  TaskMemberFilterTypes2["Tag"] = "tag";
  TaskMemberFilterTypes2["Task"] = "task";
  return TaskMemberFilterTypes2;
})(TaskMemberFilterTypes || {});
var TaskMemberFilterLogicTypes = /* @__PURE__ */ ((TaskMemberFilterLogicTypes2) => {
  TaskMemberFilterLogicTypes2[TaskMemberFilterLogicTypes2["And"] = 1] = "And";
  TaskMemberFilterLogicTypes2[TaskMemberFilterLogicTypes2["Not"] = 2] = "Not";
  TaskMemberFilterLogicTypes2[TaskMemberFilterLogicTypes2["Or"] = 3] = "Or";
  return TaskMemberFilterLogicTypes2;
})(TaskMemberFilterLogicTypes || {});
var ListFilterLogicTypes = /* @__PURE__ */ ((ListFilterLogicTypes2) => {
  ListFilterLogicTypes2["and"] = "and";
  ListFilterLogicTypes2["or"] = "or";
  return ListFilterLogicTypes2;
})(ListFilterLogicTypes || {});
var ListSortTypes = /* @__PURE__ */ ((ListSortTypes2) => {
  ListSortTypes2["Payout"] = "payout";
  ListSortTypes2["Reward"] = "reward";
  ListSortTypes2["Recharge"] = "recharge";
  return ListSortTypes2;
})(ListSortTypes || {});
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2[ErrorCode2["Success"] = 0] = "Success";
  ErrorCode2[ErrorCode2["UnexpectedError"] = -1] = "UnexpectedError";
  ErrorCode2[ErrorCode2["ShowMsg"] = 1] = "ShowMsg";
  ErrorCode2[ErrorCode2["PlatformNotLogin"] = 2] = "PlatformNotLogin";
  ErrorCode2[ErrorCode2["BadRequest"] = 400] = "BadRequest";
  ErrorCode2[ErrorCode2["Unauthorized"] = 401] = "Unauthorized";
  ErrorCode2[ErrorCode2["Unauthorized4Subject"] = 401.1] = "Unauthorized4Subject";
  ErrorCode2[ErrorCode2["NoMobile"] = 401.2] = "NoMobile";
  ErrorCode2[ErrorCode2["isExcluded"] = 401.3] = "isExcluded";
  ErrorCode2[ErrorCode2["NoWeappWechatProfile"] = 401.4] = "NoWeappWechatProfile";
  return ErrorCode2;
})(ErrorCode || {});
var UserWechatStatusTypes = /* @__PURE__ */ ((UserWechatStatusTypes2) => {
  UserWechatStatusTypes2[UserWechatStatusTypes2["notBind"] = 1] = "notBind";
  UserWechatStatusTypes2[UserWechatStatusTypes2["notSubscribe"] = 2] = "notSubscribe";
  UserWechatStatusTypes2[UserWechatStatusTypes2["subscribed"] = 3] = "subscribed";
  return UserWechatStatusTypes2;
})(UserWechatStatusTypes || {});
var UserWechatPayStatusTypes = /* @__PURE__ */ ((UserWechatPayStatusTypes2) => {
  UserWechatPayStatusTypes2[UserWechatPayStatusTypes2["notBind"] = 1] = "notBind";
  UserWechatPayStatusTypes2[UserWechatPayStatusTypes2["bind"] = 2] = "bind";
  return UserWechatPayStatusTypes2;
})(UserWechatPayStatusTypes || {});
var PushMessageMethodTypes = /* @__PURE__ */ ((PushMessageMethodTypes2) => {
  PushMessageMethodTypes2["wechat"] = "wechat";
  PushMessageMethodTypes2["sms"] = "sms";
  PushMessageMethodTypes2["email"] = "email";
  PushMessageMethodTypes2["njauCommunicationPlatform"] = "njauCommunicationPlatform";
  return PushMessageMethodTypes2;
})(PushMessageMethodTypes || {});
var PushMessageTypes = /* @__PURE__ */ ((PushMessageTypes2) => {
  PushMessageTypes2["system"] = "system";
  PushMessageTypes2["invite"] = "invite";
  PushMessageTypes2["award"] = "award";
  PushMessageTypes2["cancel"] = "cancel";
  PushMessageTypes2["announcement"] = "announcement";
  PushMessageTypes2["orgMessage"] = "orgMessage";
  PushMessageTypes2["joinSubjectPool"] = "joinSubjectPool";
  PushMessageTypes2["recruit"] = "recruit";
  return PushMessageTypes2;
})(PushMessageTypes || {});

// src/types/errorCode.ts
var PlatformErrorCode = {
  auth_not_researcher: "auth_not_researcher",
  auth_not_login: "auth_not_login",
  auth_no_mobile: "auth_no_mobile",
  feature_disabled: "FEATURE_DISABLED",
  // 招募错误码
  recruit_not_owner: "recruit_not_owner",
  recruit_not_found: "recruit_not_found",
  recruit_is_closed: "recruit_is_closed",
  recruit_not_joined: "recruit_not_joined",
  recruit_is_joined: "recruit_is_joined",
  recruit_timeslot_not_found: "recruit_timeslot_not_found",
  recruit_timeslot_is_closed: "recruit_timeslot_is_closed",
  recruit_timeslot_enrollment_closed: "recruit_timeslot_enrollment_closed",
  recruit_timeslot_is_over: "recruit_timeslot_is_over",
  recruit_timeslot_not_owner: "recruit_timeslot_not_owner",
  recruit_timeslot_is_joined: "recruit_timeslot_is_joined",
  recruit_timeslot_not_joined: "recruit_timeslot_not_joined",
  recruit_timeslot_joined_other: "recruit_timeslot_joined_other",
  recruit_timeslot_over_quit_time: "recruit_timeslot_over_quit_time",
  recruit_timeslot_member_is_full: "recruit_timeslot_member_is_full",
  recruit_timeslot_member_joined_over_max: "recruit_timeslot_member_joined_over_max",
  recruit_join_error_password: "recruit_join_error_password",
  recruit_join_self_created: "recruit_join_self_created",
  recruit_quit_not_allowed: "recruit_quit_not_allowed",
  // 课程错误码
  course_not_owner: "course_not_owner",
  course_not_found: "course_not_found",
  course_is_closed: "course_is_closed",
  course_not_joined: "course_not_joined",
  course_is_joined: "course_is_joined",
  course_join_self_created: "course_join_self_created",
  course_lesson_not_found: "course_lesson_not_found",
  course_discuss_max_time: "course_discuss_max_time",
  // jspsych错误码
  jspsych_is_joined: "jspsych_is_joined",
  jspsych_not_found: "jspsych_not_found",
  jspsych_is_closed: "jspsych_is_closed",
  // survey & external_survey错误码
  survey_is_joined: "survey_is_joined",
  survey_not_found: "survey_not_found",
  survey_is_closed: "survey_is_closed",
  survey_link_is_nomatch: "survey_link_is_nomatch"
};

// src/types/sdk.ts
var ResponseCodeTypes = /* @__PURE__ */ ((ResponseCodeTypes2) => {
  ResponseCodeTypes2["Success"] = "Success";
  ResponseCodeTypes2["Fail"] = "Fail";
  ResponseCodeTypes2["MultipleError"] = "MultipleError";
  ResponseCodeTypes2["UnknownError"] = "UnknownError";
  ResponseCodeTypes2["NetworkError"] = "NetworkError";
  ResponseCodeTypes2["InvalidRequest"] = "InvalidRequest";
  ResponseCodeTypes2["InvalidResponse"] = "InvalidResponse";
  ResponseCodeTypes2["UpdateVersionNotMatch"] = "UpdateVersionNotMatch";
  ResponseCodeTypes2["EventRecieveError"] = "EventRecieveError";
  ResponseCodeTypes2["NotLogin"] = "NotLogin";
  return ResponseCodeTypes2;
})(ResponseCodeTypes || {});
var PlatformEvents;
((PlatformEvents2) => {
  let EventTypes;
  ((EventTypes2) => {
    EventTypes2["logout"] = "logout";
    EventTypes2["payback"] = "payback";
    EventTypes2["payV2Back"] = "payV2Back";
    EventTypes2["afterCheckIn"] = "afterCheckIn";
    EventTypes2["addMembersToTask"] = "addMembersToTask";
  })(EventTypes = PlatformEvents2.EventTypes || (PlatformEvents2.EventTypes = {}));
})(PlatformEvents || (PlatformEvents = {}));

// src/const/index.ts
var const_exports = {};
__export(const_exports, {
  CourseDiscussLimit: () => CourseDiscussLimit,
  RecruitMemberUniKeyPlaceholder: () => RecruitMemberUniKeyPlaceholder,
  SmsMsgTypeMap: () => SmsMsgTypeMap,
  TaskTypeLabel: () => TaskTypeLabel,
  TransactionSubjectTypesToLabel: () => TransactionSubjectTypesToLabel,
  UserGenderTypesToLabel: () => UserGenderTypesToLabel
});
var CourseDiscussLimit = 3;
var RecruitMemberUniKeyPlaceholder = "__uniKey__";
var TaskTypeLabel = {
  ["course" /* Course */]: "\u8BFE\u5802",
  ["survey" /* Survey */]: "\u95EE\u5377",
  ["recruit" /* Recruit */]: "\u62DB\u52DF",
  ["game" /* Game */]: "\u5B9E\u9A8C",
  ["otree" /* Otree */]: "Otree"
};
var UserGenderTypesToLabel = {
  ["1" /* female */]: "\u5973",
  ["0" /* male */]: "\u7537",
  ["-1" /* unknown */]: "\u672A\u77E5"
};
var SmsMsgTypeMap = {
  [1 /* invite */]: "invite" /* invite */,
  [2 /* cancel */]: "cancel" /* cancel */,
  [3 /* announcement */]: "announcement" /* announcement */,
  [4 /* orgMessage */]: "orgMessage" /* orgMessage */,
  [5 /* joinSubjectPool */]: "joinSubjectPool" /* joinSubjectPool */
};
var TransactionSubjectTypesToLabel = {
  [0 /* Charge */]: "\u5145\u503C",
  [1 /* Payout */]: "\u63D0\u73B0",
  [2 /* SystemBonus */]: "\u7CFB\u7EDF\u64CD\u4F5C",
  [3 /* Recruit */]: "\u62DB\u52DF\u6536\u652F",
  [4 /* Survey */]: "\u95EE\u5377\u6536\u652F",
  [5 /* ClassAttendance */]: "\u8BFE\u6B21\u6536\u652F",
  [6 /* Settle */]: "\u6E05\u7406\u9884\u7B97",
  [7 /* Consume */]: "\u5145\u503C\u6263\u8D39",
  [8 /* Game */]: "\u5B9E\u9A8C\u6536\u652F",
  [9 /* SMS */]: "\u77ED\u4FE1",
  [13 /* Otree */]: "Otree\u5B9E\u9A8C\u6536\u652F",
  [14 /* BuyProgram */]: "\u8D2D\u4E70\u5957\u9910",
  [15 /* AdminPay */]: "\u7BA1\u7406\u5458\u53D1\u653E",
  [16 /* BuyChatAcademic */]: "\u8D2D\u4E70ai\u79D1\u7814\u52A9\u624B",
  [17 /* BuyAIToken */]: "\u79D1\u7814\u8C46\u8D2D\u4E70",
  [18 /* BuyOtreeServer */]: "\u8D2D\u4E70otree\u670D\u52A1\u5668",
  [19 /* SurveyAIProcess */]: "\u95EE\u5377AI\u6295\u653E"
};

// src/config/index.ts
var HeaderFields = {
  AppIdHeaderName: "WKY-APPID",
  HashHeaderName: "WKY-SIG",
  TimestampHeaderName: "WKY-TIME",
  NonceHeaderName: "WKY-NONCE"
};
var Constants = {
  AjaxSilentAuthName: "silent"
};

// src/deployment-features.ts
var DeploymentFeatureKey = /* @__PURE__ */ ((DeploymentFeatureKey2) => {
  DeploymentFeatureKey2["Course"] = "course";
  DeploymentFeatureKey2["Survey"] = "survey";
  DeploymentFeatureKey2["ExternalSurvey"] = "externalSurvey";
  DeploymentFeatureKey2["Game"] = "game";
  DeploymentFeatureKey2["Otree"] = "otree";
  DeploymentFeatureKey2["Jspsych"] = "jspsych";
  DeploymentFeatureKey2["ExperimentRoom"] = "experimentRoom";
  DeploymentFeatureKey2["RecruitPlannedReward"] = "recruitPlannedReward";
  DeploymentFeatureKey2["RecruitCompletionSubjectPool"] = "recruitCompletionSubjectPool";
  DeploymentFeatureKey2["OnlineSettlement"] = "onlineSettlement";
  return DeploymentFeatureKey2;
})(DeploymentFeatureKey || {});
var DEPLOYMENT_FEATURE_DEFINITIONS = {
  ["course" /* Course */]: {
    label: "\u8BFE\u5802",
    description: "\u8BFE\u5802\u3001\u8BFE\u6B21\u3001\u7B7E\u5230\u3001\u4F5C\u4E1A\u4E0E\u8BFE\u7A0B\u5185\u5BB9\u5165\u53E3\u3002",
    capability: "module",
    taskTypes: ["course" /* Course */]
  },
  ["survey" /* Survey */]: {
    label: "\u95EE\u5377",
    description: "\u7814\u7A76\u8005\u521B\u5EFA\u548C\u7BA1\u7406\u95EE\u5377\uFF1B\u62DB\u52DF\u91CC\u7684\u62A5\u540D\u95EE\u5377\u4E0D\u53D7\u5F71\u54CD\u3002",
    capability: "module",
    taskTypes: ["survey" /* Survey */]
  },
  ["externalSurvey" /* ExternalSurvey */]: {
    label: "\u7B2C\u4E09\u65B9\u95EE\u5377",
    description: "\u95EE\u5377\u661F\u3001Qualtrics\u3001\u817E\u8BAF\u95EE\u5377\u7B49\u5916\u90E8\u95EE\u5377\u5165\u53E3\u3002",
    capability: "module",
    taskTypes: ["externalSurvey" /* ExternalSurvey */]
  },
  ["game" /* Game */]: {
    label: "\u5B9E\u9A8C",
    description: "Game \u5B9E\u9A8C\u9879\u76EE\u521B\u5EFA\u4E0E\u7BA1\u7406\u3002",
    capability: "module",
    taskTypes: ["game" /* Game */]
  },
  ["otree" /* Otree */]: {
    label: "oTree",
    description: "oTree \u9879\u76EE\u4E0A\u4F20\u3001\u4F1A\u8BDD\u4E0E\u6570\u636E\u5165\u53E3\u3002",
    capability: "module",
    taskTypes: ["otree" /* Otree */]
  },
  ["jspsych" /* Jspsych */]: {
    label: "JsPsych",
    description: "JsPsych \u4EFB\u52A1\u4E0A\u4F20\u4E0E\u8FD0\u884C\u5165\u53E3\u3002",
    capability: "module",
    taskTypes: ["jspsych" /* JsPsych */]
  },
  ["experimentRoom" /* ExperimentRoom */]: {
    label: "\u5B9E\u9A8C\u5BA4",
    description: "\u5B9E\u9A8C\u5BA4\u7A7A\u95F4\u3001\u5EA7\u4F4D\u548C\u7EBF\u4E0B\u573A\u5730\u4FE1\u606F\u3002",
    capability: "module",
    taskTypes: []
  },
  ["recruitPlannedReward" /* RecruitPlannedReward */]: {
    label: "\u8BA1\u5212\u5956\u52B1",
    description: "\u5141\u8BB8\u7814\u7A76\u8005\u4E3A\u62DB\u52DF\u8BBE\u7F6E\u73B0\u91D1\u8865\u8D34\u6216\u5B66\u5206\u5956\u52B1\u3002",
    capability: "businessCapability",
    taskTypes: []
  },
  ["recruitCompletionSubjectPool" /* RecruitCompletionSubjectPool */]: {
    label: "\u573A\u6B21\u7ED3\u675F\u540E\u81EA\u52A8\u5F52\u5165\u88AB\u8BD5\u5E93",
    description: "\u5141\u8BB8\u7814\u7A76\u8005\u4E3A\u62DB\u52DF\u9009\u62E9\u573A\u6B21\u7ED3\u675F\u540E\u7684\u88AB\u8BD5\u5E93\u5F52\u5165\u76EE\u6807\u3002",
    capability: "businessCapability",
    taskTypes: []
  },
  ["onlineSettlement" /* OnlineSettlement */]: {
    label: "\u7EBF\u4E0A\u8D44\u91D1\u7ED3\u7B97",
    description: "\u94B1\u5305\u3001\u5145\u503C\u3001\u7EBF\u4E0A\u53D1\u653E\u3001\u63D0\u73B0\u548C\u8D44\u91D1\u7BA1\u7406\u80FD\u529B\u3002",
    capability: "sensitiveSideEffect",
    taskTypes: []
  }
};
var DEPLOYMENT_FEATURE_REDIS_KEY = "deployment:enabled-features";
var DEPLOYMENT_POLICY_REDIS_KEY = "deployment:policies";
var DEPLOYMENT_UI_REDIS_KEY = "deployment:ui";
var DEPLOYMENT_LOGIN_AUTH_REDIS_KEY = "deployment:login-auth";
var FEATURE_DISABLED_CODE = "FEATURE_DISABLED";
var ONLINE_SETTLEMENT_DISABLED_MESSAGE = "\u5F53\u524D\u90E8\u7F72\u672A\u5F00\u542F\u7EBF\u4E0A\u8D44\u91D1\u7ED3\u7B97";
function getDeploymentFeatureDisabledMessage(feature) {
  if (feature === "onlineSettlement" /* OnlineSettlement */) {
    return ONLINE_SETTLEMENT_DISABLED_MESSAGE;
  }
  const definition = DEPLOYMENT_FEATURE_DEFINITIONS[feature];
  return definition.capability === "module" ? `\u5F53\u524D\u90E8\u7F72\u672A\u5F00\u542F${definition.label}\u6A21\u5757` : `\u5F53\u524D\u90E8\u7F72\u672A\u542F\u7528${definition.label}`;
}
var DEPLOYMENT_FEATURE_KEYS = Object.values(DeploymentFeatureKey);
var DEPLOYMENT_FEATURE_ENUM_VALUES = Object.freeze(
  Object.fromEntries(DEPLOYMENT_FEATURE_KEYS.map((key) => [key, key]))
);
var TASK_TYPE_DEPLOYMENT_FEATURE = Object.freeze(
  Object.fromEntries(
    DEPLOYMENT_FEATURE_KEYS.flatMap(
      (feature) => DEPLOYMENT_FEATURE_DEFINITIONS[feature].taskTypes.map((taskType) => [taskType, feature])
    )
  )
);
var DEFAULT_DEPLOYMENT_FEATURE_STATE = Object.freeze(
  Object.fromEntries(DEPLOYMENT_FEATURE_KEYS.map((key) => [key, false]))
);
function isTaskTypeDeploymentEnabled(taskType, features) {
  if (!taskType) return true;
  const deploymentFeature = TASK_TYPE_DEPLOYMENT_FEATURE[taskType];
  return !deploymentFeature || features[deploymentFeature];
}
function isDeploymentFeatureKey(value) {
  return DEPLOYMENT_FEATURE_KEYS.includes(value);
}
function normalizeDeploymentFeatureKeys(values) {
  const normalized = [];
  const seen = /* @__PURE__ */ new Set();
  for (const value of values || []) {
    if (!isDeploymentFeatureKey(value) || seen.has(value)) {
      continue;
    }
    seen.add(value);
    normalized.push(value);
  }
  return normalized;
}
function buildDeploymentFeatureState(values) {
  const state = { ...DEFAULT_DEPLOYMENT_FEATURE_STATE };
  for (const key of normalizeDeploymentFeatureKeys(values)) {
    state[key] = true;
  }
  return state;
}
var DEFAULT_DEPLOYMENT_POLICY_STATE = {
  subjectAdmissionProfileRequired: false,
  subjectPoolJoinReviewRequired: false,
  teamOwnerRecruitManagementEnabled: false,
  recruitAutoInviteSubjectPoolEnabled: false
};
var DEPLOYMENT_POLICY_FIELDS = [
  "subjectAdmissionProfileRequired",
  "subjectPoolJoinReviewRequired",
  "teamOwnerRecruitManagementEnabled",
  "recruitAutoInviteSubjectPoolEnabled"
];
function parseDeploymentPolicyValue(value) {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value !== "string") return false;
  const normalized = value.trim().toLowerCase();
  return ["true", "1", "yes", "on", "enabled"].includes(normalized);
}
function buildDeploymentPolicyState(values) {
  return {
    ...DEFAULT_DEPLOYMENT_POLICY_STATE,
    subjectAdmissionProfileRequired: parseDeploymentPolicyValue(values?.subjectAdmissionProfileRequired),
    subjectPoolJoinReviewRequired: parseDeploymentPolicyValue(values?.subjectPoolJoinReviewRequired),
    teamOwnerRecruitManagementEnabled: parseDeploymentPolicyValue(values?.teamOwnerRecruitManagementEnabled),
    recruitAutoInviteSubjectPoolEnabled: parseDeploymentPolicyValue(
      values?.recruitAutoInviteSubjectPoolEnabled
    )
  };
}
var DeploymentHomePageMode = /* @__PURE__ */ ((DeploymentHomePageMode2) => {
  DeploymentHomePageMode2["WkyPlatform"] = "wkyPlatform";
  DeploymentHomePageMode2["DedicatedRecruit"] = "dedicatedRecruit";
  return DeploymentHomePageMode2;
})(DeploymentHomePageMode || {});
var DEFAULT_DEPLOYMENT_UI_STATE = {
  homePageMode: "wkyPlatform" /* WkyPlatform */,
  defaultTeamId: ""
};
function normalizeDeploymentHomePageMode(value) {
  if (value === "dedicatedRecruit" /* DedicatedRecruit */) {
    return "dedicatedRecruit" /* DedicatedRecruit */;
  }
  return "wkyPlatform" /* WkyPlatform */;
}
function buildDeploymentUiState(values) {
  return {
    ...DEFAULT_DEPLOYMENT_UI_STATE,
    homePageMode: normalizeDeploymentHomePageMode(values?.homePageMode),
    defaultTeamId: typeof values?.defaultTeamId === "string" ? values.defaultTeamId.trim() : ""
  };
}
function isSubjectAdmissionOnboardingEnabled(homePageMode, subjectAdmissionProfileRequired) {
  return normalizeDeploymentHomePageMode(homePageMode) === "dedicatedRecruit" /* DedicatedRecruit */ && parseDeploymentPolicyValue(subjectAdmissionProfileRequired);
}
var DEPLOYMENT_LOGIN_AUTH_FIELDS = [
  "mobileLoginEnabled",
  "wechatLoginEnabled"
];
var DEFAULT_DEPLOYMENT_LOGIN_AUTH_STATE = {
  mobileLoginEnabled: true,
  wechatLoginEnabled: true
};
function buildDeploymentLoginAuthState(values) {
  return {
    mobileLoginEnabled: parseDeploymentPolicyValue(values?.mobileLoginEnabled ?? DEFAULT_DEPLOYMENT_LOGIN_AUTH_STATE.mobileLoginEnabled),
    wechatLoginEnabled: parseDeploymentPolicyValue(values?.wechatLoginEnabled ?? DEFAULT_DEPLOYMENT_LOGIN_AUTH_STATE.wechatLoginEnabled)
  };
}

// src/deployment-recruit-defaults.ts
var DEPLOYMENT_RECRUIT_DEFAULTS_REDIS_KEY = "deployment:recruit-defaults";
var DEFAULT_DEPLOYMENT_RECRUIT_DEFAULTS_STATE = Object.freeze({
  startReminderOffsets: [],
  enrollmentCloseBeforeStartMinutes: RecruitEnrollmentCloseOffsetMinutes.AtStart
});
function parseStartReminderOffsets(value) {
  if (Array.isArray(value)) return value;
  if (typeof value !== "string" || !value.trim()) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}
function buildDeploymentRecruitDefaultsState(values) {
  const enrollmentCloseBeforeStartMinutes = Number(
    values?.enrollmentCloseBeforeStartMinutes
  );
  return {
    startReminderOffsets: normalizeRecruitStartReminderOffsets(
      parseStartReminderOffsets(values?.startReminderOffsets)
    ),
    enrollmentCloseBeforeStartMinutes: isRecruitEnrollmentCloseOffsetMinutes(
      enrollmentCloseBeforeStartMinutes
    ) ? enrollmentCloseBeforeStartMinutes : RecruitEnrollmentCloseOffsetMinutes.AtStart
  };
}
function deploymentRecruitDefaultsStateToRedisFields(state) {
  const normalized = buildDeploymentRecruitDefaultsState(state);
  return [
    "startReminderOffsets",
    JSON.stringify(normalized.startReminderOffsets),
    "enrollmentCloseBeforeStartMinutes",
    String(normalized.enrollmentCloseBeforeStartMinutes)
  ];
}

// src/recruit-rewards.ts
var RecruitRewardType = /* @__PURE__ */ ((RecruitRewardType2) => {
  RecruitRewardType2["CashSubsidy"] = "cashSubsidy";
  RecruitRewardType2["AcademicCredit"] = "academicCredit";
  return RecruitRewardType2;
})(RecruitRewardType || {});
var RECRUIT_REWARD_TYPE_ENUM_VALUES = Object.freeze(
  Object.fromEntries(
    Object.values(RecruitRewardType).map((value) => [value, value])
  )
);
var RECRUIT_REWARD_DESCRIPTION_MAX_LENGTH = 200;
function isRecruitRewardType(value) {
  return Object.values(RecruitRewardType).includes(value);
}

// src/deployment-branding.ts
var DEPLOYMENT_BRANDING_REDIS_KEY = "deployment:branding";
var DEPLOYMENT_BRANDING_FIELDS = [
  "systemName",
  "logoUrl",
  "faviconUrl",
  "homeCoverUrl",
  "primaryColor"
];
var DEFAULT_DEPLOYMENT_BRANDING_STATE = {
  systemName: "\u5FAE\u8BFE\u7814",
  logoUrl: "",
  faviconUrl: "",
  homeCoverUrl: "",
  primaryColor: ""
};
function normalizeText(value, fallback = "") {
  if (typeof value !== "string") return fallback;
  return value.trim();
}
function normalizeRequiredText(value, fallback) {
  return normalizeText(value) || fallback;
}
function normalizeUrl(value) {
  const text = normalizeText(value);
  if (!text) return "";
  if (/^(https?:)?\/\//i.test(text) || text.startsWith("/") || text.startsWith("data:image/")) {
    return text;
  }
  return "";
}
function normalizeColor(value) {
  const text = normalizeText(value);
  if (!text) return "";
  if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(text)) {
    return text;
  }
  if (/^oklch\([^)]+\)$/i.test(text) || /^rgb(a)?\([^)]+\)$/i.test(text) || /^hsl(a)?\([^)]+\)$/i.test(text)) {
    return text;
  }
  return "";
}
function buildDeploymentBrandingState(values) {
  return {
    systemName: normalizeRequiredText(values?.systemName, DEFAULT_DEPLOYMENT_BRANDING_STATE.systemName),
    logoUrl: normalizeUrl(values?.logoUrl),
    faviconUrl: normalizeUrl(values?.faviconUrl),
    homeCoverUrl: normalizeUrl(values?.homeCoverUrl),
    primaryColor: normalizeColor(values?.primaryColor)
  };
}

// src/deployment-cas-auth.ts
var DeploymentCasProtocolVersion = /* @__PURE__ */ ((DeploymentCasProtocolVersion2) => {
  DeploymentCasProtocolVersion2["CAS_2_0"] = "CAS_2_0";
  DeploymentCasProtocolVersion2["CAS_3_0"] = "CAS_3_0";
  return DeploymentCasProtocolVersion2;
})(DeploymentCasProtocolVersion || {});
var DEPLOYMENT_CAS_AUTH_REDIS_KEY = "deployment:cas-auth";
var DEPLOYMENT_CAS_AUTH_DIAGNOSTICS_TTL_SECONDS = 7 * 24 * 60 * 60;
var DEPLOYMENT_CAS_AUTH_DIAGNOSTICS_LIMIT = 20;
function getDeploymentCasAuthDiagnosticsRedisKey(providerId) {
  return `deployment:cas-auth:diagnostics:${providerId || DEFAULT_DEPLOYMENT_CAS_AUTH_STATE.providerId}`;
}
var DEPLOYMENT_CAS_AUTH_FIELDS = [
  "enabled",
  "providerId",
  "displayName",
  "casServerUrlPrefix",
  "protocolVersion",
  "serviceUrl",
  "logoutUrl",
  "principalAttribute",
  "nameAttribute",
  "mobileAttribute",
  "studentNoAttribute",
  "emailAttribute",
  "autoProvision",
  "linkByMobile",
  "requireMobile",
  "skipTlsVerify"
];
var DEFAULT_DEPLOYMENT_CAS_AUTH_STATE = {
  enabled: false,
  providerId: "default",
  displayName: "\u7EDF\u4E00\u8EAB\u4EFD\u8BA4\u8BC1",
  casServerUrlPrefix: "",
  protocolVersion: "CAS_2_0" /* CAS_2_0 */,
  serviceUrl: "",
  logoutUrl: "",
  principalAttribute: "$casUser",
  nameAttribute: "cn",
  mobileAttribute: "telephoneNumber",
  studentNoAttribute: "eduPersonStudentID",
  emailAttribute: "mail",
  autoProvision: true,
  linkByMobile: true,
  requireMobile: false,
  skipTlsVerify: false
};
function parseBoolean(value, fallback) {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value !== "string") return fallback;
  const normalized = value.trim().toLowerCase();
  if (["true", "1", "yes", "on", "enabled"].includes(normalized)) return true;
  if (["false", "0", "no", "off", "disabled"].includes(normalized)) return false;
  return fallback;
}
function parseString(value, fallback) {
  if (typeof value !== "string") return fallback;
  const normalized = value.trim();
  return normalized || fallback;
}
function normalizeCasUrlPrefix(value) {
  if (typeof value !== "string") return "";
  return value.trim().replace(/\/+$/, "");
}
function normalizeCasProviderId(value) {
  return parseString(value, DEFAULT_DEPLOYMENT_CAS_AUTH_STATE.providerId);
}
function normalizeCasProtocolVersion(value) {
  if (value === "CAS_3_0" /* CAS_3_0 */) {
    return "CAS_3_0" /* CAS_3_0 */;
  }
  return "CAS_2_0" /* CAS_2_0 */;
}
function buildDeploymentCasAuthState(values) {
  const defaults = DEFAULT_DEPLOYMENT_CAS_AUTH_STATE;
  return {
    enabled: parseBoolean(values?.enabled, defaults.enabled),
    providerId: normalizeCasProviderId(values?.providerId),
    displayName: parseString(values?.displayName, defaults.displayName),
    casServerUrlPrefix: normalizeCasUrlPrefix(values?.casServerUrlPrefix),
    protocolVersion: normalizeCasProtocolVersion(values?.protocolVersion),
    serviceUrl: typeof values?.serviceUrl === "string" ? values.serviceUrl.trim() : defaults.serviceUrl,
    logoutUrl: typeof values?.logoutUrl === "string" ? values.logoutUrl.trim() : defaults.logoutUrl,
    principalAttribute: parseString(values?.principalAttribute, defaults.principalAttribute),
    nameAttribute: parseString(values?.nameAttribute, defaults.nameAttribute),
    mobileAttribute: parseString(values?.mobileAttribute, defaults.mobileAttribute),
    studentNoAttribute: parseString(values?.studentNoAttribute, defaults.studentNoAttribute),
    emailAttribute: parseString(values?.emailAttribute, defaults.emailAttribute),
    autoProvision: true,
    linkByMobile: parseBoolean(values?.linkByMobile, defaults.linkByMobile),
    requireMobile: parseBoolean(values?.requireMobile, defaults.requireMobile),
    skipTlsVerify: false
  };
}
function validateDeploymentCasAuthState(state) {
  const errors = [];
  if (!/^[A-Za-z0-9_-]+$/.test(state.providerId)) {
    errors.push("providerId \u53EA\u80FD\u5305\u542B\u82F1\u6587\u3001\u6570\u5B57\u3001\u77ED\u6A2A\u7EBF\u6216\u4E0B\u5212\u7EBF");
  }
  if (!Object.values(DeploymentCasProtocolVersion).includes(state.protocolVersion)) {
    errors.push("protocolVersion \u53EA\u80FD\u662F CAS_2_0 \u6216 CAS_3_0");
  }
  if (state.enabled && !state.casServerUrlPrefix) {
    errors.push("\u542F\u7528 CAS \u65F6\u5FC5\u987B\u586B\u5199 CAS Server Prefix");
  }
  if (state.enabled && !state.serviceUrl) {
    errors.push("\u542F\u7528 CAS \u65F6\u5FC5\u987B\u586B\u5199 CAS \u56DE\u8C03\u5730\u5740");
  }
  if (state.casServerUrlPrefix && !isHttpUrl(state.casServerUrlPrefix)) {
    errors.push("casServerUrlPrefix \u5FC5\u987B\u662F http \u6216 https URL");
  }
  if (state.serviceUrl && !isHttpUrl(state.serviceUrl)) {
    errors.push("serviceUrl \u5FC5\u987B\u662F http \u6216 https URL");
  }
  if (state.logoutUrl && !isHttpUrl(state.logoutUrl)) {
    errors.push("logoutUrl \u5FC5\u987B\u662F http \u6216 https URL");
  }
  return errors;
}
function isHttpUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}
function getCasValidateEndpoint(config) {
  const path = config.protocolVersion === "CAS_3_0" /* CAS_3_0 */ ? "/p3/serviceValidate" : "/serviceValidate";
  return `${normalizeCasUrlPrefix(config.casServerUrlPrefix)}${path}`;
}
function getCasLoginEndpoint(config) {
  return `${normalizeCasUrlPrefix(config.casServerUrlPrefix)}/login`;
}
function getCasLogoutUrl(config) {
  return config.logoutUrl || `${normalizeCasUrlPrefix(config.casServerUrlPrefix)}/logout`;
}
function normalizeCasCallback(value, fallback = "/") {
  if (typeof value !== "string") return fallback;
  const callback = value.trim();
  if (!callback || !callback.startsWith("/") || callback.startsWith("//")) {
    return fallback;
  }
  return callback;
}
function buildCasServiceUrl(config, fallbackHostName, callback) {
  const base = config.serviceUrl || `/api/account/cas/${encodeURIComponent(config.providerId)}/callback`;
  const url = new URL(base, fallbackHostName);
  if (callback) {
    url.searchParams.set("callback", normalizeCasCallback(callback));
  }
  return url.toString();
}
function buildCasLoginUrl(config, serviceUrl) {
  const url = new URL(getCasLoginEndpoint(config));
  url.searchParams.set("service", serviceUrl);
  return url.toString();
}
function buildCasValidateUrl(config, serviceUrl, ticket) {
  const url = new URL(getCasValidateEndpoint(config));
  url.searchParams.set("service", serviceUrl);
  url.searchParams.set("ticket", ticket);
  return url.toString();
}
function normalizeAttributeValue(value) {
  if (Array.isArray(value)) {
    return value.map(normalizeAttributeValue).find(Boolean) || "";
  }
  if (value === null || value === void 0) return "";
  return String(value).trim();
}
function getCasAttributeValue(attributes, attributeKey, casUser) {
  if (attributeKey === "$casUser") {
    return casUser;
  }
  return normalizeAttributeValue(attributes[attributeKey]);
}
function mapCasAttributesToProfile(config, input) {
  return {
    principal: getCasAttributeValue(input.attributes, config.principalAttribute, input.casUser),
    name: getCasAttributeValue(input.attributes, config.nameAttribute, input.casUser),
    mobile: getCasAttributeValue(input.attributes, config.mobileAttribute, input.casUser),
    stuNum: getCasAttributeValue(input.attributes, config.studentNoAttribute, input.casUser),
    email: getCasAttributeValue(input.attributes, config.emailAttribute, input.casUser)
  };
}
function buildCasMappingPreview(config, input) {
  const profile = mapCasAttributesToProfile(config, input);
  const rows = [
    { localField: "principal", label: "\u4E3B\u8D26\u53F7", attributeKey: config.principalAttribute },
    { localField: "name", label: "\u59D3\u540D", attributeKey: config.nameAttribute },
    { localField: "mobile", label: "\u624B\u673A", attributeKey: config.mobileAttribute },
    { localField: "stuNum", label: "\u5B66\u53F7", attributeKey: config.studentNoAttribute },
    { localField: "email", label: "\u90AE\u7BB1", attributeKey: config.emailAttribute }
  ];
  return rows.map((row) => {
    const value = profile[row.localField];
    return {
      ...row,
      value,
      maskedValue: maskCasValue(row.attributeKey, value),
      matched: !!value
    };
  });
}
function maskCasValue(key, value) {
  const text = normalizeAttributeValue(value);
  if (!text) return "";
  const loweredKey = key.toLowerCase();
  if (/(password|pwd|secret|token)/.test(loweredKey)) {
    return "[\u5DF2\u9690\u85CF]";
  }
  if (/@/.test(text)) {
    const [name, domain] = text.split("@");
    if (!domain) return text;
    const visibleName = name.length <= 2 ? `${name[0] || ""}*` : `${name.slice(0, 2)}***`;
    return `${visibleName}@${domain}`;
  }
  const digits = text.replace(/\D/g, "");
  if (digits.length >= 7 && digits.length === text.length) {
    return `${text.slice(0, 3)}****${text.slice(-4)}`;
  }
  return text;
}
function maskCasAttributes(attributes) {
  const result = {};
  for (const [key, value] of Object.entries(attributes)) {
    result[key] = Array.isArray(value) ? value.map((item) => maskCasValue(key, item)) : maskCasValue(key, value);
  }
  return result;
}
function maskCasProfile(profile) {
  return {
    principal: maskCasValue("principal", profile.principal),
    name: maskCasValue("name", profile.name),
    mobile: maskCasValue("mobile", profile.mobile),
    stuNum: maskCasValue("stuNum", profile.stuNum),
    email: maskCasValue("email", profile.email)
  };
}

// src/deployment-notifications.ts
var DeploymentNotificationProviderType = /* @__PURE__ */ ((DeploymentNotificationProviderType2) => {
  DeploymentNotificationProviderType2["NjauCommunicationPlatform"] = "NJAU_COMMUNICATION_PLATFORM";
  DeploymentNotificationProviderType2["WechatOfficialAccount"] = "WECHAT_OFFICIAL_ACCOUNT";
  DeploymentNotificationProviderType2["TencentCloudSms"] = "TENCENT_CLOUD_SMS";
  DeploymentNotificationProviderType2["SmtpEmail"] = "SMTP_EMAIL";
  return DeploymentNotificationProviderType2;
})(DeploymentNotificationProviderType || {});
var DeploymentNotificationDeliveryStrategy = /* @__PURE__ */ ((DeploymentNotificationDeliveryStrategy2) => {
  DeploymentNotificationDeliveryStrategy2["SequentialFallback"] = "SEQUENTIAL_FALLBACK";
  DeploymentNotificationDeliveryStrategy2["AllEnabled"] = "ALL_ENABLED";
  return DeploymentNotificationDeliveryStrategy2;
})(DeploymentNotificationDeliveryStrategy || {});
var DEPLOYMENT_NOTIFICATION_DELIVERY_STRATEGY_TYPES = Object.values(DeploymentNotificationDeliveryStrategy);
var DEPLOYMENT_NOTIFICATION_DELIVERY_STRATEGY_ENUM_VALUES = Object.freeze(
  Object.fromEntries(DEPLOYMENT_NOTIFICATION_DELIVERY_STRATEGY_TYPES.map((strategy) => [strategy, strategy]))
);
var DEFAULT_DEPLOYMENT_NOTIFICATION_DELIVERY_STRATEGY = "SEQUENTIAL_FALLBACK" /* SequentialFallback */;
var DEPLOYMENT_NOTIFICATION_PROVIDER_TYPES = Object.values(DeploymentNotificationProviderType);
var DEPLOYMENT_NOTIFICATION_PROVIDER_ENUM_VALUES = Object.freeze(
  Object.fromEntries(DEPLOYMENT_NOTIFICATION_PROVIDER_TYPES.map((provider) => [provider, provider]))
);
var DEFAULT_DEPLOYMENT_NOTIFICATION_PROVIDER_ORDER = Object.freeze([
  "NJAU_COMMUNICATION_PLATFORM" /* NjauCommunicationPlatform */,
  "WECHAT_OFFICIAL_ACCOUNT" /* WechatOfficialAccount */,
  "TENCENT_CLOUD_SMS" /* TencentCloudSms */,
  "SMTP_EMAIL" /* SmtpEmail */
]);
var DEPLOYMENT_NOTIFICATION_PROVIDERS_REDIS_KEY = "deployment:notification-providers";
var DEPLOYMENT_NOTIFICATION_PROVIDER_REDIS_FIELDS = [
  "deliveryStrategy",
  "providerOrder",
  "njauDisplayName",
  "njauApiBaseUrl",
  "njauAppId",
  "njauAppPassword",
  "njauTodoTemplateId",
  "njauTodoEnabled",
  "njauEmailEnabled"
];
var DEFAULT_DEPLOYMENT_NJAU_NOTIFICATION_PROVIDER_CONFIG = Object.freeze({
  displayName: "\u5357\u519C\u901A\u8BAF\u4E2D\u53F0",
  apiBaseUrl: "https://msg.njau.edu.cn",
  appId: "",
  hasAppPassword: false,
  todoTemplateId: "",
  todoEnabled: true,
  emailEnabled: false
});
function normalizeStoredBoolean(value, fallback) {
  if (typeof value === "boolean") return value;
  if (value === "true") return true;
  if (value === "false") return false;
  return fallback;
}
function isDeploymentNotificationProviderType(value) {
  return typeof value === "string" && DEPLOYMENT_NOTIFICATION_PROVIDER_TYPES.includes(value);
}
function isDeploymentNotificationDeliveryStrategy(value) {
  return typeof value === "string" && DEPLOYMENT_NOTIFICATION_DELIVERY_STRATEGY_TYPES.includes(value);
}
function normalizeDeploymentNotificationDeliveryStrategy(value) {
  return isDeploymentNotificationDeliveryStrategy(value) ? value : DEFAULT_DEPLOYMENT_NOTIFICATION_DELIVERY_STRATEGY;
}
function normalizeDeploymentNotificationProviderOrder(values) {
  const normalized = [];
  const seen = /* @__PURE__ */ new Set();
  for (const value of values || []) {
    if (!isDeploymentNotificationProviderType(value) || seen.has(value)) {
      continue;
    }
    seen.add(value);
    normalized.push(value);
  }
  return normalized;
}
function normalizeDeploymentNotificationApiBaseUrl(value) {
  const normalized = typeof value === "string" ? value.trim() : "";
  return normalized.replace(/\/+$/, "") || DEFAULT_DEPLOYMENT_NJAU_NOTIFICATION_PROVIDER_CONFIG.apiBaseUrl;
}
function parseProviderOrder(value) {
  if (Array.isArray(value)) {
    return normalizeDeploymentNotificationProviderOrder(value);
  }
  if (typeof value !== "string") {
    return [...DEFAULT_DEPLOYMENT_NOTIFICATION_PROVIDER_ORDER];
  }
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? normalizeDeploymentNotificationProviderOrder(parsed) : [];
  } catch {
    return [];
  }
}
function buildDeploymentNotificationProviderStoredState(values) {
  return {
    deliveryStrategy: normalizeDeploymentNotificationDeliveryStrategy(values?.deliveryStrategy),
    providerOrder: values && Object.hasOwn(values, "providerOrder") ? parseProviderOrder(values.providerOrder) : [...DEFAULT_DEPLOYMENT_NOTIFICATION_PROVIDER_ORDER],
    njau: {
      displayName: typeof values?.njauDisplayName === "string" && values.njauDisplayName.trim() ? values.njauDisplayName.trim() : DEFAULT_DEPLOYMENT_NJAU_NOTIFICATION_PROVIDER_CONFIG.displayName,
      apiBaseUrl: normalizeDeploymentNotificationApiBaseUrl(values?.njauApiBaseUrl),
      appId: typeof values?.njauAppId === "string" ? values.njauAppId.trim() : "",
      appPassword: typeof values?.njauAppPassword === "string" ? values.njauAppPassword : "",
      todoTemplateId: typeof values?.njauTodoTemplateId === "string" ? values.njauTodoTemplateId.trim() : "",
      todoEnabled: normalizeStoredBoolean(
        values?.njauTodoEnabled,
        DEFAULT_DEPLOYMENT_NJAU_NOTIFICATION_PROVIDER_CONFIG.todoEnabled
      ),
      emailEnabled: normalizeStoredBoolean(
        values?.njauEmailEnabled,
        DEFAULT_DEPLOYMENT_NJAU_NOTIFICATION_PROVIDER_CONFIG.emailEnabled
      )
    }
  };
}
function toDeploymentNotificationProviderConfig(state, runtimeStatuses = []) {
  return {
    deliveryStrategy: state.deliveryStrategy,
    providerOrder: [...state.providerOrder],
    njau: {
      displayName: state.njau.displayName,
      apiBaseUrl: state.njau.apiBaseUrl,
      appId: state.njau.appId,
      hasAppPassword: Boolean(state.njau.appPassword),
      todoTemplateId: state.njau.todoTemplateId,
      todoEnabled: state.njau.todoEnabled,
      emailEnabled: state.njau.emailEnabled
    },
    runtimeStatuses: [...runtimeStatuses]
  };
}
function deploymentNotificationProviderStateToRedisFields(state) {
  return [
    "deliveryStrategy",
    state.deliveryStrategy,
    "providerOrder",
    JSON.stringify(state.providerOrder),
    "njauDisplayName",
    state.njau.displayName,
    "njauApiBaseUrl",
    state.njau.apiBaseUrl,
    "njauAppId",
    state.njau.appId,
    "njauAppPassword",
    state.njau.appPassword,
    "njauTodoTemplateId",
    state.njau.todoTemplateId,
    "njauTodoEnabled",
    String(state.njau.todoEnabled),
    "njauEmailEnabled",
    String(state.njau.emailEnabled)
  ];
}
function validateDeploymentNotificationProviderState(state) {
  const errors = [];
  try {
    const url = new URL(state.njau.apiBaseUrl);
    if (url.protocol !== "https:") {
      errors.push("NJAU API Base URL \u5FC5\u987B\u4F7F\u7528 HTTPS");
    }
    if (url.username || url.password || url.search || url.hash) {
      errors.push("NJAU API Base URL \u4E0D\u80FD\u5305\u542B\u51ED\u8BC1\u3001\u67E5\u8BE2\u53C2\u6570\u6216\u951A\u70B9");
    }
  } catch {
    errors.push("NJAU API Base URL \u5FC5\u987B\u662F\u5408\u6CD5 URL");
  }
  return errors;
}

// src/deployment-operations.ts
var DEPLOYMENT_OPERATIONS_REDIS_KEY = "deployment:operations";
var DEPLOYMENT_OPERATIONS_FIELDS = [
  "announcement",
  "administratorName",
  "administratorPhone",
  "administratorEmail"
];
var DEFAULT_DEPLOYMENT_OPERATIONS_STATE = {
  announcement: "",
  administratorName: "",
  administratorPhone: "",
  administratorEmail: ""
};
var FIELD_LIMITS = {
  announcement: 2e3,
  administratorName: 100,
  administratorPhone: 50,
  administratorEmail: 254
};
function normalizeField(value, field) {
  return typeof value === "string" ? value.trim().slice(0, FIELD_LIMITS[field]) : "";
}
function buildDeploymentOperationsState(values) {
  return {
    announcement: normalizeField(values?.announcement, "announcement"),
    administratorName: normalizeField(
      values?.administratorName,
      "administratorName"
    ),
    administratorPhone: normalizeField(
      values?.administratorPhone,
      "administratorPhone"
    ),
    administratorEmail: normalizeField(
      values?.administratorEmail,
      "administratorEmail"
    ).toLowerCase()
  };
}
function validateDeploymentOperationsState(state) {
  const errors = [];
  if (state.administratorEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.administratorEmail)) {
    errors.push("\u7BA1\u7406\u5458\u8054\u7CFB\u90AE\u7BB1\u683C\u5F0F\u4E0D\u6B63\u786E");
  }
  return errors;
}

// src/deployment-subject-admission.ts
var DEPLOYMENT_SUBJECT_ADMISSION_REDIS_KEY = "deployment:subject-admission";
var SUBJECT_ADMISSION_CONSENT_SCOPE = "subjectAdmission";
var SUBJECT_ADMISSION_CONSENT_DOCUMENT_KEY = "baseline-consent";
var SUBJECT_ADMISSION_CONSENT_VERSION = "1";
var CONSENT_CONTENT_TYPE_HTML = "html";
var CONSENT_RICH_TEXT_ALLOWED_TAGS = [
  "h1",
  "h2",
  "h3",
  "p",
  "strong",
  "ul",
  "ol",
  "li",
  "a",
  "br"
];
var CONSENT_RICH_TEXT_ALLOWED_ATTRIBUTES = {
  a: ["href", "title"]
};
var CONSENT_RICH_TEXT_ALLOWED_SCHEMES = ["http", "https", "mailto"];
var SUBJECT_ADMISSION_COLLEGE_OPTION_MAX_COUNT = 200;
var SUBJECT_ADMISSION_COLLEGE_OPTION_MAX_LENGTH = 80;
var DEFAULT_SUBJECT_ADMISSION_CONSENT_TITLE = "\u884C\u4E3A\u5B9E\u9A8C\u57FA\u7840\u77E5\u60C5\u540C\u610F";
var DEFAULT_SUBJECT_ADMISSION_CONSENT_CONTENT = [
  "<h3>\u4E00\u3001\u81EA\u613F\u53C2\u4E0E</h3>",
  "<p>\u6211\u77E5\u6653\u53C2\u4E0E\u6821\u5185\u79D1\u7814\u884C\u4E3A\u5B9E\u9A8C\u5B8C\u5168\u51FA\u4E8E\u81EA\u613F\u3002\u6211\u6709\u6743\u5728\u5B9E\u9A8C\u5F00\u59CB\u524D\u62D2\u7EDD\u53C2\u4E0E\uFF0C\u4E5F\u53EF\u5728\u5B9E\u9A8C\u8FC7\u7A0B\u4E2D\u968F\u65F6\u9000\u51FA\uFF0C\u4E0D\u4F1A\u56E0\u6B64\u53D7\u5230\u4E0D\u5408\u7406\u7684\u5904\u7F5A\u6216\u5F71\u54CD\u3002</p>",
  "<h3>\u4E8C\u3001\u9690\u79C1\u4E0E\u4FDD\u5BC6</h3>",
  "<p>\u5B9E\u9A8C\u7EC4\u7EC7\u65B9\u4EC5\u6536\u96C6\u5F00\u5C55\u5B9E\u9A8C\u3001\u53D1\u653E\u62A5\u916C\u53CA\u79D1\u7814\u7BA1\u7406\u6240\u5FC5\u9700\u7684\u4FE1\u606F\uFF0C\u5E76\u91C7\u53D6\u5408\u7406\u63AA\u65BD\u4FDD\u62A4\u4E2A\u4EBA\u4FE1\u606F\u548C\u5B9E\u9A8C\u6570\u636E\u3002\u672A\u7ECF\u6388\u6743\uFF0C\u4E0D\u4F1A\u5411\u65E0\u5173\u4EBA\u5458\u62AB\u9732\u80FD\u591F\u76F4\u63A5\u8BC6\u522B\u6211\u8EAB\u4EFD\u7684\u4FE1\u606F\uFF1B\u79D1\u7814\u6210\u679C\u516C\u5F00\u65F6\u5C06\u5C3D\u53EF\u80FD\u4F7F\u7528\u53BB\u6807\u8BC6\u5316\u6216\u6C47\u603B\u6570\u636E\u3002</p>",
  "<h3>\u4E09\u3001\u53C2\u4E0E\u6743\u76CA</h3>",
  "<p>\u6211\u6709\u6743\u4E86\u89E3\u5B9E\u9A8C\u76EE\u7684\u3001\u4E3B\u8981\u6D41\u7A0B\u3001\u9884\u8BA1\u65F6\u957F\u3001\u53EF\u80FD\u98CE\u9669\u3001\u62A5\u916C\u5B89\u6392\u53CA\u8054\u7CFB\u65B9\u5F0F\uFF0C\u5E76\u53EF\u5728\u53C2\u4E0E\u524D\u6216\u53C2\u4E0E\u8FC7\u7A0B\u4E2D\u63D0\u51FA\u95EE\u9898\u3002\u5982\u611F\u5230\u4E0D\u9002\u6216\u8BA4\u4E3A\u6743\u76CA\u53D7\u5230\u5F71\u54CD\uFF0C\u6211\u53EF\u4EE5\u6682\u505C\u6216\u9000\u51FA\u5B9E\u9A8C\uFF0C\u5E76\u6309\u5DF2\u8BF4\u660E\u7684\u89C4\u5219\u83B7\u5F97\u76F8\u5E94\u5904\u7406\u3002</p>",
  "<h3>\u56DB\u3001\u8D23\u4EFB\u8BF4\u660E</h3>",
  "<p>\u6211\u627F\u8BFA\u5982\u5B9E\u63D0\u4F9B\u5907\u6848\u4FE1\u606F\uFF0C\u5E76\u9075\u5B88\u5B9E\u9A8C\u73B0\u573A\u53CA\u5B89\u5168\u8981\u6C42\u3002\u6211\u7406\u89E3\u53C2\u4E0E\u5B9E\u9A8C\u4E0D\u4EE3\u8868\u5FC5\u7136\u83B7\u5F97\u4E2A\u4EBA\u6536\u76CA\uFF0C\u4E5F\u4E0D\u514D\u9664\u5B66\u6821\u3001\u5E73\u53F0\u6216\u7814\u7A76\u8005\u4F9D\u6CD5\u5E94\u627F\u62C5\u7684\u8D23\u4EFB\u3002</p>"
].join("");
var DEFAULT_DEPLOYMENT_SUBJECT_ADMISSION_STATE = {
  consentTitle: DEFAULT_SUBJECT_ADMISSION_CONSENT_TITLE,
  consentContent: DEFAULT_SUBJECT_ADMISSION_CONSENT_CONTENT,
  collegeOptions: []
};
function normalizeText2(value) {
  return typeof value === "string" ? value.trim() : "";
}
function escapeHtml(value) {
  return value.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll('"', "&quot;").replaceAll("'", "&#39;");
}
function isHtmlLikeContent(value) {
  return /<\/?[a-z][^>]*>/i.test(value);
}
function legacyPlainTextToHtml(value) {
  return value.trim().split(/\n{2,}/).map((paragraph) => `<p>${escapeHtml(paragraph.trim()).replaceAll("\n", "<br>")}</p>`).join("");
}
function normalizeConsentHtmlSource(value) {
  const normalized = normalizeText2(value);
  if (!normalized) return "";
  return isHtmlLikeContent(normalized) ? normalized : legacyPlainTextToHtml(normalized);
}
function parseCollegeOptionSource(value) {
  if (Array.isArray(value)) return value;
  if (typeof value !== "string" || !value.trim()) return [];
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) return parsed;
  } catch {
    return value.split(/\r?\n/);
  }
  return [];
}
function normalizeDeploymentSubjectAdmissionCollegeOptions(value) {
  const options = [];
  const seen = /* @__PURE__ */ new Set();
  for (const rawOption of parseCollegeOptionSource(value)) {
    const option = normalizeSubjectAdmissionCategoryValue(rawOption);
    if (!option || option.length > SUBJECT_ADMISSION_COLLEGE_OPTION_MAX_LENGTH || seen.has(option)) {
      continue;
    }
    seen.add(option);
    options.push(option);
    if (options.length >= SUBJECT_ADMISSION_COLLEGE_OPTION_MAX_COUNT) break;
  }
  return options;
}
function deploymentSubjectAdmissionStateToRedisFields(state) {
  return [
    "consentTitle",
    state.consentTitle,
    "consentContent",
    state.consentContent,
    "collegeOptions",
    JSON.stringify(state.collegeOptions)
  ];
}
function buildDeploymentSubjectAdmissionState(values) {
  const consentContent = normalizeConsentHtmlSource(values?.consentContent);
  return {
    consentTitle: normalizeText2(values?.consentTitle) || DEFAULT_SUBJECT_ADMISSION_CONSENT_TITLE,
    consentContent: consentContent || DEFAULT_SUBJECT_ADMISSION_CONSENT_CONTENT,
    collegeOptions: normalizeDeploymentSubjectAdmissionCollegeOptions(values?.collegeOptions)
  };
}

// src/subject-pool-members.ts
var SubjectPoolMemberSortField = /* @__PURE__ */ ((SubjectPoolMemberSortField2) => {
  SubjectPoolMemberSortField2["JoinedAt"] = "joinedAt";
  SubjectPoolMemberSortField2["Name"] = "name";
  SubjectPoolMemberSortField2["StudentNumber"] = "studentNumber";
  SubjectPoolMemberSortField2["Grade"] = "grade";
  return SubjectPoolMemberSortField2;
})(SubjectPoolMemberSortField || {});
var SubjectPoolMemberSortDirection = /* @__PURE__ */ ((SubjectPoolMemberSortDirection2) => {
  SubjectPoolMemberSortDirection2["Asc"] = "asc";
  SubjectPoolMemberSortDirection2["Desc"] = "desc";
  return SubjectPoolMemberSortDirection2;
})(SubjectPoolMemberSortDirection || {});
var SubjectAdmissionProfileCompleteness = /* @__PURE__ */ ((SubjectAdmissionProfileCompleteness2) => {
  SubjectAdmissionProfileCompleteness2["Complete"] = "complete";
  SubjectAdmissionProfileCompleteness2["Incomplete"] = "incomplete";
  return SubjectAdmissionProfileCompleteness2;
})(SubjectAdmissionProfileCompleteness || {});

// src/admin-permissions.ts
var AdminPermission = /* @__PURE__ */ ((AdminPermission2) => {
  AdminPermission2["SubjectManage"] = "subject:manage";
  AdminPermission2["NotificationManage"] = "notification:manage";
  AdminPermission2["DataExport"] = "data:export";
  AdminPermission2["DataStatsView"] = "data:stats:view";
  AdminPermission2["AuditView"] = "audit:view";
  return AdminPermission2;
})(AdminPermission || {});
var AdminPermissionValues = Object.values(AdminPermission);

// src/env.ts
var EnvType = /* @__PURE__ */ ((EnvType2) => {
  EnvType2["development"] = "development";
  EnvType2["test"] = "test";
  EnvType2["integration"] = "integration";
  EnvType2["stage"] = "stage";
  EnvType2["production"] = "production";
  return EnvType2;
})(EnvType || {});
var NODE_ENV = typeof process !== "undefined" && process.env?.NODE_ENV || "development" /* development */;
var Env = {
  NODE_ENV,
  isDev: NODE_ENV === "development" /* development */,
  isTest: NODE_ENV === "test" /* test */,
  isCI: NODE_ENV === "integration" /* integration */,
  isStage: NODE_ENV === "stage" /* stage */,
  isProd: NODE_ENV === "production" /* production */,
  notDev: NODE_ENV !== "development" /* development */,
  notTest: NODE_ENV !== "test" /* test */,
  notCI: NODE_ENV !== "integration" /* integration */,
  notStage: NODE_ENV !== "stage" /* stage */,
  notProd: NODE_ENV !== "production" /* production */
};

// src/runtime-config.ts
function getWindowRuntimeConfig() {
  const runtimeWindow = globalThis.window;
  return runtimeWindow?.__RUNTIME_CONFIG__ ?? {};
}
function getRuntimeConfigBoolean(key, fallback = false) {
  const value = getWindowRuntimeConfig()[key];
  if (typeof value === "boolean") return value;
  if (typeof value === "string") return value === "true";
  return fallback;
}
function getRuntimeConfigString(key, fallback = "") {
  const value = getWindowRuntimeConfig()[key];
  if (typeof value !== "string") return fallback;
  const normalized = value.trim();
  return normalized || fallback;
}
async function loadRuntimeConfigScript(src) {
  const root = globalThis;
  const doc = root.document;
  if (!doc) return;
  root.__WKY_RUNTIME_CONFIG_PROMISES__ ??= {};
  const cachedPromise = root.__WKY_RUNTIME_CONFIG_PROMISES__[src];
  if (cachedPromise) {
    await cachedPromise;
    return;
  }
  if (doc.querySelector(`script[src="${src}"]`)) {
    root.__WKY_RUNTIME_CONFIG_PROMISES__[src] = Promise.resolve();
    return;
  }
  root.__WKY_RUNTIME_CONFIG_PROMISES__[src] = new Promise((resolve, reject) => {
    const script = doc.createElement("script");
    script.src = src;
    script.async = false;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`failed to load runtime config: ${src}`));
    (doc.head ?? doc.body ?? doc.documentElement)?.appendChild(script);
  });
  await root.__WKY_RUNTIME_CONFIG_PROMISES__[src];
}

// src/utils/shareUrl.ts
function normalizePath(p) {
  if (!p) return "";
  const trimmed = p.replace(/^\/+|\/+$/g, "");
  return trimmed ? `/${trimmed}` : "";
}
function buildShareUrl(input) {
  const { domain, rootPath, taskId, inviter, sig, exp, extraQuery } = input;
  if (!domain) throw new Error("buildShareUrl: domain required");
  if (!taskId) throw new Error("buildShareUrl: taskId required");
  const base = domain.replace(/\/+$/, "");
  const prefix = normalizePath(rootPath);
  const pathPart = `/task/${encodeURIComponent(taskId)}`;
  const qs = new URLSearchParams();
  if (inviter) qs.set("inviter", String(inviter));
  if (sig) qs.set("sig", String(sig));
  if (exp !== void 0 && exp !== null && exp !== "") qs.set("exp", String(exp));
  if (extraQuery) {
    for (const [k, v] of Object.entries(extraQuery)) {
      if (v !== void 0 && v !== null && v !== "") {
        qs.set(k, String(v));
      }
    }
  }
  const query = qs.toString();
  return `${base}${prefix}${pathPart}${query ? `?${query}` : ""}`;
}

// src/utils/privacy.ts
function compact(value) {
  return typeof value === "string" ? value.trim() : "";
}
function maskMobile(value) {
  const mobile = compact(value);
  if (!mobile) return "";
  if (mobile.length <= 4)
    return `${mobile[0]}${"*".repeat(Math.max(mobile.length - 1, 1))}`;
  if (mobile.length <= 7)
    return `${mobile.slice(0, 2)}${"*".repeat(mobile.length - 3)}${mobile.slice(-1)}`;
  return `${mobile.slice(0, 3)}${"*".repeat(mobile.length - 7)}${mobile.slice(-4)}`;
}
function maskEmail(value) {
  const email = compact(value);
  if (!email) return "";
  const at = email.lastIndexOf("@");
  if (at <= 0 || at === email.length - 1) return maskPrincipal(email);
  const local = email.slice(0, at);
  return `${local[0]}${"*".repeat(Math.max(local.length - 1, 2))}@${email.slice(at + 1)}`;
}
function maskPrincipal(value) {
  const principal = compact(value);
  if (!principal) return "";
  if (principal.length === 1) return `${principal}*`;
  if (principal.length <= 4) {
    return `${principal[0]}${"*".repeat(Math.max(principal.length - 1, 2))}`;
  }
  return `${principal.slice(0, 2)}${"*".repeat(principal.length - 4)}${principal.slice(-2)}`;
}
function escapeSpreadsheetFormula(value) {
  if (value === void 0 || value === null) return "";
  if (typeof value === "number" || typeof value === "boolean") return value;
  const text = value instanceof Date ? value.toISOString() : String(value);
  return /^[=+\-@\t\r]/.test(text) ? `'${text}` : text;
}

// src/utils/index.ts
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
function generateId(length = 12) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}
function formatDate(date, format = "YYYY-MM-DD") {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return format.replace("YYYY", String(year)).replace("MM", month).replace("DD", day).replace("HH", hours).replace("mm", minutes).replace("ss", seconds);
}
function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}
function isEmpty(value) {
  if (value === null || value === void 0) return true;
  if (typeof value === "string" && value.trim() === "") return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (typeof value === "object" && Object.keys(value).length === 0) return true;
  return false;
}
function debounce(fn, delay) {
  let timer = null;
  return function(...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}
function throttle(fn, delay) {
  let lastTime = 0;
  return function(...args) {
    const now = Date.now();
    if (now - lastTime >= delay) {
      lastTime = now;
      fn.apply(this, args);
    }
  };
}
function removeEmpty(obj) {
  const result = {};
  for (const key of Object.keys(obj)) {
    if (!isEmpty(obj[key])) {
      result[key] = obj[key];
    }
  }
  return result;
}
function generateQueueName(namespace, queueName) {
  return `${namespace}_${queueName}`;
}
function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// src/data/areaCode.ts
var areaCode_default = {
  \u4E2D\u56FD: 86,
  American: 1,
  Hongkong: 852,
  Singapore: 65,
  UK: 44,
  Andorra: 376,
  "United Arab Emirates": 971,
  Afghanistan: 93,
  "Antigua and Barbuda": 1268,
  Anguilla: 1264,
  Albania: 355,
  Armenia: 374,
  Angola: 244,
  Argentina: 54,
  "American Samoa": 1684,
  Austria: 43,
  Australia: 61,
  Aruba: 297,
  Azerbaijan: 994,
  "Bosniaand Herzegovina": 387,
  Barbados: 1246,
  Bangladesh: 880,
  Belgium: 32,
  "Burkina Faso": 226,
  Bulgaria: 359,
  Bahrain: 973,
  Burundi: 257,
  Benin: 229,
  Bermuda: 1441,
  Brunei: 673,
  Bolivia: 591,
  "Caribisch Nederland": 599,
  Brazil: 55,
  Bahamas: 1242,
  Bhutan: 975,
  Botswana: 267,
  Belarus: 375,
  Belize: 501,
  Canada: 1,
  "Democratic Republic of theCongo": 243,
  "Central African Republic": 236,
  "Republic Of The Congo": 242,
  Switzerland: 41,
  "Ivory Coast": 225,
  "Cook Islands": 682,
  Chile: 56,
  Cameroon: 237,
  Colombia: 57,
  CostaRica: 506,
  Cuba: 53,
  "Cape Verde": 238,
  Curacao: 599,
  Cyprus: 357,
  Czech: 420,
  Germany: 49,
  Djibouti: 253,
  Denmark: 45,
  Dominica: 1767,
  "dominican republic": 1809,
  Algeria: 213,
  Ecuador: 593,
  Estonia: 372,
  Egypt: 20,
  Eritrea: 291,
  Spain: 34,
  Ethiopia: 251,
  Finland: 358,
  Fiji: 679,
  Micronesia: 691,
  "Faroe Islands": 298,
  France: 33,
  Gabon: 241,
  "United Kingdom": 44,
  Grenada: 1473,
  Georgia: 995,
  "French Guiana": 594,
  Ghana: 233,
  Gibraltar: 350,
  Greenland: 299,
  Gambia: 220,
  Guinea: 224,
  Guadeloupe: 590,
  "Equatorial Guinea": 240,
  Greece: 30,
  Guatemala: 502,
  Guam: 1671,
  "Guinea-Bissau": 245,
  Guyana: 592,
  "Hong Kong": 852,
  Honduras: 504,
  Croatia: 385,
  Haiti: 509,
  Hungary: 36,
  Indonesia: 62,
  Ireland: 353,
  Israel: 972,
  India: 91,
  Iraq: 964,
  Iran: 98,
  Iceland: 354,
  Italy: 39,
  Jamaica: 1876,
  Jordan: 962,
  Japan: 81,
  Kenya: 254,
  Kyrgyzstan: 996,
  Cambodia: 855,
  Kiribati: 686,
  Comoros: 269,
  "Saint Kitts and Nevis": 1869,
  "Korea Democratic Rep.": 850,
  "South Korea": 82,
  Kuwait: 965,
  "Cayman Islands": 1345,
  Kazakhstan: 7,
  Laos: 856,
  Lebanon: 961,
  "Saint Lucia": 1758,
  Liechtenstein: 423,
  "Sri Lanka": 94,
  Liberia: 231,
  Lesotho: 266,
  Lithuania: 370,
  Luxembourg: 352,
  Latvia: 371,
  Libya: 218,
  Morocco: 212,
  Monaco: 377,
  Moldova: 373,
  Montenegro: 382,
  Madagascar: 261,
  "Marshall Islands": 692,
  Macedonia: 389,
  Mali: 223,
  Myanmar: 95,
  Mongolia: 976,
  Macau: 853,
  Mauritania: 222,
  Montserrat: 1664,
  Malta: 356,
  Mauritius: 230,
  Maldives: 960,
  Malawi: 265,
  Mexico: 52,
  Malaysia: 60,
  Mozambique: 258,
  Namibia: 264,
  "New Caledonia": 687,
  Niger: 227,
  Nigeria: 234,
  Nicaragua: 505,
  Netherlands: 31,
  Norway: 47,
  Nepal: 977,
  Nauru: 674,
  "New Zealand": 64,
  Oman: 968,
  Panama: 507,
  Peru: 51,
  "French Polynesia": 689,
  "Papua New Guinea": 675,
  Philippines: 63,
  Pakistan: 92,
  Poland: 48,
  "Saint Pierreand Miquelon": 508,
  "Puerto Rico": 1787,
  Portugal: 351,
  Palau: 680,
  Paraguay: 595,
  Qatar: 974,
  "R\xE9union Island": 262,
  Romania: 40,
  Serbia: 381,
  Russia: 7,
  Rwanda: 250,
  "Saudi Arabia": 966,
  "Solomon Islands": 677,
  Seychelles: 248,
  Sudan: 249,
  Sweden: 46,
  Slovenia: 386,
  Slovakia: 421,
  "Sierra Leone": 232,
  "San Marino": 378,
  Senegal: 221,
  Somalia: 252,
  Suriname: 597,
  "Sao Tome and Principe": 239,
  ElSalvador: 503,
  Syria: 963,
  Swaziland: 268,
  "Turksand Caicos Islands": 1649,
  Chad: 235,
  Togo: 228,
  Thailand: 66,
  Tajikistan: 992,
  "East Timor": 670,
  Turkmenistan: 993,
  Tunisia: 216,
  Tonga: 676,
  Turkey: 90,
  "Trinidadand Tobago": 1868,
  Taiwan: 886,
  Tanzania: 255,
  Ukraine: 380,
  Uganda: 256,
  "United States": 1,
  Uruguay: 598,
  Uzbekistan: 998,
  "Saint Vincent and The Grenadines": 1784,
  Venezuela: 58,
  "VirginIslands,British": 1284,
  Vietnam: 84,
  Vanuatu: 678,
  Samoa: 685,
  Yemen: 967,
  Mayotte: 269,
  "South Africa": 27,
  Zambia: 260,
  Zimbabwe: 263
};

// src/data/provinces.ts
var provinces_default = [
  "\u5317\u4EAC\u5E02",
  "\u5929\u6D25\u5E02",
  "\u6CB3\u5317\u7701",
  "\u5C71\u897F\u7701",
  "\u5185\u8499\u53E4\u81EA\u6CBB\u533A",
  "\u8FBD\u5B81\u7701",
  "\u5409\u6797\u7701",
  "\u9ED1\u9F99\u6C5F\u7701",
  "\u4E0A\u6D77\u5E02",
  "\u6C5F\u82CF\u7701",
  "\u6D59\u6C5F\u7701",
  "\u5B89\u5FBD\u7701",
  "\u798F\u5EFA\u7701",
  "\u6C5F\u897F\u7701",
  "\u5C71\u4E1C\u7701",
  "\u6CB3\u5357\u7701",
  "\u6E56\u5317\u7701",
  "\u6E56\u5357\u7701",
  "\u5E7F\u4E1C\u7701",
  "\u5E7F\u897F\u58EE\u65CF\u81EA\u6CBB\u533A",
  "\u6D77\u5357\u7701",
  "\u91CD\u5E86\u5E02",
  "\u56DB\u5DDD\u7701",
  "\u8D35\u5DDE\u7701",
  "\u4E91\u5357\u7701",
  "\u897F\u85CF\u81EA\u6CBB\u533A",
  "\u9655\u897F\u7701",
  "\u7518\u8083\u7701",
  "\u9752\u6D77\u7701",
  "\u5B81\u590F\u56DE\u65CF\u81EA\u6CBB\u533A",
  "\u65B0\u7586\u7EF4\u543E\u5C14\u81EA\u6CBB\u533A",
  "\u53F0\u6E7E\u7701",
  "\u9999\u6E2F\u7279\u522B\u884C\u653F\u533A",
  "\u6FB3\u95E8\u7279\u522B\u884C\u653F\u533A"
];

// src/index.ts
function checkAssistantUserPermission(role, requiredPermissions) {
  if (!role) return false;
  const userPermissions = new Set(role.permissions ?? []);
  const requiredValues = Object.entries(requiredPermissions).filter(([, v]) => v).map(
    ([permission]) => AssistantUserPermissionValues[permission]
  );
  return requiredValues.every((permission) => userPermissions.has(permission));
}
var ClientValidateTools = class {
  appId;
  appSecret;
  redis;
  replayCheck;
  constructor(config) {
    this.appId = config.appId;
    this.appSecret = config.appSecret;
    this.redis = config.redis;
    this.replayCheck = config.replayCheck ?? false;
  }
  /**
   * 从请求头获取 AppId
   */
  static getAppId(header) {
    const appIdKey = "x-app-id";
    const val = header[appIdKey];
    return Array.isArray(val) ? val[0] : val;
  }
  /**
   * 获取 AppId
   */
  getAppId() {
    return this.appId;
  }
  /**
   * 验证签名
   */
  validateSignature(params) {
    const { timestamp, nonce, signature } = params;
    if (!this.appId || !this.appSecret || !timestamp || !nonce || !signature) {
      return false;
    }
    return true;
  }
  /**
   * 生成签名
   */
  generateSignature(params) {
    const { timestamp, nonce } = params;
    return `${this.appId}:${timestamp}:${nonce}`;
  }
  /**
   * 附加验证字段到请求头
   */
  attachValidateFields(headers, _body) {
    const timestamp = Date.now().toString();
    const nonce = Math.random().toString(36).substring(2, 15);
    const signature = this.generateSignature({ timestamp, nonce });
    headers["x-app-id"] = this.appId;
    headers["x-timestamp"] = timestamp;
    headers["x-nonce"] = nonce;
    headers["x-signature"] = signature;
  }
  /**
   * 验证请求
   */
  async validateRequest(headers, _body) {
    const timestamp = headers["x-timestamp"];
    const nonce = headers["x-nonce"];
    const signature = headers["x-signature"];
    if (!timestamp || !nonce || !signature) {
      return false;
    }
    if (this.replayCheck && this.redis) {
      const key = `replay:${this.appId}:${nonce}`;
      const exists = await this.redis.get(key);
      if (exists) {
        return false;
      }
      await this.redis.set(key, "1", "EX", 300);
    }
    return this.validateSignature({ timestamp, nonce, signature });
  }
  /**
   * 验证响应 (validate 是 validateRequest 的别名)
   */
  async validate(headers, body) {
    return this.validateRequest(headers, body);
  }
};
export {
  AIAssistantPurpose,
  AIMessageStatus,
  AIModelProviderTypes,
  AdminPermission,
  AdminPermissionValues,
  AdminTransactionStatusTypes,
  AdminTransactionTypes,
  areaCode_default as AreaCode,
  AssistantProfileProgramTypes,
  AssistantUserPermissionTypes,
  AssistantUserPermissionValues,
  AssistantUserStatusTypes,
  AutoPayoutStatusType,
  CONSENT_CONTENT_TYPE_HTML,
  CONSENT_RICH_TEXT_ALLOWED_ATTRIBUTES,
  CONSENT_RICH_TEXT_ALLOWED_SCHEMES,
  CONSENT_RICH_TEXT_ALLOWED_TAGS,
  ClientValidateTools,
  const_exports as CommonConst,
  Constants,
  CourseDiscussLimit,
  CourseDiscussStatusTypes,
  CourseMemberStatusTypes,
  CoursePadResourceType,
  CourseQuarterTypes,
  DEFAULT_DEPLOYMENT_BRANDING_STATE,
  DEFAULT_DEPLOYMENT_CAS_AUTH_STATE,
  DEFAULT_DEPLOYMENT_FEATURE_STATE,
  DEFAULT_DEPLOYMENT_LOGIN_AUTH_STATE,
  DEFAULT_DEPLOYMENT_NJAU_NOTIFICATION_PROVIDER_CONFIG,
  DEFAULT_DEPLOYMENT_NOTIFICATION_DELIVERY_STRATEGY,
  DEFAULT_DEPLOYMENT_NOTIFICATION_PROVIDER_ORDER,
  DEFAULT_DEPLOYMENT_OPERATIONS_STATE,
  DEFAULT_DEPLOYMENT_POLICY_STATE,
  DEFAULT_DEPLOYMENT_RECRUIT_DEFAULTS_STATE,
  DEFAULT_DEPLOYMENT_SUBJECT_ADMISSION_STATE,
  DEFAULT_DEPLOYMENT_UI_STATE,
  DEFAULT_SUBJECT_ADMISSION_CONSENT_CONTENT,
  DEFAULT_SUBJECT_ADMISSION_CONSENT_TITLE,
  DEFAULT_TIMESLOT_CHECK_IN_DURATION_SECONDS,
  DEPLOYMENT_BRANDING_FIELDS,
  DEPLOYMENT_BRANDING_REDIS_KEY,
  DEPLOYMENT_CAS_AUTH_DIAGNOSTICS_LIMIT,
  DEPLOYMENT_CAS_AUTH_DIAGNOSTICS_TTL_SECONDS,
  DEPLOYMENT_CAS_AUTH_FIELDS,
  DEPLOYMENT_CAS_AUTH_REDIS_KEY,
  DEPLOYMENT_FEATURE_DEFINITIONS,
  DEPLOYMENT_FEATURE_ENUM_VALUES,
  DEPLOYMENT_FEATURE_KEYS,
  DEPLOYMENT_FEATURE_REDIS_KEY,
  DEPLOYMENT_LOGIN_AUTH_FIELDS,
  DEPLOYMENT_LOGIN_AUTH_REDIS_KEY,
  DEPLOYMENT_NOTIFICATION_DELIVERY_STRATEGY_ENUM_VALUES,
  DEPLOYMENT_NOTIFICATION_DELIVERY_STRATEGY_TYPES,
  DEPLOYMENT_NOTIFICATION_PROVIDERS_REDIS_KEY,
  DEPLOYMENT_NOTIFICATION_PROVIDER_ENUM_VALUES,
  DEPLOYMENT_NOTIFICATION_PROVIDER_REDIS_FIELDS,
  DEPLOYMENT_NOTIFICATION_PROVIDER_TYPES,
  DEPLOYMENT_OPERATIONS_FIELDS,
  DEPLOYMENT_OPERATIONS_REDIS_KEY,
  DEPLOYMENT_POLICY_FIELDS,
  DEPLOYMENT_POLICY_REDIS_KEY,
  DEPLOYMENT_RECRUIT_DEFAULTS_REDIS_KEY,
  DEPLOYMENT_SUBJECT_ADMISSION_REDIS_KEY,
  DEPLOYMENT_UI_REDIS_KEY,
  DeploymentCasProtocolVersion,
  DeploymentFeatureKey,
  DeploymentHomePageMode,
  DeploymentNotificationDeliveryStrategy,
  DeploymentNotificationProviderType,
  entityTypes_exports as EntityTypes,
  Env,
  EnvType,
  ErrorCode,
  ExternalSurveyLinkSourceTypes,
  ExternalSurveyMemberStatusTypes,
  FEATURE_DISABLED_CODE,
  GameHistoryDisplayTypes,
  GameStatusTypes,
  HeaderFields,
  IssueCreatedFromTypes,
  IssuePayTypes,
  IssueStatusTypes,
  IssueTypes,
  JspsychMemberStatusTypes,
  LessonCheckInSource,
  ListFilterLogicTypes,
  ListSortTypes,
  MsgPushChannel,
  NjauNotificationSubchannel,
  NotificationBatchAudienceType,
  NotificationBatchRecipientStatus,
  NotificationBatchStatus,
  NotificationBatchTrigger,
  ONLINE_SETTLEMENT_DISABLED_MESSAGE,
  OfficialAccountTypes,
  OrgJoinOrderTypes,
  OrgUserPlanTypes,
  PayConfigurationItemTypes,
  PayeeTypes,
  PayerTypes,
  PayoutResolveResponseCode,
  PlatformErrorCode,
  PlatformEvents,
  ProgramProfilePlanTypes,
  provinces_default as Provinces,
  PushMessageMethodTypes,
  PushMessageTypes,
  RECOMMENDED_RECRUIT_TAGS,
  RECRUIT_DISCOVERY_STATUS,
  RECRUIT_DISCOVERY_STATUS_VALUES,
  RECRUIT_ENROLLMENT_CLOSE_OFFSET_MINUTES,
  RECRUIT_ENROLLMENT_CLOSE_OFFSET_OPTIONS,
  RECRUIT_NOTIFICATION_SCENARIOS,
  RECRUIT_REWARD_DESCRIPTION_MAX_LENGTH,
  RECRUIT_REWARD_FILTER_ENUM_VALUES,
  RECRUIT_REWARD_TYPE_ENUM_VALUES,
  RECRUIT_START_REMINDER_OFFSETS,
  RECRUIT_START_REMINDER_OFFSET_ENUM_VALUES,
  RECRUIT_START_REMINDER_OFFSET_MILLISECONDS,
  RECRUIT_SUBJECT_ADMISSION_FILTER_FIELDS,
  RECRUIT_SUBJECT_ADMISSION_RULE_TARGET_PREFIX,
  RecruitApplyFilterTypes,
  RecruitEnrollmentCloseOffsetMinutes,
  RecruitFilterConditionAimTypes,
  RecruitFilterConditionTypes,
  RecruitFilterQuestionTypes,
  RecruitFilterSpecialQuestionKeyTypes,
  RecruitFilterSupportedQuestionTypes,
  RecruitMemberApplyMessageTypes,
  RecruitMemberCheckInTypes,
  RecruitMemberStatusTypes,
  RecruitMemberUniKeyPlaceholder,
  RecruitNotificationDeliveryOutcome,
  RecruitNotificationScenario,
  RecruitRewardFilter,
  RecruitRewardType,
  RecruitStartReminderOffset,
  RecruitSubjectAdmissionFilterField,
  RecruitSubjectAdmissionFilterFieldLabels,
  RecruitSubjectAdmissionFilterQuestionKey,
  RecruitTimeslotStatusTypes,
  RecruitTimeslotTypes,
  ResponseCodeTypes,
  SSOAppTypes,
  SUBJECT_ADMISSION_COLLEGE_OPTION_MAX_COUNT,
  SUBJECT_ADMISSION_COLLEGE_OPTION_MAX_LENGTH,
  SUBJECT_ADMISSION_CONSENT_DOCUMENT_KEY,
  SUBJECT_ADMISSION_CONSENT_SCOPE,
  SUBJECT_ADMISSION_CONSENT_VERSION,
  SUBJECT_ADMISSION_EDUCATION_LEVELS,
  SUBJECT_ADMISSION_EDUCATION_LEVEL_ENUM_VALUES,
  SUBJECT_ADMISSION_GRADE_YEAR_PATTERN,
  SUBJECT_ADMISSION_REQUIRED_FIELD_LABELS,
  SmsCodeTypes,
  SmsMsgTypeMap,
  SmsMsgTypes,
  SubjectAdmissionEducationLevel,
  SubjectAdmissionEducationLevelLabels,
  SubjectAdmissionProfileCompleteness,
  SubjectAdmissionSuggestionField,
  SubjectPoolMemberSortDirection,
  SubjectPoolMemberSortField,
  SubjectPoolTypes,
  SubscribeAutoReplyContentTypes,
  SurveyAnswerStatusTypes,
  SurveyModeTypes,
  SurveyStatusTypes,
  TASK_TYPE_DEPLOYMENT_FEATURE,
  TIMESLOT_CHECK_IN_DURATION_OPTIONS,
  TIMESLOT_CHECK_IN_DURATION_SECONDS,
  TagAttachmentTypes,
  TaskAuditStatusTypes,
  TaskAutoWdthDrawTypes,
  TaskMemberFilterLogicTypes,
  TaskMemberFilterTypes,
  TaskMemberJoinChannelTypes,
  TaskMemberStatusTypes,
  TaskPushTypes,
  TaskShareQrCodeTypes,
  TaskTrashTypes,
  TaskTypeLabel,
  TaskTypes,
  TextAutoReplyContentModeTypes,
  TextAutoReplyMatchRuleTypes,
  TimeslotCheckInDurationSeconds,
  TransactionPaymentSourceTypes,
  TransactionStatusTypes,
  TransactionSubjectTypes,
  TransactionSubjectTypesToLabel,
  UserActionLogTypes,
  UserGenderTypes,
  UserGenderTypesToLabel,
  UserRecruitJoinStatus,
  UserRoleTypes,
  UserStatusTypes,
  UserTagVisibleTypes,
  UserTaskInvitationStatusTypes,
  UserTaskRelationStatusTypes,
  UserTransListTypes,
  UserWechatPayStatusTypes,
  UserWechatStatusTypes,
  WalletOwnerTypes,
  WalletTypes,
  WeappAuditStatusTypes,
  WeappDomainManageTypes,
  WechatGroupPushMsgTypes,
  WechatQRCodeSceneTypes,
  WxSubscribeTypes,
  WxTextSentTypes,
  WxTextUnReadStatusTypes,
  buildCasLoginUrl,
  buildCasMappingPreview,
  buildCasServiceUrl,
  buildCasValidateUrl,
  buildDeploymentBrandingState,
  buildDeploymentCasAuthState,
  buildDeploymentFeatureState,
  buildDeploymentLoginAuthState,
  buildDeploymentNotificationProviderStoredState,
  buildDeploymentOperationsState,
  buildDeploymentPolicyState,
  buildDeploymentRecruitDefaultsState,
  buildDeploymentSubjectAdmissionState,
  buildDeploymentUiState,
  buildShareUrl,
  buildSubjectAdmissionGradeOptions,
  buildSubjectAdmissionOnboardingState,
  calculateAgeFromBirth,
  checkAssistantUserPermission,
  debounce,
  deepClone,
  deploymentNotificationProviderStateToRedisFields,
  deploymentRecruitDefaultsStateToRedisFields,
  deploymentSubjectAdmissionStateToRedisFields,
  escapeRegex,
  escapeSpreadsheetFormula,
  findRecruitFilterSurveyQuestion,
  formatDate,
  formatRecruitNotificationProviderAttemptDetails,
  generateId,
  generateQueueName,
  getCasAttributeValue,
  getCasLoginEndpoint,
  getCasLogoutUrl,
  getCasValidateEndpoint,
  getDeploymentCasAuthDiagnosticsRedisKey,
  getDeploymentFeatureDisabledMessage,
  getMissingSubjectAdmissionFields,
  getRecruitEnrollmentDeadline,
  getRecruitFilterConditionDefaultAim,
  getRecruitSubjectAdmissionFieldFromRuleTarget,
  getRecruitSubjectAdmissionFilterField,
  getRecruitSubjectAdmissionFilterQuestionKey,
  getRecruitSubjectAdmissionRuleTarget,
  getRuntimeConfigBoolean,
  getRuntimeConfigString,
  getSubjectAdmissionContactMobile,
  getSubjectAdmissionEducationLevelLabel,
  hasBoundMobile,
  hasValidSubjectAdmissionBirthDate,
  isCompleteRecruitFilterCondition,
  isDeploymentFeatureKey,
  isDeploymentNotificationDeliveryStrategy,
  isDeploymentNotificationProviderType,
  isEmpty,
  isHtmlLikeContent,
  isHttpUrl,
  isRecruitDiscoveryStatus,
  isRecruitEnrollmentCloseOffsetMinutes,
  isRecruitEnrollmentClosed,
  isRecruitFilterConditionAimRequired,
  isRecruitRewardFilter,
  isRecruitRewardType,
  isRecruitStartReminderOffset,
  isRecruitSubjectAdmissionFilterField,
  isRecruitSubjectAdmissionFilterQuestionKey,
  isSpecialRecruitFilterQuestionKey,
  isSubjectAdmissionOnboardingEnabled,
  isSubjectAdmissionProfileComplete,
  isTaskTypeDeploymentEnabled,
  isTimeslotCheckInDurationSeconds,
  legacyPlainTextToHtml,
  loadRuntimeConfigScript,
  mapCasAttributesToProfile,
  maskCasAttributes,
  maskCasProfile,
  maskCasValue,
  maskEmail,
  maskMobile,
  maskPrincipal,
  normalizeCasCallback,
  normalizeCasProtocolVersion,
  normalizeCasProviderId,
  normalizeCasUrlPrefix,
  normalizeConsentHtmlSource,
  normalizeDeploymentFeatureKeys,
  normalizeDeploymentHomePageMode,
  normalizeDeploymentNotificationApiBaseUrl,
  normalizeDeploymentNotificationDeliveryStrategy,
  normalizeDeploymentNotificationProviderOrder,
  normalizeDeploymentSubjectAdmissionCollegeOptions,
  normalizeRecruitDiscoveryTags,
  normalizeRecruitFilterCondition,
  normalizeRecruitFilterConditions,
  normalizeRecruitNotificationProviderAttemptDetails,
  normalizeRecruitStartReminderOffsets,
  normalizeRecruitSubjectAdmissionFilterValue,
  normalizeSubjectAdmissionCategoryValue,
  normalizeSubjectAdmissionContactMobile,
  normalizeSubjectAdmissionEducationLevel,
  normalizeSubjectAdmissionGrade,
  normalizeSubjectAdmissionText,
  parseDeploymentPolicyValue,
  parseSubjectAdmissionBirthDate,
  removeEmpty,
  resolveRecruitStartReminderOffsets,
  resolveTimeslotCheckInDurationSeconds,
  sleep,
  throttle,
  toDeploymentNotificationProviderConfig,
  validateDeploymentCasAuthState,
  validateDeploymentNotificationProviderState,
  validateDeploymentOperationsState,
  validateRecruitFilterCondition
};
/**
 * @wky/common
 * 公共类型定义和工具函数
 * 
 * @description
 * 微课研平台公共模块，提供：
 * - 实体类型定义（用户、任务、交易等）
 * - GraphQL 解析器类型
 * - 错误码定义
 * - SDK 相关类型（OIDC、事件等）
 * - 常量和配置项
 * - 通用工具函数
 * - 地区数据（国际区号、中国省份）
 * 
 * @module @wky/common
 * @license MIT
 * 
 * @example
 * ```ts
 * import {
 *   EntityTypes,
 *   ResponseCodeTypes,
 *   TaskTypeLabel,
 *   sleep,
 *   generateId,
 *   AreaCode,
 * } from '@wky/common';
 * 
 * // 使用类型
 * const user: EntityTypes.User = { ... };
 * 
 * // 使用常量
 * console.log(TaskTypeLabel[task.type]);
 * 
 * // 使用工具函数
 * await sleep(1000);
 * const id = generateId();
 * 
 * // 使用地区数据
 * console.log(AreaCode['中国']); // 86
 * ```
 */
//# sourceMappingURL=index.js.map